// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-unused-vars, prettier/prettier */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AccountNumber: { input: any; output: any; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  CountryCode: { input: any; output: any; }
  Cuid: { input: any; output: any; }
  Currency: { input: any; output: any; }
  DID: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  DateTimeISO: { input: any; output: any; }
  DeweyDecimal: { input: any; output: any; }
  Duration: { input: any; output: any; }
  EmailAddress: { input: string; output: string; }
  GUID: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IP: { input: any; output: any; }
  IPCPatent: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  ISO8601Duration: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  JWT: { input: any; output: any; }
  LCCSubclass: { input: any; output: any; }
  Latitude: { input: number; output: number; }
  LocalDate: { input: any; output: any; }
  LocalDateTime: { input: any; output: any; }
  LocalEndTime: { input: any; output: any; }
  LocalTime: { input: any; output: any; }
  Locale: { input: any; output: any; }
  Long: { input: any; output: any; }
  Longitude: { input: number; output: number; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: number; output: number; }
  NegativeInt: { input: number; output: number; }
  NonEmptyString: { input: string; output: string; }
  NonNegativeFloat: { input: number; output: number; }
  NonNegativeInt: { input: number; output: number; }
  NonPositiveFloat: { input: number; output: number; }
  NonPositiveInt: { input: number; output: number; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: string; output: string; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: number; output: number; }
  PositiveInt: { input: number; output: number; }
  PostalCode: { input: string; output: string; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  RoutingNumber: { input: any; output: any; }
  SESSN: { input: any; output: any; }
  SafeInt: { input: any; output: any; }
  SemVer: { input: any; output: any; }
  Time: { input: any; output: any; }
  TimeZone: { input: string; output: string; }
  Timestamp: { input: number; output: number; }
  URL: { input: string; output: string; }
  USCurrency: { input: any; output: any; }
  UUID: { input: any; output: any; }
  UnsignedFloat: { input: number; output: number; }
  UnsignedInt: { input: number; output: number; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AcceptAwardedItemInput = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
  note: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  preferred_dates: Array<Scalars['Timestamp']['input']>;
};

export type AcceptPaymentRequestInput = {
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  tips?: InputMaybe<PaymentItemRequestInput>;
};

export type AcceptedBidInput = {
  auction_request_id: Scalars['ID']['input'];
  quantity: Scalars['NonNegativeInt']['input'];
};

export type AccountOnboardLinkInput = {
  refreshUrl: Scalars['String']['input'];
  returnUrl: Scalars['String']['input'];
};

export enum ActivityLogAction {
  AcceptBooking = 'ACCEPT_BOOKING',
  ArchiveBooking = 'ARCHIVE_BOOKING',
  CancelBooking = 'CANCEL_BOOKING',
  CreateBookingAsOutfitter = 'CREATE_BOOKING_AS_OUTFITTER',
  DeclineBooking = 'DECLINE_BOOKING',
  UpdateBooking = 'UPDATE_BOOKING',
  UpdateBookingDatesGuestsAndAddons = 'UPDATE_BOOKING_DATES_GUESTS_AND_ADDONS'
}

export enum ActivityMutationType {
  Archive = 'ARCHIVE',
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/** A type that describes an add-on */
export type AddOn = {
  __typename?: 'AddOn';
  applied_tax_definition_ids?: Maybe<Array<Scalars['ID']['output']>>;
  apply_to_all_listings?: Maybe<Scalars['Boolean']['output']>;
  category: Scalars['String']['output'];
  category_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  created_for_entity_id?: Maybe<Scalars['ID']['output']>;
  created_for_entity_type?: Maybe<EntityType>;
  currency?: Maybe<Scalars['String']['output']>;
  deposit_amount?: Maybe<Scalars['Float']['output']>;
  deposit_percentage?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  is_enabled: Scalars['Boolean']['output'];
  is_hidden_from_outfitters?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_sportsmen?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  listings: Array<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  offer_period: AddOnOfferPeriod;
  /** Unused field. Built for potential cases with size variations for trophies. For now new add-ons will be created for each size variation. */
  options?: Maybe<Array<AddOnOption>>;
  order?: Maybe<Scalars['Int']['output']>;
  outfitter: Outfitter;
  price_by_day?: Maybe<PriceByDay>;
  price_by_guest?: Maybe<PriceByGuest>;
  species?: Maybe<Species>;
  /** Unused field. Built for future references to Stripe products. */
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  sub_label?: Maybe<Scalars['String']['output']>;
  unit_price: Scalars['Float']['output'];
  unit_price_label?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum AddOnCategory {
  GunRental = 'GUN_RENTAL',
  MealUpgrade = 'MEAL_UPGRADE',
  Other = 'OTHER',
  Trophy = 'TROPHY'
}

export enum AddOnOfferPeriod {
  After = 'AFTER',
  Before = 'BEFORE',
  During = 'DURING'
}

export type AddOnOption = {
  __typename?: 'AddOnOption';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  deposit_amount?: Maybe<Scalars['Float']['output']>;
  deposit_percentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  unit_price: Scalars['Float']['output'];
  updated_at?: Maybe<Scalars['Timestamp']['output']>;
};

export type AddPackageToQuoteInput = {
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  number_of_guests: Scalars['PositiveInt']['input'];
  pricing_package_id: Scalars['ID']['input'];
};

export type AdditionalBookingPaymentSummaryInput = {
  amount: Scalars['Float']['input'];
  external_payment_type?: InputMaybe<ExternalPaymentType>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
};

export type AdditionalPaymentSummary = {
  __typename?: 'AdditionalPaymentSummary';
  line_items: Array<LineItem>;
  prices: Array<QuotePrice>;
  total: Scalars['Int']['output'];
};

export type AdditionalPaymentSummaryInput = {
  add_ons?: InputMaybe<Array<PaymentRequestAddOnInput>>;
  items?: InputMaybe<Array<PaymentItemRequestInput>>;
  should_include_taxes?: InputMaybe<Scalars['Boolean']['input']>;
};

/** A type that describes an address */
export type Address = {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  country: Scalars['String']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  street_a?: Maybe<Scalars['String']['output']>;
  street_b?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country: Scalars['String']['input'];
  lat?: InputMaybe<Scalars['Float']['input']>;
  lng?: InputMaybe<Scalars['Float']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  street_a?: InputMaybe<Scalars['String']['input']>;
  street_b?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export enum AiAgent {
  Availability = 'AVAILABILITY',
  ListingDescription = 'LISTING_DESCRIPTION',
  OutfitterAbout = 'OUTFITTER_ABOUT',
  OutfitterAssistant = 'OUTFITTER_ASSISTANT'
}

export enum AiAssistantClientSurface {
  Dashboard = 'DASHBOARD',
  Mobile = 'MOBILE'
}

export enum AiAssistantInteractionKind {
  Confirmation = 'CONFIRMATION',
  MultiSelection = 'MULTI_SELECTION',
  PlanProgress = 'PLAN_PROGRESS',
  Selection = 'SELECTION'
}

export enum AiAssistantOutputStatus {
  Answered = 'ANSWERED',
  Dismissed = 'DISMISSED',
  Error = 'ERROR',
  NeedsClientExecution = 'NEEDS_CLIENT_EXECUTION',
  NeedsConfirmation = 'NEEDS_CONFIRMATION',
  NeedsUserInput = 'NEEDS_USER_INPUT',
  Success = 'SUCCESS'
}

export enum AiAssistantOutputType {
  Action = 'ACTION',
  BrowsePage = 'BROWSE_PAGE',
  Chart = 'CHART',
  EmailTemplateEdit = 'EMAIL_TEMPLATE_EDIT',
  ImageSearch = 'IMAGE_SEARCH',
  MessageTemplateCreate = 'MESSAGE_TEMPLATE_CREATE',
  Navigation = 'NAVIGATION',
  OutfitterFormPrepare = 'OUTFITTER_FORM_PREPARE',
  PlanProgress = 'PLAN_PROGRESS',
  Search = 'SEARCH',
  Suggestion = 'SUGGESTION',
  UserSelection = 'USER_SELECTION'
}

export enum AiContextPurpose {
  WebsiteBuilder = 'WEBSITE_BUILDER'
}

export type AiConversation = {
  __typename?: 'AiConversation';
  ai_agent: AiAgent;
  booking_id?: Maybe<Scalars['ID']['output']>;
  context: Scalars['JSONObject']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  last_message_at?: Maybe<Scalars['Timestamp']['output']>;
  last_message_preview?: Maybe<Scalars['String']['output']>;
  listing_id?: Maybe<Scalars['ID']['output']>;
  memory_ids: Array<Scalars['ID']['output']>;
  message_count: Scalars['NonNegativeInt']['output'];
  metadata: Scalars['JSONObject']['output'];
  outfitter_id?: Maybe<Scalars['ID']['output']>;
  status: AiConversationStatus;
  title?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user_id: Scalars['ID']['output'];
};

export type AiConversationFilePart = AiConversationMessagePart & {
  __typename?: 'AiConversationFilePart';
  filename?: Maybe<Scalars['String']['output']>;
  media_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AiConversationMessage = {
  __typename?: 'AiConversationMessage';
  conversation_id: Scalars['ID']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  memory_ids: Array<Scalars['ID']['output']>;
  metadata: Scalars['JSONObject']['output'];
  parts: Array<AiConversationMessagePart>;
  role: AiConversationMessageRole;
  source_message_id?: Maybe<Scalars['ID']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type AiConversationMessagePart = {
  type: Scalars['String']['output'];
};

export enum AiConversationMessageRole {
  Assistant = 'ASSISTANT',
  System = 'SYSTEM',
  Tool = 'TOOL',
  User = 'USER'
}

export type AiConversationMessagesResult = {
  __typename?: 'AiConversationMessagesResult';
  count: Scalars['Int']['output'];
  data: Array<AiConversationMessage>;
  pages: Scalars['Int']['output'];
};

export enum AiConversationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type AiConversationTextPart = AiConversationMessagePart & {
  __typename?: 'AiConversationTextPart';
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type AiConversationUnknownPart = AiConversationMessagePart & {
  __typename?: 'AiConversationUnknownPart';
  data: Scalars['JSONObject']['output'];
  type: Scalars['String']['output'];
};

export type AiConversationsInput = {
  ai_agent?: InputMaybe<AiAgent>;
  outfitter_id?: InputMaybe<Scalars['ID']['input']>;
};

export type AiConversationsResult = {
  __typename?: 'AiConversationsResult';
  count: Scalars['Int']['output'];
  data: Array<AiConversation>;
  pages: Scalars['Int']['output'];
};

export type AiOnboarding = {
  __typename?: 'AiOnboarding';
  available_entity_creation_scopes: Array<AiOnboardingEntityCreationScope>;
  completed_entity_creation_steps: Array<AiOnboardingEntityCreationStep>;
  created_at: Scalars['Timestamp']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  outfitter_id: Scalars['ID']['output'];
  source_documents: Array<AiOnboardingSourceDocument>;
  source_type: AiOnboardingSourceType;
  status: AiOnboardingStatus;
  summary_items: Array<AiOnboardingSummaryItem>;
  updated_at: Scalars['Timestamp']['output'];
  website_url?: Maybe<Scalars['String']['output']>;
};

export enum AiOnboardingEntityCreationScope {
  All = 'ALL',
  Listings = 'LISTINGS',
  Outfitter = 'OUTFITTER'
}

export enum AiOnboardingEntityCreationStep {
  AddOns = 'ADD_ONS',
  AddOnImages = 'ADD_ON_IMAGES',
  Listings = 'LISTINGS',
  ListingImages = 'LISTING_IMAGES',
  ListingToLodgingRelationships = 'LISTING_TO_LODGING_RELATIONSHIPS',
  Lodgings = 'LODGINGS',
  LodgingImages = 'LODGING_IMAGES',
  OtherImages = 'OTHER_IMAGES',
  Outfitter = 'OUTFITTER',
  OutfitterImages = 'OUTFITTER_IMAGES',
  PricingPackages = 'PRICING_PACKAGES'
}

export type AiOnboardingSourceDocument = {
  __typename?: 'AiOnboardingSourceDocument';
  source_file_url?: Maybe<Scalars['String']['output']>;
  source_private_file_id?: Maybe<Scalars['ID']['output']>;
};

export type AiOnboardingSourceDocumentInput = {
  sourceFileUrl?: InputMaybe<Scalars['String']['input']>;
  sourcePrivateFileId?: InputMaybe<Scalars['ID']['input']>;
};

export enum AiOnboardingSourceType {
  Document = 'DOCUMENT',
  Website = 'WEBSITE'
}

export enum AiOnboardingStatus {
  CrawlingWebsite = 'CRAWLING_WEBSITE',
  CreatingEntities = 'CREATING_ENTITIES',
  ExtractingData = 'EXTRACTING_DATA',
  Failed = 'FAILED',
  Pending = 'PENDING',
  ProcessingDocuments = 'PROCESSING_DOCUMENTS',
  Success = 'SUCCESS',
  UploadingImages = 'UPLOADING_IMAGES'
}

export type AiOnboardingSummaryItem = {
  __typename?: 'AiOnboardingSummaryItem';
  description?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum AiToolName {
  BrowsePage = 'BROWSE_PAGE',
  ConfirmedAction = 'CONFIRMED_ACTION',
  CreateMessageTemplate = 'CREATE_MESSAGE_TEMPLATE',
  EditEmailTemplate = 'EDIT_EMAIL_TEMPLATE',
  GetAvailability = 'GET_AVAILABILITY',
  NavigateToPage = 'NAVIGATE_TO_PAGE',
  OutfitterImageSearch = 'OUTFITTER_IMAGE_SEARCH',
  OutfitterSearch = 'OUTFITTER_SEARCH',
  PrepareOutfitterForm = 'PREPARE_OUTFITTER_FORM',
  PresentChart = 'PRESENT_CHART',
  PresentPlan = 'PRESENT_PLAN',
  RequestSelection = 'REQUEST_SELECTION',
  SuggestAvailabilityChanges = 'SUGGEST_AVAILABILITY_CHANGES',
  SuggestHtml = 'SUGGEST_HTML'
}

/** Alert item */
export type Alert = {
  __typename?: 'Alert';
  action_label?: Maybe<Scalars['String']['output']>;
  action_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  severity: AlertSeverity;
  title: Scalars['String']['output'];
};

export enum AlertSeverity {
  Error = 'ERROR',
  Info = 'INFO',
  Neutral = 'NEUTRAL',
  Warning = 'WARNING'
}

/** Needs attention alerts section */
export type AlertsSection = BaseDashboardSection & {
  __typename?: 'AlertsSection';
  alerts: Array<Alert>;
  id: Scalars['String']['output'];
  order: Scalars['PositiveInt']['output'];
  title: Scalars['String']['output'];
};

export type AlgoliaOutfitterClient = {
  __typename?: 'AlgoliaOutfitterClient';
  date_added?: Maybe<Scalars['Timestamp']['output']>;
  gross_revenue?: Maybe<Scalars['PositiveInt']['output']>;
  last_booking_date?: Maybe<Scalars['Timestamp']['output']>;
  notes: Array<Note>;
  number_of_prior_bookings?: Maybe<Scalars['PositiveInt']['output']>;
  objectID: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  resolved_user: OutfitterClientUser;
};

/** A type that describes an amenity */
export type Amenity = {
  __typename?: 'Amenity';
  category: AmenityCategory;
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  icon_url?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export enum AmenityCategory {
  Basic = 'BASIC',
  Features = 'FEATURES',
  Include = 'INCLUDE'
}

export type AppPrompt = {
  __typename?: 'AppPrompt';
  cta?: Maybe<AppPromptCta>;
  dismiss_for_seconds?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<AppPromptImages>;
  message: Scalars['String']['output'];
  severity: AppPromptSeverity;
  title: Scalars['String']['output'];
  type: AppPromptType;
};

export type AppPromptCta = {
  __typename?: 'AppPromptCta';
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type AppPromptImages = {
  __typename?: 'AppPromptImages';
  dark: Scalars['String']['output'];
  light: Scalars['String']['output'];
};

export enum AppPromptSeverity {
  Blocking = 'BLOCKING',
  Info = 'INFO',
  Warning = 'WARNING'
}

export enum AppPromptType {
  ReleaseNotes = 'RELEASE_NOTES',
  SubscriptionPastDue = 'SUBSCRIPTION_PAST_DUE',
  UpdateRequired = 'UPDATE_REQUIRED',
  UpdateSuggested = 'UPDATE_SUGGESTED'
}

export type ArchiveLeadsResult = {
  __typename?: 'ArchiveLeadsResult';
  archived_leads: Array<Lead>;
};

export type AssignGuidesToBookingInput = {
  guide_ids: Array<Scalars['ID']['input']>;
  should_update_availability: Scalars['Boolean']['input'];
};

export type AssignLodgingsToBookingInput = {
  lodging_ids: Array<Scalars['ID']['input']>;
  should_update_availability: Scalars['Boolean']['input'];
};

export type AssignResourcesToBookingInput = {
  resource_ids: Array<Scalars['ID']['input']>;
  should_update_availability: Scalars['Boolean']['input'];
};

export type Attribution = {
  __typename?: 'Attribution';
  deal_attribution?: Maybe<Scalars['String']['output']>;
  internal_source?: Maybe<BookingInternalSource>;
  internal_source_entity_id?: Maybe<Scalars['ID']['output']>;
  internal_source_entity_type?: Maybe<BookingInternalSourceEntityType>;
  utm_campaign?: Maybe<Scalars['String']['output']>;
  utm_content?: Maybe<Scalars['String']['output']>;
  utm_medium?: Maybe<Scalars['String']['output']>;
  utm_source?: Maybe<Scalars['String']['output']>;
  utm_term?: Maybe<Scalars['String']['output']>;
};

export type AttributionInput = {
  client_name?: InputMaybe<Scalars['String']['input']>;
  client_version?: InputMaybe<Scalars['String']['input']>;
  deal_attribution?: InputMaybe<Scalars['String']['input']>;
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  utm_campaign?: InputMaybe<Scalars['String']['input']>;
  utm_content?: InputMaybe<Scalars['String']['input']>;
  utm_medium?: InputMaybe<Scalars['String']['input']>;
  utm_source?: InputMaybe<Scalars['String']['input']>;
  utm_term?: InputMaybe<Scalars['String']['input']>;
};

export enum AtvCategory {
  SideBySide = 'SIDE_BY_SIDE',
  Sport = 'SPORT',
  Utility = 'UTILITY',
  Youth = 'YOUTH'
}

export type AtvInput = {
  category: AtvCategory;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
};

export type AtvProps = {
  __typename?: 'AtvProps';
  category: AtvCategory;
  manufacturer?: Maybe<Scalars['String']['output']>;
};

export type Auction = {
  __typename?: 'Auction';
  counts: AuctionCounts;
  created_at: Scalars['Timestamp']['output'];
  ends_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  number_of_days?: Maybe<Scalars['NonNegativeInt']['output']>;
  number_of_guests?: Maybe<Scalars['NonNegativeInt']['output']>;
  organizer: EventOrganizer;
  quantity_requested: Scalars['NonNegativeInt']['output'];
  search_term: Scalars['String']['output'];
  status: AuctionStatus;
  type: AuctionType;
  updated_at: Scalars['Timestamp']['output'];
};

export type AuctionCounts = {
  __typename?: 'AuctionCounts';
  bids: Scalars['NonNegativeInt']['output'];
  requests: Scalars['NonNegativeInt']['output'];
};

export type AuctionFiltersInput = {
  organizerId: Scalars['ID']['input'];
  status?: InputMaybe<AuctionStatus>;
  type?: InputMaybe<AuctionType>;
};

export type AuctionRequest = {
  __typename?: 'AuctionRequest';
  auction: Auction;
  bid?: Maybe<AuctionRequestBid>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  organizer: EventOrganizer;
  quantity_accepted: Scalars['NonNegativeInt']['output'];
  quantity_remaining: Scalars['NonNegativeInt']['output'];
  recipient: AuctionRequestRecipient;
  recipient_id: Scalars['ID']['output'];
  recipient_type: EntityType;
  status: AuctionRequestStatus;
  updated_at: Scalars['Timestamp']['output'];
};

export type AuctionRequestBid = {
  __typename?: 'AuctionRequestBid';
  note: Scalars['String']['output'];
  price: Scalars['NonNegativeInt']['output'];
  pricing_entity_id: Scalars['ID']['output'];
  pricing_entity_type: EntityType;
  product_name: Scalars['String']['output'];
  quantity: Scalars['NonNegativeInt']['output'];
};

export type AuctionRequestFiltersInput = {
  auctionId?: InputMaybe<Scalars['ID']['input']>;
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  recipientType?: InputMaybe<EntityType>;
  status?: InputMaybe<AuctionRequestStatus>;
};

export type AuctionRequestRecipient = {
  __typename?: 'AuctionRequestRecipient';
  avatar?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export enum AuctionRequestStatus {
  BidAccepted = 'BID_ACCEPTED',
  BidSubmitted = 'BID_SUBMITTED',
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Open = 'OPEN'
}

export type AuctionRequestsResults = {
  __typename?: 'AuctionRequestsResults';
  count: Scalars['Int']['output'];
  data: Array<AuctionRequest>;
  pages: Scalars['Int']['output'];
};

export enum AuctionStatus {
  Ended = 'ENDED',
  Open = 'OPEN'
}

export enum AuctionType {
  Booking = 'BOOKING'
}

export type AuctionsResults = {
  __typename?: 'AuctionsResults';
  count: Scalars['Int']['output'];
  data: Array<Auction>;
  pages: Scalars['Int']['output'];
};

export type AuditLog = {
  __typename?: 'AuditLog';
  actor_email?: Maybe<Scalars['String']['output']>;
  actor_name?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  document_hash?: Maybe<Scalars['String']['output']>;
  entity_id: Scalars['String']['output'];
  entity_type: Scalars['String']['output'];
  event_type: AuditLogEventType;
  id: Scalars['ID']['output'];
  ip_address?: Maybe<Scalars['String']['output']>;
  user_agent?: Maybe<Scalars['String']['output']>;
};

export enum AuditLogEntityType {
  FormSubmission = 'FORM_SUBMISSION'
}

export enum AuditLogEventType {
  FormConsented = 'FORM_CONSENTED',
  FormDownloaded = 'FORM_DOWNLOADED',
  FormSignedAndFinalized = 'FORM_SIGNED_AND_FINALIZED'
}

export type AuthorizedRepresentativeInput = {
  business_title: Scalars['String']['input'];
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  job_position: JobPosition;
  last_name: Scalars['String']['input'];
  phone_number: Scalars['PhoneNumber']['input'];
};

export type AutomationAction = {
  __typename?: 'AutomationAction';
  templates?: Maybe<Array<AutomationTemplate>>;
  type: AutomationActionType;
};

export enum AutomationActionType {
  Communication = 'COMMUNICATION'
}

export enum AutomationGroup {
  Booking = 'BOOKING',
  LeadManagement = 'LEAD_MANAGEMENT',
  Notifications = 'NOTIFICATIONS',
  PostTrip = 'POST_TRIP',
  QuotesAndInvites = 'QUOTES_AND_INVITES'
}

export type AutomationRunError = {
  __typename?: 'AutomationRunError';
  code?: Maybe<Scalars['String']['output']>;
  date: Scalars['Float']['output'];
  message: Scalars['String']['output'];
};

export enum AutomationRunStatus {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Success = 'SUCCESS'
}

export type AutomationStep = {
  __typename?: 'AutomationStep';
  action: AutomationAction;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type AutomationTemplate = {
  __typename?: 'AutomationTemplate';
  channel: MessageTemplateChannel;
  is_active: Scalars['Boolean']['output'];
  /** Whether the channel is configured and ready to send. For EMAIL, always true. For SMS, checks Twilio transactional setup. */
  is_configured: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  template_id: Scalars['String']['output'];
  template_key: MessageTemplateKey;
};

export type AutomationTemplateUpdateInput = {
  channel: MessageTemplateChannel;
  is_active: Scalars['Boolean']['input'];
  template_key: MessageTemplateKey;
};

export type AutomationTrigger = {
  __typename?: 'AutomationTrigger';
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum AutomationTriggerType {
  Cron = 'CRON',
  Event = 'EVENT'
}

export enum AutomationType {
  BookingApprovedSportsman = 'BOOKING_APPROVED_SPORTSMAN',
  BookingCanceledSportsman = 'BOOKING_CANCELED_SPORTSMAN',
  BookingInviteInvoiceSportsman = 'BOOKING_INVITE_INVOICE_SPORTSMAN',
  BookingInviteSportsman = 'BOOKING_INVITE_SPORTSMAN',
  BookingReceiptSportsman = 'BOOKING_RECEIPT_SPORTSMAN',
  BookingRequestedSportsman = 'BOOKING_REQUESTED_SPORTSMAN',
  BookingUpdatedSportsman = 'BOOKING_UPDATED_SPORTSMAN',
  FormSubmissionCompleted = 'FORM_SUBMISSION_COMPLETED',
  GearList = 'GEAR_LIST',
  LeadCoolingAlert = 'LEAD_COOLING_ALERT',
  PreTripReminder = 'PRE_TRIP_REMINDER',
  QuoteReminder = 'QUOTE_REMINDER',
  ReviewRequest = 'REVIEW_REQUEST',
  TripDetailReminder = 'TRIP_DETAIL_REMINDER'
}

/** A type that describes an available date with slots amount */
export type Availability = {
  __typename?: 'Availability';
  available_slots: Scalars['NonNegativeInt']['output'];
  booked_slots: Scalars['NonNegativeInt']['output'];
  date: Scalars['Timestamp']['output'];
  total_slots: Scalars['NonNegativeInt']['output'];
};

export type AvailabilityInfo = {
  __typename?: 'AvailabilityInfo';
  available_slots: Scalars['NonNegativeInt']['output'];
  booked_slots: Scalars['NonNegativeInt']['output'];
  threshold: AvailabilityThreshold;
  total_slots: Scalars['NonNegativeInt']['output'];
};

export type AvailabilityInput = {
  booked_slots: Scalars['NonNegativeInt']['input'];
  date: Scalars['Timestamp']['input'];
  total_slots: Scalars['NonNegativeInt']['input'];
};

export type AvailabilityRangeInput = {
  end_date: Scalars['Timestamp']['input'];
  is_available: Scalars['Boolean']['input'];
  start_date: Scalars['Timestamp']['input'];
  total_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export enum AvailabilityThreshold {
  High = 'HIGH',
  Low = 'LOW',
  None = 'NONE'
}

export type AvailabilityTimeWindow = {
  __typename?: 'AvailabilityTimeWindow';
  available_slots: Scalars['NonNegativeInt']['output'];
  booked_slots: Scalars['NonNegativeInt']['output'];
  end_time: Scalars['NonNegativeInt']['output'];
  is_available: Scalars['Boolean']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  single_use_ref_id?: Maybe<Scalars['ID']['output']>;
  single_use_ref_type?: Maybe<EntityType>;
  start_time: Scalars['NonNegativeInt']['output'];
  total_slots: Scalars['NonNegativeInt']['output'];
};

export type AvailabilityTimeWindowInput = {
  end_time: Scalars['NonNegativeInt']['input'];
  is_available: Scalars['Boolean']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
  total_slots: Scalars['NonNegativeInt']['input'];
};

export type AvailabilityTimeWindowStartAndEndTime = {
  end_time: Scalars['NonNegativeInt']['input'];
  start_time: Scalars['NonNegativeInt']['input'];
};

export type AvailabilityUpdateInput = {
  booked_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  end_date: Scalars['Timestamp']['input'];
  is_available?: InputMaybe<Scalars['Boolean']['input']>;
  resource_id: Scalars['ID']['input'];
  resource_type: Scalars['String']['input'];
  should_clear_time_windows?: InputMaybe<Scalars['Boolean']['input']>;
  start_date: Scalars['Timestamp']['input'];
  time_windows?: InputMaybe<Array<AvailabilityTimeWindowInput>>;
  total_slots?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type AvailableDatesForCalendarEventResourcesInput = {
  calendar_event_id: Scalars['ID']['input'];
  end_date: Scalars['Timestamp']['input'];
  number_of_guests: Scalars['NonNegativeInt']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export type AvailableDatesForCheckoutCalendarInput = {
  end_date: Scalars['Timestamp']['input'];
  listing_id: Scalars['ID']['input'];
  number_of_guests: Scalars['NonNegativeInt']['input'];
  pricing_package_id?: InputMaybe<Scalars['ID']['input']>;
  start_date: Scalars['Timestamp']['input'];
};

export type AvailableDatesForEditBookingInput = {
  booking_id: Scalars['ID']['input'];
  end_date: Scalars['Timestamp']['input'];
  number_of_guests?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  start_date: Scalars['Timestamp']['input'];
};

export type AwardedItem = {
  __typename?: 'AwardedItem';
  auction: Auction;
  auction_request: AuctionRequest;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  organizer: EventOrganizer;
  redeemed_entity_id?: Maybe<Scalars['ID']['output']>;
  status: AwardedItemStatus;
  type: AwardedItemType;
  updated_at: Scalars['Timestamp']['output'];
  was_winner_notified: Scalars['Boolean']['output'];
  winner?: Maybe<AwardedItemWinner>;
  winner_email?: Maybe<Scalars['String']['output']>;
};

export enum AwardedItemStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING',
  WinnerChosen = 'WINNER_CHOSEN',
  WinnerDidAccept = 'WINNER_DID_ACCEPT'
}

export enum AwardedItemType {
  Booking = 'BOOKING'
}

export type AwardedItemWinner = {
  __typename?: 'AwardedItemWinner';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  preferred_dates: Array<Scalars['Timestamp']['output']>;
};

export type AwardedItemsFiltersInput = {
  organizerId?: InputMaybe<Scalars['ID']['input']>;
  recipientId?: InputMaybe<Scalars['ID']['input']>;
  recipientType?: InputMaybe<EntityType>;
  status?: InputMaybe<AwardedItemStatus>;
};

export type AwardedItemsResults = {
  __typename?: 'AwardedItemsResults';
  count: Scalars['Int']['output'];
  data: Array<AwardedItem>;
  pages: Scalars['Int']['output'];
};

export type Badge = {
  __typename?: 'Badge';
  created_at: Scalars['Timestamp']['output'];
  icon_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type BadgeInput = {
  icon_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type Banner = {
  __typename?: 'Banner';
  content_default: BannerContent;
  content_mobile?: Maybe<BannerContent>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_admin: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  order: Scalars['PositiveInt']['output'];
  outfitter_id?: Maybe<Scalars['ID']['output']>;
  page_keys?: Maybe<Array<BannerPageKey>>;
  type: BannerType;
  updated_at: Scalars['Timestamp']['output'];
};

export type BannerContent = {
  __typename?: 'BannerContent';
  body?: Maybe<Scalars['String']['output']>;
  color_mode?: Maybe<ColorMode>;
  ctas: Array<CallToAction>;
  image?: Maybe<Media>;
  title_lines: Array<Scalars['String']['output']>;
};

export type BannerContentInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  color_mode?: InputMaybe<ColorMode>;
  ctas: Array<CallToActionInput>;
  image?: InputMaybe<MediaInput>;
  title_lines: Array<Scalars['String']['input']>;
};

export enum BannerPageKey {
  DashboardHomepage = 'DashboardHomepage',
  WebsiteHomepage = 'WebsiteHomepage'
}

/** Banner section containing multiple banners */
export type BannerSection = BaseDashboardSection & {
  __typename?: 'BannerSection';
  banners: Array<Banner>;
  id: Scalars['String']['output'];
  order: Scalars['PositiveInt']['output'];
  title: Scalars['String']['output'];
};

export enum BannerType {
  HighPriorityOutfitter = 'HIGH_PRIORITY_OUTFITTER',
  Info = 'INFO'
}

/** Base interface for all dashboard sections */
export type BaseDashboardSection = {
  /** Unique identifier for the section */
  id: Scalars['String']['output'];
  /** Order/position of the section */
  order: Scalars['PositiveInt']['output'];
  /** Section title */
  title: Scalars['String']['output'];
};

export type BaseEvent = {
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type BidOnAuctionInput = {
  note: Scalars['String']['input'];
  price: Scalars['NonNegativeInt']['input'];
  pricing_entity_id: Scalars['ID']['input'];
  pricing_entity_type: EntityType;
  quantity: Scalars['NonNegativeInt']['input'];
};

export enum BlindCategory {
  Box = 'BOX',
  Layout = 'LAYOUT',
  PopUp = 'POP_UP'
}

export type BlindInput = {
  category: BlindCategory;
};

export type BlindProps = {
  __typename?: 'BlindProps';
  category: BlindCategory;
};

export enum BoatCategory {
  DriftBoat = 'DRIFT_BOAT',
  ManPoweredBoat = 'MAN_POWERED_BOAT',
  MotorBoat = 'MOTOR_BOAT',
  SailBoat = 'SAIL_BOAT'
}

export type BoatInput = {
  boat_manufacturer?: InputMaybe<Scalars['String']['input']>;
  boat_type?: InputMaybe<Scalars['String']['input']>;
  category: BoatCategory;
  length?: InputMaybe<Scalars['Int']['input']>;
};

export type BoatProps = {
  __typename?: 'BoatProps';
  boat_manufacturer?: Maybe<Scalars['String']['output']>;
  boat_type?: Maybe<Scalars['String']['output']>;
  category: BoatCategory;
  length?: Maybe<Scalars['Int']['output']>;
};

/** A type that describes a booking */
export type Booking = {
  __typename?: 'Booking';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  allows_editing?: Maybe<Scalars['Boolean']['output']>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  can_be_reviewed?: Maybe<Scalars['Boolean']['output']>;
  can_request_additional_payments: Scalars['Boolean']['output'];
  cancellation_reason?: Maybe<BookingCancellationReason>;
  check_in_time: Scalars['Timestamp']['output'];
  check_out_time: Scalars['Timestamp']['output'];
  client?: Maybe<OutfitterBookingClient>;
  color?: Maybe<Scalars['String']['output']>;
  coupon?: Maybe<Coupon>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  denial_reasons?: Maybe<Array<DenialReason>>;
  deposit_amount?: Maybe<Scalars['NonNegativeInt']['output']>;
  deposit_date?: Maybe<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  edits_history?: Maybe<Array<EditLogEntry>>;
  end_date: Scalars['Timestamp']['output'];
  event_groups?: Maybe<Array<EventGroup>>;
  forms_with_submissions?: Maybe<Array<FormWithSubmissions>>;
  group_pay_share?: Maybe<GroupPayShare>;
  guides: Array<TeamMember>;
  has_additional_booking_payments?: Maybe<Scalars['Boolean']['output']>;
  has_lodging: Scalars['Boolean']['output'];
  has_remaining_payments?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['String']['output']>;
  is_archived: Scalars['Boolean']['output'];
  is_custom_price?: Maybe<Scalars['Boolean']['output']>;
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  is_from_auction: Scalars['Boolean']['output'];
  is_offsite?: Maybe<Scalars['Boolean']['output']>;
  is_returning_customer?: Maybe<Scalars['Boolean']['output']>;
  is_unread: Scalars['Boolean']['output'];
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  listing: Listing;
  listing_id: Scalars['ID']['output'];
  message_to_outfitter?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outfitter: Outfitter;
  packages: Array<QuotePackage>;
  paymentRequests: Array<PaymentRequest>;
  payment_plan_type?: Maybe<PaymentPlanType>;
  payment_summary: BookingPaymentSummary;
  payments: Array<Payment>;
  pending_async_tasks?: Maybe<Array<Maybe<PendingAsyncTask>>>;
  /** @deprecated Use packages instead */
  pricing_package?: Maybe<PricingPackage>;
  quote?: Maybe<Quote>;
  rates?: Maybe<Rates>;
  resources: Array<BookingResourceTypeAndId>;
  review_form_url?: Maybe<Scalars['String']['output']>;
  service_fee: Scalars['Float']['output'];
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  start_date: Scalars['Timestamp']['output'];
  start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  state_tax: Scalars['Float']['output'];
  status: BookingStatus;
  sub_total: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  trip_insurance?: Maybe<BookingTripInsurance>;
  updated_at: Scalars['Timestamp']['output'];
  user: User;
  was_guest_checkout?: Maybe<Scalars['Boolean']['output']>;
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
  widget_source?: Maybe<Scalars['String']['output']>;
};

export type BookingCancellationInfo = {
  __typename?: 'BookingCancellationInfo';
  members: Array<BookingCancellationMemberInfo>;
  reasons: Array<DenialReason>;
};

export type BookingCancellationMemberInfo = {
  __typename?: 'BookingCancellationMemberInfo';
  amount_paid: Scalars['NonNegativeInt']['output'];
  deposit_amount: Scalars['NonNegativeInt']['output'];
  is_auto_refund_allowed: Scalars['Boolean']['output'];
  member_id: Scalars['ID']['output'];
  member_name: Scalars['String']['output'];
  payment_plan_type?: Maybe<PaymentPlanType>;
};

export type BookingCancellationReason = {
  __typename?: 'BookingCancellationReason';
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
};

export enum BookingInternalSource {
  Dashboard = 'Dashboard',
  GuideTech = 'GuideTech',
  MallardBay = 'MallardBay',
  SendQuote = 'SendQuote',
  SendQuoteMarketplace = 'SendQuoteMarketplace'
}

export enum BookingInternalSourceEntityType {
  AwardedItems = 'AwardedItems',
  BookingInvites = 'BookingInvites',
  Listings = 'Listings',
  PricingPackages = 'PricingPackages',
  Widgets = 'Widgets'
}

export type BookingInvite = {
  __typename?: 'BookingInvite';
  /** @deprecated Use packages instead */
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booked_redirect_url?: Maybe<Scalars['String']['output']>;
  can_send_invoice: Scalars['Boolean']['output'];
  coupon?: Maybe<Coupon>;
  created_at: Scalars['Timestamp']['output'];
  dates?: Maybe<Array<Scalars['Timestamp']['output']>>;
  editable_fields: BookingInviteEditableFields;
  hubspot_deal_owner_email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invoice_id?: Maybe<Scalars['String']['output']>;
  invoice_note?: Maybe<Scalars['String']['output']>;
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_invoice?: Maybe<Scalars['Boolean']['output']>;
  itinerary?: Maybe<TripItinerary>;
  join_url: Scalars['String']['output'];
  listing: Listing;
  note?: Maybe<Scalars['String']['output']>;
  outfitter: Outfitter;
  packages: Array<BookingInvitePackage>;
  /** @deprecated Use packages instead */
  pricing_package?: Maybe<PricingPackage>;
  quote_request_id?: Maybe<Scalars['ID']['output']>;
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  sportsman_email?: Maybe<Scalars['String']['output']>;
  sportsman_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** @deprecated Use packages instead */
  total_guests?: Maybe<Scalars['PositiveInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<BookingInviteUser>;
};

export type BookingInviteAddOnCustomizationInput = {
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  unit_price?: InputMaybe<Scalars['Float']['input']>;
};

export type BookingInviteAddOnInput = {
  customization?: InputMaybe<BookingInviteAddOnCustomizationInput>;
  id: Scalars['ID']['input'];
  package_id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['PositiveInt']['input'];
};

export type BookingInviteCustomCouponInput = {
  amount_off?: InputMaybe<Scalars['Float']['input']>;
  percent_off?: InputMaybe<Scalars['Float']['input']>;
};

export type BookingInviteEditableFields = {
  __typename?: 'BookingInviteEditableFields';
  add_ons: Scalars['Boolean']['output'];
  coupon: Scalars['Boolean']['output'];
  dates: Scalars['Boolean']['output'];
  pricing_package: Scalars['Boolean']['output'];
  total_guests: Scalars['Boolean']['output'];
};

export type BookingInviteEditableFieldsInput = {
  add_ons: Scalars['Boolean']['input'];
  coupon: Scalars['Boolean']['input'];
  dates: Scalars['Boolean']['input'];
  pricing_package: Scalars['Boolean']['input'];
  total_guests: Scalars['Boolean']['input'];
};

export type BookingInviteFilters = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  listing_id?: InputMaybe<Scalars['ID']['input']>;
  quote_request_id?: InputMaybe<Scalars['ID']['input']>;
};

export type BookingInviteInvoicePreviewInput = {
  attribution?: InputMaybe<AttributionInput>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  editable_fields?: InputMaybe<BookingInviteEditableFieldsInput>;
  hubspot_deal_owner_email?: InputMaybe<Scalars['String']['input']>;
  invoice_note?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  listing?: InputMaybe<Scalars['ID']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  outfitter: Scalars['ID']['input'];
  packages?: InputMaybe<Array<BookingInvitePackageInput>>;
  quote_request_id?: InputMaybe<Scalars['ID']['input']>;
  should_allow_external_payment?: InputMaybe<Scalars['Boolean']['input']>;
  sportsman_email?: InputMaybe<Scalars['String']['input']>;
  sportsman_name?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type BookingInvitePackage = {
  __typename?: 'BookingInvitePackage';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  editable_fields: BookingInviteEditableFields;
  id: Scalars['ID']['output'];
  pricing_package?: Maybe<PricingPackage>;
  total_guests?: Maybe<Scalars['PositiveInt']['output']>;
};

export type BookingInvitePackageInput = {
  add_ons?: InputMaybe<Array<BookingInviteAddOnInput>>;
  editable_fields: BookingInviteEditableFieldsInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  pricing_package?: InputMaybe<Scalars['ID']['input']>;
  pricing_package_customization?: InputMaybe<BookingInvitePricingPackageCustomizationInput>;
  total_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type BookingInvitePricingPackageCustomizationInput = {
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type BookingInviteSearchResults = {
  __typename?: 'BookingInviteSearchResults';
  results: Array<BookingInvite>;
  total: Scalars['NonNegativeInt']['output'];
};

export type BookingInviteUser = {
  __typename?: 'BookingInviteUser';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type BookingInvitesResults = {
  __typename?: 'BookingInvitesResults';
  count: Scalars['Int']['output'];
  data: Array<BookingInvite>;
  pages: Scalars['Int']['output'];
};

export type BookingPaymentSummary = {
  __typename?: 'BookingPaymentSummary';
  line_items: Array<LineItem>;
  member_summaries: Array<MemberPaymentSummary>;
  member_total?: Maybe<Scalars['Int']['output']>;
  totals: Array<QuotePrice>;
};

export type BookingQuoteTripInsuranceQuote = {
  __typename?: 'BookingQuoteTripInsuranceQuote';
  cost: Scalars['PositiveInt']['output'];
  insurable_amount?: Maybe<Scalars['PositiveInt']['output']>;
  is_accepted?: Maybe<Scalars['Boolean']['output']>;
  policy_attributes?: Maybe<TripInsurancePolicyAttribute>;
  product: TripInsuranceProduct;
  quote_id: Scalars['String']['output'];
  taxes_and_fees?: Maybe<Array<TripInsuranceTaxesAndFees>>;
  zip_code?: Maybe<Scalars['String']['output']>;
};

export type BookingResourceTypeAndId = {
  __typename?: 'BookingResourceTypeAndId';
  id: Scalars['ID']['output'];
  type: ResourceType;
};

export type BookingResults = {
  __typename?: 'BookingResults';
  count: Scalars['Int']['output'];
  data: Array<Booking>;
  pages: Scalars['Int']['output'];
};

export type BookingSearchResults = {
  __typename?: 'BookingSearchResults';
  results: Array<Booking>;
  total: Scalars['NonNegativeInt']['output'];
};

export type BookingStartedEvent = BaseEvent & {
  __typename?: 'BookingStartedEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  metadata: BookingStartedEventMetadata;
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type BookingStartedEventMetadata = {
  __typename?: 'BookingStartedEventMetadata';
  listing_id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
  pricing_package_ids: Array<Scalars['ID']['output']>;
};

export enum BookingStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  Requested = 'REQUESTED'
}

export type BookingTripInsurance = {
  __typename?: 'BookingTripInsurance';
  errors?: Maybe<Array<TripInsuranceError>>;
  insurable_amount: Scalars['PositiveInt']['output'];
  insurance_policy_number?: Maybe<Scalars['String']['output']>;
  insurance_quote_id: Scalars['String']['output'];
  is_accepted?: Maybe<Scalars['Boolean']['output']>;
  status: BookingTripInsuranceStatus;
  total: Scalars['PositiveInt']['output'];
  zip_code: Scalars['String']['output'];
};

export type BookingTripInsuranceInput = {
  insurance_quote_id: Scalars['String']['input'];
  zip_code: Scalars['String']['input'];
};

export enum BookingTripInsuranceStatus {
  Approved = 'APPROVED',
  Declined = 'DECLINED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  PendingApproval = 'PENDING_APPROVAL'
}

/** Bookings section with navigation */
export type BookingsSection = BaseDashboardSection & {
  __typename?: 'BookingsSection';
  bookings: Array<Booking>;
  id: Scalars['String']['output'];
  order: Scalars['PositiveInt']['output'];
  title: Scalars['String']['output'];
};

export type BulkOperation = {
  __typename?: 'BulkOperation';
  attributes?: Maybe<BulkOperationAttributes>;
  completed_at?: Maybe<Scalars['Timestamp']['output']>;
  created_at: Scalars['Timestamp']['output'];
  created_by?: Maybe<Scalars['ID']['output']>;
  errors?: Maybe<Array<BulkOperationError>>;
  failed_count: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
  processed_count: Scalars['NonNegativeInt']['output'];
  started_at?: Maybe<Scalars['Timestamp']['output']>;
  status: BulkOperationStatus;
  successful_count: Scalars['NonNegativeInt']['output'];
  total_count: Scalars['NonNegativeInt']['output'];
  type: BulkOperationType;
  updated_at: Scalars['Timestamp']['output'];
};

/**
 * Job-level context for a bulk operation. Fields are optional and depend on type.
 * Marketing blasts set template_id (when using a template) and topic_entity_id
 * (client list id for list sends, client id for single-client sends).
 */
export type BulkOperationAttributes = {
  __typename?: 'BulkOperationAttributes';
  template_id?: Maybe<Scalars['ID']['output']>;
  topic_entity_id?: Maybe<Scalars['ID']['output']>;
};

export type BulkOperationAttributesFilter = {
  template_id?: InputMaybe<Scalars['ID']['input']>;
  topic_entity_id?: InputMaybe<Scalars['ID']['input']>;
};

export type BulkOperationError = {
  __typename?: 'BulkOperationError';
  completed_at?: Maybe<Scalars['Timestamp']['output']>;
  data: Scalars['JSONObject']['output'];
  error: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  row_index: Scalars['NonNegativeInt']['output'];
};

export enum BulkOperationItemStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Succeeded = 'SUCCEEDED'
}

export enum BulkOperationStatus {
  Completed = 'COMPLETED',
  CompletedWithErrors = 'COMPLETED_WITH_ERRORS',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING'
}

export enum BulkOperationType {
  Bookings = 'BOOKINGS',
  Contacts = 'CONTACTS',
  Leads = 'LEADS',
  MarketingEmail = 'MARKETING_EMAIL',
  MarketingSms = 'MARKETING_SMS'
}

export type BulkOperationsResults = {
  __typename?: 'BulkOperationsResults';
  count: Scalars['Int']['output'];
  data: Array<BulkOperation>;
  pages: Scalars['Int']['output'];
};

export type BulkUpdateLeadsInput = {
  quality?: InputMaybe<LeadQuality>;
  referral_source?: InputMaybe<ReferralSource>;
  status?: InputMaybe<LeadStatus>;
};

export type BusinessAddressInput = {
  city: Scalars['String']['input'];
  iso_country: Scalars['String']['input'];
  postal_code: Scalars['String']['input'];
  region: Scalars['String']['input'];
  street: Scalars['String']['input'];
};

export enum BusinessType {
  Cooperative = 'Cooperative',
  Corporation = 'Corporation',
  LimitedLiabilityCorporation = 'LimitedLiabilityCorporation',
  NonProfitCorporation = 'NonProfitCorporation',
  Partnership = 'Partnership'
}

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  base_color: Scalars['String']['output'];
  calculated_colors: CalendarEventCalculatedColors;
  created_at: Scalars['Timestamp']['output'];
  dates: Array<CalendarEventDate>;
  description?: Maybe<Scalars['String']['output']>;
  details_items: Array<CalendarEventDetailsItem>;
  end_date: Scalars['Timestamp']['output'];
  formatted_date_range: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_single_use_resources: Scalars['Boolean']['output'];
  notes?: Maybe<Scalars['String']['output']>;
  number_of_guests: Scalars['NonNegativeInt']['output'];
  outfitter_id: Scalars['ID']['output'];
  resources: Array<MinimalResource>;
  source: Scalars['String']['output'];
  source_id: Scalars['String']['output'];
  source_type: CalendarEventSourceType;
  start_date: Scalars['Timestamp']['output'];
  status: EventStatus;
  subtitle: Scalars['String']['output'];
  time_zone: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type CalendarEventCalculatedColors = {
  __typename?: 'CalendarEventCalculatedColors';
  dark: CalendarEventColors;
  light: CalendarEventColors;
};

export type CalendarEventColors = {
  __typename?: 'CalendarEventColors';
  background: Scalars['String']['output'];
  border: Scalars['String']['output'];
  highlighted: Scalars['String']['output'];
  not_highlighted: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type CalendarEventDate = {
  __typename?: 'CalendarEventDate';
  date: Scalars['Timestamp']['output'];
  is_highlighted: Scalars['Boolean']['output'];
};

export type CalendarEventDetailsItem = {
  __typename?: 'CalendarEventDetailsItem';
  is_bold: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
};

export type CalendarEventFilters = {
  from_date?: InputMaybe<Scalars['Timestamp']['input']>;
  to_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export enum CalendarEventSourceType {
  Booking = 'BOOKING',
  CalendarImport = 'CALENDAR_IMPORT',
  EventGroup = 'EVENT_GROUP'
}

export type CalendarEventsByResourceTypeFilters = {
  from_date: Scalars['Timestamp']['input'];
  resourceType: ResourceType;
  to_date: Scalars['Timestamp']['input'];
};

export type CalendarEventsByResourceTypeRow = {
  __typename?: 'CalendarEventsByResourceTypeRow';
  events: Array<CalendarEvent>;
  row_name: Scalars['String']['output'];
};

export type CalendarSubscription = {
  __typename?: 'CalendarSubscription';
  created_at: Scalars['Timestamp']['output'];
  filename: Scalars['String']['output'];
  google_calendar_url: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outlook_calendar_url: Scalars['URL']['output'];
  resources: Array<MinimalResource>;
  updated_at: Scalars['Timestamp']['output'];
  url: Scalars['URL']['output'];
  user: User;
  webcal_url: Scalars['URL']['output'];
};

export type CalendarSubscriptionsResults = {
  __typename?: 'CalendarSubscriptionsResults';
  count: Scalars['Int']['output'];
  data: Array<CalendarSubscription>;
  pages: Scalars['Int']['output'];
};

export type CallToAction = {
  __typename?: 'CallToAction';
  image?: Maybe<Media>;
  label: Scalars['String']['output'];
  url_android?: Maybe<Scalars['URL']['output']>;
  url_default: Scalars['URL']['output'];
  url_ios?: Maybe<Scalars['URL']['output']>;
};

export type CallToActionInput = {
  image?: InputMaybe<MediaInput>;
  label: Scalars['String']['input'];
  url_android?: InputMaybe<Scalars['URL']['input']>;
  url_default: Scalars['URL']['input'];
  url_ios?: InputMaybe<Scalars['URL']['input']>;
};

export type CancelBookingReasonInput = {
  id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
};

export type CancelBookingRefundInput = {
  amount: Scalars['NonNegativeInt']['input'];
  member_id: Scalars['String']['input'];
};

export type CancellationPolicy = {
  __typename?: 'CancellationPolicy';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_custom: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

/**
 * Categories with a value and optional color. One shape serves PIE, DONUT, and
 * DISTRIBUTION charts; the chart_type decides the presentation.
 */
export type CategoryChartData = {
  __typename?: 'CategoryChartData';
  segments: Array<CategoryChartSegment>;
  value_format: ChartValueFormat;
};

export type CategoryChartSegment = {
  __typename?: 'CategoryChartSegment';
  color?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Chart = {
  __typename?: 'Chart';
  data: ChartData;
  definition: ChartDefinition;
};

export type ChartData = CategoryChartData | ScorecardChartData | SeriesChartData | TableChartData;

export type ChartDefinition = {
  __typename?: 'ChartDefinition';
  chart_type: ChartType;
  default_window: ChartTimeWindow;
  description?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  page_keys: Array<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ChartQueryInput = {
  chart_key: Scalars['String']['input'];
  outfitter_id: Scalars['ID']['input'];
  time_zone?: InputMaybe<Scalars['TimeZone']['input']>;
  window?: InputMaybe<ChartTimeWindowInput>;
};

/**
 * A reference marker drawn on a series chart. Provide `x` for a vertical line
 * anchored to a category label, or `y` for a horizontal line at a value.
 */
export type ChartReferenceLine = {
  __typename?: 'ChartReferenceLine';
  color?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  x?: Maybe<Scalars['String']['output']>;
  y?: Maybe<Scalars['Float']['output']>;
};

export enum ChartTimeFrameInterval {
  Day = 'DAY',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Week = 'WEEK',
  Year = 'YEAR'
}

/**
 * A lookback window for a chart query. Controls the start/end date range
 * sent to the metrics layer. The bucketing/granularity is owned by the chart
 * definition itself and is not configurable through this input.
 */
export type ChartTimeWindow = {
  __typename?: 'ChartTimeWindow';
  interval: ChartTimeFrameInterval;
  value: Scalars['PositiveInt']['output'];
};

export type ChartTimeWindowInput = {
  interval: ChartTimeFrameInterval;
  value: Scalars['PositiveInt']['input'];
};

export enum ChartType {
  Bar = 'BAR',
  Distribution = 'DISTRIBUTION',
  Donut = 'DONUT',
  Line = 'LINE',
  Pie = 'PIE',
  Scorecard = 'SCORECARD',
  Table = 'TABLE'
}

export enum ChartValueFormat {
  Currency = 'CURRENCY',
  Duration = 'DURATION',
  Number = 'NUMBER',
  Percent = 'PERCENT'
}

export type CheckInConfig = {
  __typename?: 'CheckInConfig';
  check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  days_after_check_out?: Maybe<Scalars['NonNegativeInt']['output']>;
  days_before_check_in?: Maybe<Scalars['NonNegativeInt']['output']>;
  is_check_in_off?: Maybe<Scalars['Boolean']['output']>;
  is_check_out_off?: Maybe<Scalars['Boolean']['output']>;
  non_lodging_check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  non_lodging_check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  non_lodging_days_after_check_out?: Maybe<Scalars['NonNegativeInt']['output']>;
  non_lodging_days_before_check_in?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type CheckInConfigInput = {
  check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  days_after_check_out?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  days_before_check_in?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  is_check_in_off?: InputMaybe<Scalars['Boolean']['input']>;
  is_check_out_off?: InputMaybe<Scalars['Boolean']['input']>;
  non_lodging_check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  non_lodging_check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  non_lodging_days_after_check_out?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  non_lodging_days_before_check_in?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CheckoutCalendarAvailabilityTimeWindow = {
  __typename?: 'CheckoutCalendarAvailabilityTimeWindow';
  end_time: Scalars['NonNegativeInt']['output'];
  start_time: Scalars['NonNegativeInt']['output'];
};

export type CheckoutCalendarDateWithTimeWindows = {
  __typename?: 'CheckoutCalendarDateWithTimeWindows';
  date: Scalars['Timestamp']['output'];
  time_windows: Array<CheckoutCalendarAvailabilityTimeWindow>;
};

export type CheckoutMaxSlots = {
  __typename?: 'CheckoutMaxSlots';
  /** The minimum capacity across the range. */
  max_available_slots: Scalars['NonNegativeInt']['output'];
};

export type CheckoutMaxSlotsInput = {
  end_date: Scalars['Timestamp']['input'];
  listing_id: Scalars['ID']['input'];
  /** Guests already on the booking (held slots), included so max slots are not undercounted during checkout edits. */
  number_of_guests?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pricing_package_id: Scalars['ID']['input'];
  start_date: Scalars['Timestamp']['input'];
  /** Required when the pricing package is hourly. */
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ClientList = {
  __typename?: 'ClientList';
  client_count?: Maybe<Scalars['Int']['output']>;
  client_ids?: Maybe<Array<Scalars['ID']['output']>>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filters: Array<ClientListFilter>;
  id: Scalars['ID']['output'];
  is_system_defined: Scalars['Boolean']['output'];
  list_type: ClientListType;
  name: Scalars['String']['output'];
  outfitter_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ClientListFilter = {
  __typename?: 'ClientListFilter';
  operator: EntityFilterOperator;
  property_key: Scalars['String']['output'];
  property_type: CustomPropertyType;
  property_value: EntityPropertyValue;
};

export type ClientListFilterInput = {
  operator: EntityFilterOperator;
  property_key: Scalars['String']['input'];
  property_type: CustomPropertyType;
  property_value: EntityPropertyValueInput;
};

export type ClientListInput = {
  client_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  filters?: InputMaybe<Array<ClientListFilterInput>>;
  list_type?: InputMaybe<ClientListType>;
  name: Scalars['String']['input'];
  outfitter_id: Scalars['ID']['input'];
};

export enum ClientListType {
  FilterBased = 'FILTER_BASED',
  SelectionBased = 'SELECTION_BASED'
}

export type ClientListsResults = {
  __typename?: 'ClientListsResults';
  count: Scalars['Int']['output'];
  data: Array<ClientList>;
  pages: Scalars['Int']['output'];
};

export type ClientMarketingOptOut = {
  __typename?: 'ClientMarketingOptOut';
  email?: Maybe<EmailMarketingOptOut>;
  sms?: Maybe<SmsMarketingOptOut>;
};

export enum ColorMode {
  Dark = 'Dark',
  Light = 'Light'
}

export type ColorModeImage = {
  __typename?: 'ColorModeImage';
  dark: Scalars['String']['output'];
  light: Scalars['String']['output'];
};

export enum CompanyType {
  Government = 'Government',
  NonProfit = 'NonProfit',
  Private = 'Private',
  Public = 'Public'
}

export enum ConsentType {
  Marketing = 'MARKETING',
  Transactional = 'TRANSACTIONAL'
}

export type Contact = {
  __typename?: 'Contact';
  booking_invites?: Maybe<Array<BookingInvite>>;
  bookings?: Maybe<Array<Booking>>;
  created_at: Scalars['Timestamp']['output'];
  date_added?: Maybe<Scalars['Timestamp']['output']>;
  gross_revenue?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  last_booking_date?: Maybe<Scalars['Timestamp']['output']>;
  leads?: Maybe<Array<Lead>>;
  marketing_opt_out: ContactMarketingOptOutStatus;
  metrics: Array<Metric>;
  notes: Array<Note>;
  number_of_prior_bookings?: Maybe<Scalars['NonNegativeInt']['output']>;
  outfitter_id: Scalars['ID']['output'];
  quote_requests?: Maybe<Array<QuoteRequest>>;
  source?: Maybe<ReferralSource>;
  stage: ContactStage;
  updated_at: Scalars['Timestamp']['output'];
  user: ContactUser;
};

export type ContactList = {
  __typename?: 'ContactList';
  contact_count?: Maybe<Scalars['Int']['output']>;
  contact_ids?: Maybe<Array<Scalars['ID']['output']>>;
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  filters: Array<ContactListFilter>;
  id: Scalars['ID']['output'];
  is_system_defined: Scalars['Boolean']['output'];
  list_type: ContactListType;
  name: Scalars['String']['output'];
  outfitter_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ContactListFilter = {
  __typename?: 'ContactListFilter';
  operator: EntityFilterOperator;
  property_key: Scalars['String']['output'];
  property_type: CustomPropertyType;
  property_value: EntityPropertyValue;
};

export type ContactListFilterInput = {
  operator: EntityFilterOperator;
  property_key: Scalars['String']['input'];
  property_type: CustomPropertyType;
  property_value: EntityPropertyValueInput;
};

export type ContactListInput = {
  contact_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  filters?: InputMaybe<Array<ContactListFilterInput>>;
  list_type?: InputMaybe<ContactListType>;
  name: Scalars['String']['input'];
  outfitter_id: Scalars['ID']['input'];
};

export enum ContactListType {
  FilterBased = 'FILTER_BASED',
  SelectionBased = 'SELECTION_BASED'
}

export type ContactListsResults = {
  __typename?: 'ContactListsResults';
  count: Scalars['Int']['output'];
  data: Array<ContactList>;
  pages: Scalars['Int']['output'];
};

export type ContactMarketingOptOutStatus = {
  __typename?: 'ContactMarketingOptOutStatus';
  /** Null if no email on contact or not opted out. */
  email_opt_out_date?: Maybe<Scalars['Timestamp']['output']>;
  /** True when a marketing email opt-out exists for this contact's email + outfitter. */
  is_email_opted_out: Scalars['Boolean']['output'];
  /** True when a marketing SMS opt-out exists for this contact's phone + outfitter. */
  is_sms_opted_out: Scalars['Boolean']['output'];
  /** Null if no phone on contact or not opted out. */
  sms_opt_out_date?: Maybe<Scalars['Timestamp']['output']>;
};

export enum ContactStage {
  Client = 'CLIENT',
  Lead = 'LEAD',
  None = 'NONE'
}

export type ContactUser = {
  __typename?: 'ContactUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type ContactsFiltersInput = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  outfitterId: Scalars['ID']['input'];
  source?: InputMaybe<ReferralSource>;
  stage?: InputMaybe<ContactStage>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ContactsResults = {
  __typename?: 'ContactsResults';
  count: Scalars['Int']['output'];
  data: Array<Contact>;
  pages: Scalars['Int']['output'];
};

export type Counts = {
  __typename?: 'Counts';
  count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CountsResponse = {
  __typename?: 'CountsResponse';
  counts: Array<Counts>;
  total: Scalars['Int']['output'];
};

/** A type that describes a coupon */
export type Coupon = {
  __typename?: 'Coupon';
  amount_off?: Maybe<Scalars['Float']['output']>;
  created_at: Scalars['Timestamp']['output'];
  created_for_entity_id?: Maybe<Scalars['ID']['output']>;
  created_for_entity_type?: Maybe<EntityType>;
  currency?: Maybe<Scalars['String']['output']>;
  custom_code: Scalars['ID']['output'];
  duration: CouponDuration;
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  max_redemptions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  outfitter?: Maybe<Outfitter>;
  percent_off?: Maybe<Scalars['Float']['output']>;
  redeem_by?: Maybe<Scalars['Timestamp']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum CouponDuration {
  Forever = 'forever',
  Once = 'once',
  Repeating = 'repeating'
}

export type CreateAddOnInput = {
  applied_tax_definition_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  apply_to_all_listings?: InputMaybe<Scalars['Boolean']['input']>;
  category: Scalars['String']['input'];
  category_id?: InputMaybe<Scalars['String']['input']>;
  created_for_entity_id?: InputMaybe<Scalars['ID']['input']>;
  created_for_entity_type?: InputMaybe<EntityType>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  offer_period: AddOnOfferPeriod;
  order?: InputMaybe<Scalars['Int']['input']>;
  outfitter: Scalars['ID']['input'];
  price_by_day?: InputMaybe<PriceByDay>;
  price_by_guest?: InputMaybe<PriceByGuest>;
  species?: InputMaybe<Scalars['ID']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price: Scalars['Float']['input'];
};

export type CreateAddOnOptionInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price: Scalars['Float']['input'];
};

export type CreateAdditionalBookingPaymentInput = {
  amount: Scalars['Float']['input'];
  date?: InputMaybe<Scalars['Timestamp']['input']>;
  external_payment_reference_id?: InputMaybe<Scalars['String']['input']>;
  external_payment_type?: InputMaybe<ExternalPaymentType>;
  group_pay_member_id?: InputMaybe<Scalars['String']['input']>;
  has_payment_been_received?: InputMaybe<Scalars['Boolean']['input']>;
  is_requesting_sportsman_payment?: InputMaybe<Scalars['Boolean']['input']>;
  note: Scalars['String']['input'];
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  should_email_payment_link_to_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAmenityInput = {
  category: Scalars['String']['input'];
  description: Scalars['String']['input'];
  icon_url?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type CreateAuctionInput = {
  ends_at: Scalars['Timestamp']['input'];
  name: Scalars['String']['input'];
  number_of_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  number_of_guests?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  organizer: Scalars['ID']['input'];
  quantity_requested: Scalars['NonNegativeInt']['input'];
  search_term: Scalars['String']['input'];
  type: AuctionType;
};

export type CreateAuditLogInput = {
  actor_email?: InputMaybe<Scalars['String']['input']>;
  actor_name?: InputMaybe<Scalars['String']['input']>;
  document_hash?: InputMaybe<Scalars['String']['input']>;
  entity_id: Scalars['String']['input'];
  entity_type: AuditLogEntityType;
  event_type: AuditLogEventType;
  ip_address?: InputMaybe<Scalars['String']['input']>;
  user_agent?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBannerInput = {
  content_default: BannerContentInput;
  content_mobile?: InputMaybe<BannerContentInput>;
  is_admin: Scalars['Boolean']['input'];
  order: Scalars['PositiveInt']['input'];
  outfitter_id?: InputMaybe<Scalars['ID']['input']>;
  page_keys: Array<BannerPageKey>;
  type?: InputMaybe<BannerType>;
};

export type CreateBookingForAwardedItemInput = {
  awarded_item_id: Scalars['ID']['input'];
  end_date: Scalars['Timestamp']['input'];
  send_confirmation_email: Scalars['Boolean']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export type CreateBookingInput = {
  external_payment?: InputMaybe<ExternalPaymentInput>;
  group_pay_share?: InputMaybe<Scalars['ID']['input']>;
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  is_external_payment_method?: InputMaybe<Scalars['Boolean']['input']>;
  message_to_outfitter?: InputMaybe<Scalars['String']['input']>;
  payment_method?: InputMaybe<Scalars['ID']['input']>;
  payment_plan_type: PaymentPlanType;
  payment_processor_type?: InputMaybe<PaymentProcessorType>;
  quote_id: Scalars['ID']['input'];
  sms_marketing_consent?: InputMaybe<SmsMarketingConsentInput>;
  widget_source?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBookingInviteInput = {
  attribution?: InputMaybe<AttributionInput>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  custom_coupon?: InputMaybe<BookingInviteCustomCouponInput>;
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  editable_fields: BookingInviteEditableFieldsInput;
  hubspot_deal_owner_email?: InputMaybe<Scalars['String']['input']>;
  invoice_note?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  listing: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  outfitter: Scalars['ID']['input'];
  packages?: InputMaybe<Array<BookingInvitePackageInput>>;
  quote_request_id?: InputMaybe<Scalars['ID']['input']>;
  should_allow_external_payment?: InputMaybe<Scalars['Boolean']['input']>;
  /** @deprecated Use userInput instead */
  sportsman_email?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Use userInput instead */
  sportsman_name?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateBookingStartedEventInput = {
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  listing_id: Scalars['ID']['input'];
  pricing_package_ids: Array<Scalars['ID']['input']>;
};

export type CreateCalendarSubscriptionInput = {
  name: Scalars['String']['input'];
  resources: Array<MinimalResourceInput>;
};

export type CreateClientInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CreateContactInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CreateCouponInput = {
  amount_off?: InputMaybe<Scalars['Float']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  custom_code: Scalars['ID']['input'];
  duration: CouponDuration;
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  max_redemptions?: InputMaybe<Scalars['Int']['input']>;
  outfitter?: InputMaybe<Scalars['ID']['input']>;
  percent_off?: InputMaybe<Scalars['Float']['input']>;
  redeem_by?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type CreateESignCompliantFormSubmissionInput = {
  agreed_to_e_signature_disclosure: Scalars['Boolean']['input'];
  answers: Array<FormSubmissionAnswerInput>;
};

export type CreateEventGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  event_compound_ids_input: Array<EventCompoundIdInput>;
  outfitter_id: Scalars['ID']['input'];
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateFormInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  external_form_url?: InputMaybe<Scalars['String']['input']>;
  form_inputs?: InputMaybe<Array<FormInputInput>>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  link_to_booking_configs?: InputMaybe<LinkToBookingConfigsInput>;
  name: Scalars['String']['input'];
  should_create_lead_from_submission?: InputMaybe<Scalars['Boolean']['input']>;
  success_redirect_url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFormSubmissionInput = {
  answers: Array<FormSubmissionAnswerInput>;
};

export type CreateGenericEventInput = {
  event_type: Scalars['String']['input'];
  metadata: Scalars['JSONObject']['input'];
  user_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateGroupPayMemberInput = {
  email: Scalars['EmailAddress']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type CreateGroupPayShareInput = {
  group_pay: Scalars['ID']['input'];
  shares: Array<CreateSlotShareInput>;
};

export type CreateKnowledgeArticleInput = {
  access_scope?: KnowledgeAccessScope;
  contexts?: InputMaybe<Array<KnowledgeContextInput>>;
  is_public?: Scalars['Boolean']['input'];
  product?: KnowledgeProduct;
  sections?: InputMaybe<Array<KnowledgeSectionInput>>;
  slug: Scalars['String']['input'];
  summary?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateLeadInput = {
  address?: InputMaybe<AddressInput>;
  email: Scalars['EmailAddress']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  group_size?: InputMaybe<Scalars['PositiveInt']['input']>;
  integration_source?: InputMaybe<IntegrationSource>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
  quality?: InputMaybe<LeadQuality>;
  referral_source?: InputMaybe<ReferralSource>;
  source_entity_id?: InputMaybe<Scalars['String']['input']>;
  source_entity_type?: InputMaybe<IntegrationSourceEntityType>;
  source_sub_entity_id?: InputMaybe<Scalars['String']['input']>;
  source_sub_entity_type?: InputMaybe<EntityType>;
  source_url?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  trip_amount?: InputMaybe<Scalars['PositiveInt']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLicenseInfoInput = {
  country: Scalars['String']['input'];
  fishing_info_url?: InputMaybe<Scalars['String']['input']>;
  general_info_url?: InputMaybe<Scalars['String']['input']>;
  hunting_info_url?: InputMaybe<Scalars['String']['input']>;
  online_portal_url?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
};

export type CreateListingInput = {
  admin_note?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<Scalars['ID']['input']>>;
  booking_instructions?: InputMaybe<Scalars['String']['input']>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ListingDuration>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  guides?: InputMaybe<Array<Scalars['ID']['input']>>;
  license_info?: InputMaybe<Scalars['ID']['input']>;
  license_required?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging?: InputMaybe<Scalars['ID']['input']>;
  lodgings?: InputMaybe<Array<Scalars['ID']['input']>>;
  max_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  meeting_location?: InputMaybe<AddressInput>;
  min_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  outfitter: Scalars['ID']['input'];
  photos?: InputMaybe<Array<MediaInput>>;
  pricing?: InputMaybe<PricingInput>;
  pricing_packages?: InputMaybe<Array<Scalars['ID']['input']>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_of_day?: InputMaybe<ListingTimeOfDay>;
  time_zone?: InputMaybe<Scalars['TimeZone']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ListingType>;
};

export type CreateListingNoteInput = {
  content: Scalars['String']['input'];
  date: Scalars['Timestamp']['input'];
};

export type CreateListingVisitedEventInput = {
  listing_id: Scalars['ID']['input'];
};

export type CreateLodgingInput = {
  capacity?: InputMaybe<Scalars['PositiveInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<AddressInput>;
  name: Scalars['String']['input'];
  outfitter: Scalars['ID']['input'];
  type: LodgingType;
};

export type CreateMessageTemplateInput = {
  channel: MessageTemplateChannel;
  name: Scalars['String']['input'];
  outfitter_id: Scalars['ID']['input'];
  type: MessageTemplateType;
};

export type CreateMetaAdAndCampaignInput = {
  ad_creative_input: MetaAdCreativeInput;
  ad_input: MetaAdInput;
  ad_set_input: MetaAdSetInput;
  campaign_input: MetaCampaignInput;
  leadgen_form_input: MetaLeadFormInput;
  meta_ad_account_id: Scalars['String']['input'];
  meta_page_id: Scalars['String']['input'];
  outfitter_id: Scalars['ID']['input'];
};

export type CreateMetaAdAndCampaignResult = {
  __typename?: 'CreateMetaAdAndCampaignResult';
  ad: MetaAd;
  success: Scalars['Boolean']['output'];
};

export type CreateNewsfeedEventInput = {
  activity_id: Scalars['String']['input'];
  entity_id: Scalars['ID']['input'];
  entity_type: EntityType;
};

export type CreateNoteInput = {
  content: Scalars['String']['input'];
  media?: InputMaybe<Array<MediaInput>>;
  thread_id?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOutfitterCustomPropertyInput = {
  description: Scalars['String']['input'];
  entity_type: CustomPropertyEntityType;
  format_type?: InputMaybe<CustomPropertyFormatType>;
  is_select: Scalars['Boolean']['input'];
  outfitter_id: Scalars['ID']['input'];
  property_key?: InputMaybe<Scalars['String']['input']>;
  property_label: Scalars['String']['input'];
  property_type: CustomPropertyType;
};

export type CreateOutfitterDocumentInput = {
  document?: InputMaybe<MediaInput>;
  external_url?: InputMaybe<Scalars['String']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  outfitter_id: Scalars['String']['input'];
  pricing_package_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  type: OutfitterDocumentType;
};

export type CreateOutfitterImageInput = {
  alt_text?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  url: Scalars['String']['input'];
};

export type CreateOutfitterInput = {
  about: Scalars['String']['input'];
  admin_note?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<MediaInput>;
  cancellation_policy?: InputMaybe<OutfitterCancellationPolicyInput>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  default_check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  default_check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  gmb_id?: InputMaybe<Scalars['String']['input']>;
  hubspot_company_id?: InputMaybe<Scalars['String']['input']>;
  is_hidden_from_marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  land_size?: InputMaybe<Scalars['PositiveInt']['input']>;
  licensed?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging_instructions?: InputMaybe<Scalars['String']['input']>;
  lodging_rules?: InputMaybe<Scalars['String']['input']>;
  mailing_address?: InputMaybe<AddressInput>;
  meeting_location?: InputMaybe<AddressInput>;
  name: Scalars['String']['input'];
  other_info?: InputMaybe<OutfitterOtherInfoInput>;
  owner?: InputMaybe<Scalars['ID']['input']>;
  photos?: InputMaybe<Array<MediaInput>>;
  primary_contact_email?: InputMaybe<Scalars['EmailAddress']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<OutfitterStatus>;
  tax_definitions?: InputMaybe<Array<OutfitterTaxDefinitionInput>>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<VideoInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  years_in_operation?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreatePaymentRequestInput = {
  add_ons?: InputMaybe<Array<PaymentRequestAddOnInput>>;
  items: Array<PaymentItemRequestInput>;
  payment_method_id?: InputMaybe<Scalars['String']['input']>;
  should_allow_external_payment?: InputMaybe<Scalars['Boolean']['input']>;
  should_include_taxes?: InputMaybe<Scalars['Boolean']['input']>;
  type: PaymentRequestType;
};

export type CreatePricingPackageInput = {
  applied_tax_definition_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  created_for_entity_id?: InputMaybe<Scalars['ID']['input']>;
  created_for_entity_type?: InputMaybe<EntityType>;
  days_included: Scalars['NonNegativeInt']['input'];
  duration_minutes?: InputMaybe<Scalars['PositiveInt']['input']>;
  gear_rentals: Array<Scalars['ID']['input']>;
  guests_included: Scalars['NonNegativeInt']['input'];
  included_lodging_id?: InputMaybe<Scalars['ID']['input']>;
  included_resource_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  is_lodging_only?: InputMaybe<Scalars['Boolean']['input']>;
  lodging_included: Scalars['Boolean']['input'];
  max_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  meal_upgrades: Array<Scalars['ID']['input']>;
  min_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  name: Scalars['String']['input'];
  other_add_ons: Array<Scalars['ID']['input']>;
  price: Scalars['Float']['input'];
  price_by_day: PriceByDay;
  price_by_guest: PriceByGuest;
  start_times?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  trophies: Array<Scalars['ID']['input']>;
};

export type CreateQuickPayPaymentInput = {
  amount: Scalars['PositiveInt']['input'];
  customer?: InputMaybe<PaymentCustomerInput>;
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  outfitter_id: Scalars['ID']['input'];
  should_include_taxes?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateQuoteInput = {
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  booking_invite?: InputMaybe<Scalars['ID']['input']>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  dates: Array<Scalars['Timestamp']['input']>;
  deposit_amount?: InputMaybe<Scalars['PositiveInt']['input']>;
  deposit_date?: InputMaybe<Scalars['Timestamp']['input']>;
  internal_source?: InputMaybe<BookingInternalSource>;
  internal_source_entity_id?: InputMaybe<Scalars['ID']['input']>;
  internal_source_entity_type?: InputMaybe<BookingInternalSourceEntityType>;
  packages?: InputMaybe<Array<AddPackageToQuoteInput>>;
  pricing_package?: InputMaybe<Scalars['ID']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateRefundInput = {
  amount: Scalars['PositiveInt']['input'];
  approved_by_name: Scalars['String']['input'];
  is_outfitter_responsible_for_refund: Scalars['Boolean']['input'];
  payment_id: Scalars['ID']['input'];
  stripe_reason?: InputMaybe<StripeRefundReason>;
  user_reason: Scalars['String']['input'];
};

export type CreateResourceInput = {
  atv_props?: InputMaybe<AtvInput>;
  blind_props?: InputMaybe<BlindInput>;
  boat_props?: InputMaybe<BoatInput>;
  capacity: Scalars['Int']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  gear_props?: InputMaybe<GearInput>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  outfitter_id: Scalars['String']['input'];
  type: ResourceType;
  vehicle_props?: InputMaybe<VehicleInput>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateReviewFormInput = {
  main_subject_type: ReviewSubjectType;
  name: Scalars['String']['input'];
  owner_type: ReviewOwnerType;
  questions?: InputMaybe<Array<ReviewFormQuestionInput>>;
  sub_owner_type?: InputMaybe<ReviewOwnerType>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateReviewInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  photos?: InputMaybe<Array<MediaInput>>;
  rating?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type CreateSetupIntentOnBehalfOfInput = {
  userId: Scalars['ID']['input'];
};

export type CreateSlotShareInput = {
  member: Scalars['ID']['input'];
  slots: Scalars['PositiveInt']['input'];
  total: Scalars['NonNegativeInt']['input'];
};

export type CreateSpeciesCategoryInput = {
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export type CreateSpeciesInput = {
  category?: InputMaybe<SpeciesCategoryInput>;
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
  type: SpeciesType;
};

export type CreateTeamMemberInput = {
  email: Scalars['EmailAddress']['input'];
  name: Scalars['String']['input'];
  role: TeamMemberRole;
};

export type CreateTransactionInput = {
  payment_processor_transaction_id: Scalars['ID']['input'];
  payment_processor_type: Scalars['String']['input'];
};

export type CreateUserInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  bookings?: InputMaybe<Array<Scalars['ID']['input']>>;
  date_of_birth?: InputMaybe<Scalars['PositiveInt']['input']>;
  email: Scalars['EmailAddress']['input'];
  favorite_game?: InputMaybe<Array<Scalars['String']['input']>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  is_guest?: InputMaybe<Scalars['Boolean']['input']>;
  is_guest_conversion_disabled?: InputMaybe<Scalars['Boolean']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  stripe_connected_account_id?: InputMaybe<Scalars['String']['input']>;
  stripe_user_id?: InputMaybe<Scalars['String']['input']>;
  years_of_experience?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type CreateWidgetInput = {
  button_color?: InputMaybe<Scalars['String']['input']>;
  button_text?: InputMaybe<Scalars['String']['input']>;
  google_analytics_id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_external?: InputMaybe<Scalars['Boolean']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  outfitter: Scalars['ID']['input'];
  pixel_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text_color?: InputMaybe<Scalars['String']['input']>;
  trigger_type: WidgetTriggerType;
  widget_name: Scalars['String']['input'];
};

export type CreateWishlistInput = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name: Scalars['String']['input'];
  user: Scalars['ID']['input'];
};

export type Cta = {
  __typename?: 'Cta';
  action: DashboardActionType;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type CursorPaginationInfo = {
  __typename?: 'CursorPaginationInfo';
  first_cursor?: Maybe<Scalars['ID']['output']>;
  has_more: Scalars['Boolean']['output'];
  last_cursor?: Maybe<Scalars['ID']['output']>;
};

export type CursorPaginationOptions = {
  ending_before?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
  starting_after?: InputMaybe<Scalars['ID']['input']>;
};

export type CustomEmailDomainConfig = {
  __typename?: 'CustomEmailDomainConfig';
  created_at: Scalars['Timestamp']['output'];
  dns_records?: Maybe<Array<CustomEmailDomainDnsRecord>>;
  domain: Scalars['String']['output'];
  from_email: Scalars['EmailAddress']['output'];
  reply_to_email?: Maybe<Scalars['EmailAddress']['output']>;
  sendgrid_domain_id?: Maybe<Scalars['Int']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  verification_status: CustomEmailDomainVerificationStatus;
  verified_at?: Maybe<Scalars['Timestamp']['output']>;
};

export type CustomEmailDomainConfigInput = {
  domain: Scalars['String']['input'];
  from_email: Scalars['EmailAddress']['input'];
  reply_to_email?: InputMaybe<Scalars['EmailAddress']['input']>;
};

export type CustomEmailDomainDnsRecord = {
  __typename?: 'CustomEmailDomainDnsRecord';
  data: Scalars['String']['output'];
  host: Scalars['String']['output'];
  type: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum CustomEmailDomainVerificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

export type CustomMessageInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  templateType: MessageTemplateType;
};

export enum CustomPropertyEntityType {
  Client = 'Client'
}

export type CustomPropertyFields = {
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  entity_type: CustomPropertyEntityType;
  format_type?: Maybe<CustomPropertyFormatType>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_select: Scalars['Boolean']['output'];
  is_system_defined: Scalars['Boolean']['output'];
  /** @deprecated Use is_system_defined instead */
  is_system_property: Scalars['Boolean']['output'];
  outfitter_id?: Maybe<Scalars['ID']['output']>;
  property_key: Scalars['String']['output'];
  property_label: Scalars['String']['output'];
  property_type: CustomPropertyType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum CustomPropertyFormatType {
  Currency = 'CURRENCY'
}

export enum CustomPropertyType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT'
}

export type CustomSmsMessageInput = {
  body: Scalars['String']['input'];
  templateType: MessageTemplateType;
};

export enum DashboardActionType {
  OpenModal = 'open_modal',
  OpenUrl = 'open_url'
}

export type DashboardCheckoutAvailabilityInput = {
  end_date: Scalars['Timestamp']['input'];
  listing_id: Scalars['ID']['input'];
  start_date: Scalars['Timestamp']['input'];
};

/** Dashboard home page data structure */
export type DashboardHome = {
  __typename?: 'DashboardHome';
  /** Array of dashboard sections in order */
  sections: Array<DashboardSection>;
  /** Welcome message for the user */
  welcome_message: Scalars['String']['output'];
};

export enum DashboardModalName {
  ImportContacts = 'import_contacts'
}

/** Search result group containing results of a specific type */
export type DashboardSearchGroup = {
  __typename?: 'DashboardSearchGroup';
  /** Number of results in this group */
  count: Scalars['Int']['output'];
  /** Array of search results (limited to a few results) */
  results: Array<DashboardSearchResult>;
  /** Title for the group */
  title: Scalars['String']['output'];
  /** URL to view more results for this group */
  view_more_url: Scalars['String']['output'];
};

/** Generic search result type for dashboard search */
export type DashboardSearchResult = {
  __typename?: 'DashboardSearchResult';
  /** Feature key for fallback icon when no image URL is available */
  feature_key: FeatureIconKey;
  /** Optional image URL for the result */
  image_url?: Maybe<Scalars['String']['output']>;
  /** Optional subtitle for the result */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Optional tag with color scheme and label */
  tag?: Maybe<DashboardSearchTag>;
  /** Title of the result (required) */
  title: Scalars['String']['output'];
  /** URL to view the full result (required) */
  url: Scalars['String']['output'];
};

/** Search results for dashboard consolidated search */
export type DashboardSearchResults = {
  __typename?: 'DashboardSearchResults';
  /** Array of search result groups */
  groups: Array<DashboardSearchGroup>;
  /** Search query that was executed */
  query: Scalars['String']['output'];
};

/** Tag with color scheme and label for search results */
export type DashboardSearchTag = {
  __typename?: 'DashboardSearchTag';
  /** Color scheme for the tag */
  color_scheme: DashboardSearchTagColor;
  /** Label text for the tag */
  label: Scalars['String']['output'];
};

/** Available color schemes for search result tags */
export enum DashboardSearchTagColor {
  Blue = 'BLUE',
  Green = 'GREEN',
  Grey = 'GREY',
  Red = 'RED',
  Yellow = 'YELLOW'
}

/** Union of all possible dashboard section types */
export type DashboardSection = AlertsSection | BannerSection | BookingsSection | FeaturesSection | HighPriorityOutfitterBannerSection | QuickAccessSection | ReportingSection | TipsSection;

export type DateRange = {
  end_date: Scalars['Timestamp']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export type DayBalanceDueConfig = {
  __typename?: 'DayBalanceDueConfig';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
};

export type DayBalanceDueConfigInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
};

export type DealAttributionOption = {
  __typename?: 'DealAttributionOption';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type DefaultAvailabilityRule = {
  __typename?: 'DefaultAvailabilityRule';
  created_at: Scalars['Timestamp']['output'];
  date_end?: Maybe<Scalars['Timestamp']['output']>;
  date_start?: Maybe<Scalars['Timestamp']['output']>;
  day_schedules: Array<DefaultAvailabilityRuleDaySchedule>;
  id: Scalars['ID']['output'];
  is_system_defined: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outfitter_id: Scalars['ID']['output'];
  repeats_yearly: Scalars['Boolean']['output'];
  resource_id: Scalars['ID']['output'];
  resource_type: ResourceType;
  updated_at: Scalars['Timestamp']['output'];
};

/** 0 = Sunday through 6 = Saturday, matching JavaScript Date#getUTCDay(). */
export type DefaultAvailabilityRuleDaySchedule = {
  __typename?: 'DefaultAvailabilityRuleDaySchedule';
  day_of_week: Scalars['NonNegativeInt']['output'];
  is_available: Scalars['Boolean']['output'];
  time_windows?: Maybe<Array<DefaultAvailabilityRuleTimeWindow>>;
  total_slots: Scalars['NonNegativeInt']['output'];
};

export type DefaultAvailabilityRuleDayScheduleInput = {
  day_of_week: Scalars['NonNegativeInt']['input'];
  is_available: Scalars['Boolean']['input'];
  time_windows?: InputMaybe<Array<AvailabilityTimeWindowInput>>;
  total_slots: Scalars['NonNegativeInt']['input'];
};

export type DefaultAvailabilityRuleInput = {
  date_end?: InputMaybe<Scalars['Timestamp']['input']>;
  date_start?: InputMaybe<Scalars['Timestamp']['input']>;
  day_schedules: Array<DefaultAvailabilityRuleDayScheduleInput>;
  name: Scalars['String']['input'];
  repeats_yearly: Scalars['Boolean']['input'];
  resource_id: Scalars['ID']['input'];
  resource_type: ResourceType;
};

export type DefaultAvailabilityRuleTimeWindow = {
  __typename?: 'DefaultAvailabilityRuleTimeWindow';
  end_time: Scalars['NonNegativeInt']['output'];
  is_available: Scalars['Boolean']['output'];
  start_time: Scalars['NonNegativeInt']['output'];
  total_slots: Scalars['NonNegativeInt']['output'];
};

export type DefaultAvailabilityRulesResults = {
  __typename?: 'DefaultAvailabilityRulesResults';
  count: Scalars['Int']['output'];
  data: Array<DefaultAvailabilityRule>;
  pages: Scalars['Int']['output'];
};

export type DenialReason = {
  __typename?: 'DenialReason';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type DenialReasonInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type DeviceCounts = {
  __typename?: 'DeviceCounts';
  android?: Maybe<Scalars['Int']['output']>;
  ios?: Maybe<Scalars['Int']['output']>;
  linux?: Maybe<Scalars['Int']['output']>;
  macos?: Maybe<Scalars['Int']['output']>;
  other?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
  windows?: Maybe<Scalars['Int']['output']>;
};

export type DeviceTypeBreakdown = {
  __typename?: 'DeviceTypeBreakdown';
  desktop: DeviceCounts;
  mobile: DeviceCounts;
  tablet: DeviceCounts;
};

export type DisconnectMetaResult = {
  __typename?: 'DisconnectMetaResult';
  success: Scalars['Boolean']['output'];
};

export type Disqualification = {
  __typename?: 'Disqualification';
  created_at?: Maybe<Scalars['Timestamp']['output']>;
  created_by?: Maybe<Scalars['String']['output']>;
  is_disqualified?: Maybe<Scalars['Boolean']['output']>;
  reason?: Maybe<Array<DisqualifiedReason>>;
};

export type DisqualificationInput = {
  created_by: Scalars['String']['input'];
  is_disqualified: Scalars['Boolean']['input'];
  reason?: InputMaybe<Array<DisqualifiedReason>>;
};

export enum DisqualifiedReason {
  AskedToBeRemoved = 'ASKED_TO_BE_REMOVED',
  BadEmail = 'BAD_EMAIL',
  BadNumber = 'BAD_NUMBER',
  Other = 'OTHER',
  Spam = 'SPAM'
}

export type DraftQuote = QuoteInterface & {
  __typename?: 'DraftQuote';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  coupon?: Maybe<Coupon>;
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  deposit_amount?: Maybe<Scalars['NonNegativeInt']['output']>;
  deposit_date?: Maybe<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  listing: Listing;
  lodging_included?: Maybe<Scalars['Boolean']['output']>;
  packages: Array<QuotePackage>;
  payment_plans: Array<QuotePaymentPlan>;
  payment_summary?: Maybe<PaymentSummary>;
  start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
};

export type DuplicateListingInput = {
  should_clear_photos?: InputMaybe<Scalars['Boolean']['input']>;
  should_clear_pricing_packages?: InputMaybe<Scalars['Boolean']['input']>;
  should_clear_species?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EditLogEntry = {
  __typename?: 'EditLogEntry';
  edited_at: Scalars['Timestamp']['output'];
  edited_by: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
};

export type EmailMarketingOptOut = {
  __typename?: 'EmailMarketingOptOut';
  client_id?: Maybe<Scalars['ID']['output']>;
  created_at: Scalars['Timestamp']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['ID']['output'];
  opt_out_date: Scalars['Timestamp']['output'];
  outfitter_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type EnabledOutfitterIntegrations = {
  __typename?: 'EnabledOutfitterIntegrations';
  does_quick_books_need_reconnection?: Maybe<Scalars['Boolean']['output']>;
  is_custom_email_domain_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_meta_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_quick_books_enabled?: Maybe<Scalars['Boolean']['output']>;
};

export type EntityCustomProperty = CustomPropertyFields & {
  __typename?: 'EntityCustomProperty';
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  entity_id: Scalars['ID']['output'];
  entity_type: CustomPropertyEntityType;
  format_type?: Maybe<CustomPropertyFormatType>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_select: Scalars['Boolean']['output'];
  is_system_defined: Scalars['Boolean']['output'];
  /** @deprecated Use is_system_defined instead */
  is_system_property: Scalars['Boolean']['output'];
  outfitter_custom_property_id: Scalars['ID']['output'];
  outfitter_id?: Maybe<Scalars['ID']['output']>;
  property_key: Scalars['String']['output'];
  property_label: Scalars['String']['output'];
  property_type: CustomPropertyType;
  property_value: EntityPropertyValue;
  updated_at: Scalars['Timestamp']['output'];
};

export type EntityCustomPropertyInput = {
  outfitter_custom_property_id: Scalars['ID']['input'];
  property_value: EntityPropertyValueInput;
};

export enum EntityFilterOperator {
  Equals = 'Equals',
  GreaterThan = 'GreaterThan',
  GreaterThanOrEqual = 'GreaterThanOrEqual',
  LessThan = 'LessThan',
  LessThanOrEqual = 'LessThanOrEqual',
  NotEquals = 'NotEquals'
}

export enum EntityIntegrationSettingsEntityType {
  AddOn = 'ADD_ON',
  Listing = 'LISTING',
  PricingPackage = 'PRICING_PACKAGE'
}

export enum EntityListCountsKey {
  ContactCountsByStage = 'CONTACT_COUNTS_BY_STAGE',
  LeadCountsByStatus = 'LEAD_COUNTS_BY_STATUS'
}

export type EntityPropertyValue = {
  __typename?: 'EntityPropertyValue';
  boolean_value?: Maybe<Scalars['Boolean']['output']>;
  date_value?: Maybe<Scalars['Timestamp']['output']>;
  is_null: Scalars['Boolean']['output'];
  number_value?: Maybe<Scalars['Float']['output']>;
  string_value?: Maybe<Scalars['String']['output']>;
};

export type EntityPropertyValueInput = {
  boolean_value?: InputMaybe<Scalars['Boolean']['input']>;
  date_value?: InputMaybe<Scalars['Timestamp']['input']>;
  is_null: Scalars['Boolean']['input'];
  number_value?: InputMaybe<Scalars['Float']['input']>;
  string_value?: InputMaybe<Scalars['String']['input']>;
};

export enum EntityType {
  AddOn = 'add_on',
  AiOnboarding = 'ai_onboarding',
  Auction = 'auction',
  AuctionRequest = 'auction_request',
  AwardedItem = 'awarded_item',
  Badge = 'badge',
  Booking = 'booking',
  BookingInvite = 'booking_invite',
  CalendarEvent = 'calendar_event',
  Client = 'client',
  ClientList = 'client_list',
  EventGroup = 'event_group',
  EventOrganizer = 'event_organizer',
  Form = 'form',
  FormSubmission = 'form_submission',
  GroupPayShare = 'group_pay_share',
  Lead = 'lead',
  Listing = 'listing',
  Lodging = 'lodging',
  MessageTemplate = 'message_template',
  Note = 'note',
  Onboarding = 'onboarding',
  Outfitter = 'outfitter',
  OutfitterDocument = 'outfitter_document',
  Payment = 'payment',
  PaymentRequest = 'payment_request',
  PricingPackage = 'pricing_package',
  Quote = 'quote',
  QuoteRequest = 'quote_request',
  Resource = 'resource',
  StripeCharge = 'stripe_charge',
  StripeCustomer = 'stripe_customer',
  SyncedCalendar = 'synced_calendar',
  TeamMember = 'team_member',
  User = 'user',
  Website = 'website',
  Widget = 'widget'
}

export type EntityUserInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type EphemeralKeyAndCustomerId = {
  __typename?: 'EphemeralKeyAndCustomerId';
  customerId?: Maybe<Scalars['ID']['output']>;
  ephemeralKey?: Maybe<Scalars['String']['output']>;
};

export type EventCompoundIdInput = {
  entity_id: Scalars['ID']['input'];
  type: EventGroupEntityType;
};

export type EventGroup = {
  __typename?: 'EventGroup';
  calendar_events?: Maybe<Array<CalendarEvent>>;
  color?: Maybe<Scalars['String']['output']>;
  events?: Maybe<Array<EventGroupEvent>>;
  id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type EventGroupEntity = Booking | CalendarEvent;

export enum EventGroupEntityType {
  Booking = 'BOOKING',
  CalendarEvent = 'CALENDAR_EVENT'
}

export type EventGroupEvent = {
  __typename?: 'EventGroupEvent';
  entity: EventGroupEntity;
  type: EventGroupEntityType;
};

export type EventGroupsResults = {
  __typename?: 'EventGroupsResults';
  count: Scalars['NonNegativeInt']['output'];
  data: Array<EventGroup>;
  pages: Scalars['NonNegativeInt']['output'];
};

export type EventOrganizer = {
  __typename?: 'EventOrganizer';
  bio?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  current_self_onboard_step: EventOrganizerSelfOnboardingStepType;
  documents: Array<Media>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  my_roles: Array<TeamMember>;
  name: Scalars['String']['output'];
  number_of_members: Scalars['NonNegativeInt']['output'];
  number_of_organized_events: Scalars['NonNegativeInt']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  type: EventOrganizerType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum EventOrganizerSelfOnboardingStepType {
  ContactInfo = 'CONTACT_INFO',
  Documents = 'DOCUMENTS',
  Finished = 'FINISHED',
  Profile = 'PROFILE',
  Start = 'START'
}

export enum EventOrganizerType {
  RegionalDirector = 'REGIONAL_DIRECTOR'
}

export enum EventStatus {
  Approved = 'APPROVED',
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Denied = 'DENIED',
  Requested = 'REQUESTED'
}

export enum EventType {
  BookingRequested = 'BOOKING_REQUESTED',
  BookingStarted = 'BOOKING_STARTED',
  ListingVisited = 'LISTING_VISITED',
  NewsfeedPostInteractedWith = 'NEWSFEED_POST_INTERACTED_WITH',
  NewsfeedPostOpened = 'NEWSFEED_POST_OPENED',
  WebsitePageView = 'WEBSITE_PAGE_VIEW',
  WebsiteSessionActive = 'WEBSITE_SESSION_ACTIVE',
  WebsiteSessionEnd = 'WEBSITE_SESSION_END',
  WebsiteSessionStart = 'WEBSITE_SESSION_START'
}

export type ExistingPackageInput = {
  id: Scalars['ID']['input'];
  /** Minutes from midnight; required when the existing package is hourly (matches Booking.start_time / Quote.start_time). */
  startTime?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ExportDataInput = {
  from_date?: InputMaybe<Scalars['Timestamp']['input']>;
  outfitter_id: Scalars['ID']['input'];
  to_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type ExternalPaymentInfoInput = {
  date: Scalars['Timestamp']['input'];
  external_payment_reference_id?: InputMaybe<Scalars['String']['input']>;
  external_payment_type: ExternalPaymentType;
};

/** Input for external payment information. These properties should stay in sync with additional booking payment's external payment properties. */
export type ExternalPaymentInput = {
  external_payment_date?: InputMaybe<Scalars['Timestamp']['input']>;
  external_payment_reference_id?: InputMaybe<Scalars['String']['input']>;
  external_payment_type?: InputMaybe<ExternalPaymentType>;
  has_payment_been_received?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ExternalPaymentType {
  Cash = 'CASH',
  Check = 'CHECK',
  Other = 'OTHER'
}

export type FaqItem = {
  __typename?: 'FaqItem';
  answer: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  question: Scalars['String']['output'];
};

export type FaqItemInput = {
  answer: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  question: Scalars['String']['input'];
};

/** Feature item */
export type Feature = {
  __typename?: 'Feature';
  badge?: Maybe<FeatureBadgeType>;
  description: Scalars['String']['output'];
  feature_key: FeatureIconKey;
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type FeatureAccess = {
  __typename?: 'FeatureAccess';
  features: Array<FeatureAccessSetting>;
};

export type FeatureAccessInput = {
  feature_key: FeatureKey;
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type FeatureAccessSetting = {
  __typename?: 'FeatureAccessSetting';
  current_count?: Maybe<Scalars['NonNegativeInt']['output']>;
  feature_key: FeatureKey;
  limit?: Maybe<Scalars['PositiveInt']['output']>;
};

export enum FeatureBadgeType {
  New = 'NEW',
  Preview = 'PREVIEW'
}

export type FeatureGate = {
  __typename?: 'FeatureGate';
  cta?: Maybe<Cta>;
  description: Scalars['String']['output'];
  image?: Maybe<ColorModeImage>;
  title: Scalars['String']['output'];
};

export enum FeatureIconKey {
  Amenities = 'AMENITIES',
  Auctions = 'AUCTIONS',
  AuctionTrips = 'AUCTION_TRIPS',
  Badges = 'BADGES',
  Bookings = 'BOOKINGS',
  Calendar = 'CALENDAR',
  Clients = 'CLIENTS',
  Contacts = 'CONTACTS',
  Coupons = 'COUPONS',
  Feedback = 'FEEDBACK',
  Forms = 'FORMS',
  Home = 'HOME',
  Inbox = 'INBOX',
  Integrations = 'INTEGRATIONS',
  KnowledgeBase = 'KNOWLEDGE_BASE',
  Leads = 'LEADS',
  Licenses = 'LICENSES',
  Listings = 'LISTINGS',
  MyOutfitter = 'MY_OUTFITTER',
  MyRegionalDirector = 'MY_REGIONAL_DIRECTOR',
  Onboardings = 'ONBOARDINGS',
  OnboardingTasks = 'ONBOARDING_TASKS',
  Outfitters = 'OUTFITTERS',
  OutfitterAutomationSettings = 'OUTFITTER_AUTOMATION_SETTINGS',
  PaidAdsReporting = 'PAID_ADS_REPORTING',
  PaidFacebookAds = 'PAID_FACEBOOK_ADS',
  QuickPay = 'QUICK_PAY',
  Quotes = 'QUOTES',
  Reports = 'REPORTS',
  SourceTrips = 'SOURCE_TRIPS',
  Species = 'SPECIES',
  Stripe = 'STRIPE',
  Templates = 'TEMPLATES',
  WebsiteBuilder = 'WEBSITE_BUILDER',
  WebsiteTracking = 'WEBSITE_TRACKING'
}

export enum FeatureKey {
  AdditionalBookingPayments = 'ADDITIONAL_BOOKING_PAYMENTS',
  AdditionalPaymentRequests = 'ADDITIONAL_PAYMENT_REQUESTS',
  AdReporting = 'AD_REPORTING',
  AssignGuideToBookings = 'ASSIGN_GUIDE_TO_BOOKINGS',
  AutomationCenter = 'AUTOMATION_CENTER',
  BookingInvites = 'BOOKING_INVITES',
  Clients = 'CLIENTS',
  ClientList = 'CLIENT_LIST',
  Coupons = 'COUPONS',
  CreateAds = 'CREATE_ADS',
  EditBookingDates = 'EDIT_BOOKING_DATES',
  Feedback = 'FEEDBACK',
  FormsAndWaivers = 'FORMS_AND_WAIVERS',
  Leads = 'LEADS',
  Marketplace = 'MARKETPLACE',
  MessageTemplates = 'MESSAGE_TEMPLATES',
  Messaging = 'MESSAGING',
  MetaIntegration = 'META_INTEGRATION',
  OffPlatformBookings = 'OFF_PLATFORM_BOOKINGS',
  QuickBooks = 'QUICK_BOOKS',
  QuickPay = 'QUICK_PAY',
  ReportingBasic = 'REPORTING_BASIC',
  ReportingBusinessPerformance = 'REPORTING_BUSINESS_PERFORMANCE',
  ReportingPayments = 'REPORTING_PAYMENTS',
  ReportingPayouts = 'REPORTING_PAYOUTS',
  ReportingUnpaidBalances = 'REPORTING_UNPAID_BALANCES',
  SmsIntegration = 'SMS_INTEGRATION',
  SyncedCalendarsIntegration = 'SYNCED_CALENDARS_INTEGRATION',
  TeamMembers = 'TEAM_MEMBERS',
  ViewBookingsInCalendar = 'VIEW_BOOKINGS_IN_CALENDAR',
  WebsiteBuilder = 'WEBSITE_BUILDER',
  WebPerformance = 'WEB_PERFORMANCE'
}

export enum FeatureStatus {
  New = 'new',
  Preview = 'preview'
}

/** Recently released features section */
export type FeaturesSection = BaseDashboardSection & {
  __typename?: 'FeaturesSection';
  features: Array<Feature>;
  id: Scalars['String']['output'];
  order: Scalars['PositiveInt']['output'];
  title: Scalars['String']['output'];
};

export type Form = {
  __typename?: 'Form';
  created_at: Scalars['Timestamp']['output'];
  created_by?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  external_form_url?: Maybe<Scalars['String']['output']>;
  form_inputs?: Maybe<Array<FormInput>>;
  id: Scalars['ID']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_e_signature_required?: Maybe<Scalars['Boolean']['output']>;
  is_published?: Maybe<Scalars['Boolean']['output']>;
  is_required?: Maybe<Scalars['Boolean']['output']>;
  link_to_booking_configs?: Maybe<LinkToBookingConfigs>;
  name: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  should_create_lead_from_submission?: Maybe<Scalars['Boolean']['output']>;
  submissions_count?: Maybe<Scalars['Int']['output']>;
  success_redirect_url?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type FormInput = {
  __typename?: 'FormInput';
  additional_notes?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  input_type: FormInputType;
  is_required: Scalars['Boolean']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  order?: Maybe<Scalars['Int']['output']>;
  placeholder?: Maybe<Scalars['String']['output']>;
  should_allow_pricing_package_selection?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
};

export type FormInputInput = {
  additional_notes?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  input_type: FormInputType;
  is_required: Scalars['Boolean']['input'];
  options?: InputMaybe<Array<Scalars['String']['input']>>;
  order?: InputMaybe<Scalars['Int']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  should_allow_pricing_package_selection?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
};

export enum FormInputType {
  Address = 'address',
  Checkbox = 'checkbox',
  Date = 'date',
  Email = 'email',
  FileUpload = 'file_upload',
  ListingAndPricingPackage = 'listing_and_pricing_package',
  Name = 'name',
  Phone = 'phone',
  Selection = 'selection',
  Signature = 'signature',
  Text = 'text',
  Textarea = 'textarea'
}

export type FormSubmission = {
  __typename?: 'FormSubmission';
  access_code_id?: Maybe<Scalars['String']['output']>;
  agreed_to_e_signature_disclosure?: Maybe<Scalars['Boolean']['output']>;
  answers: Array<FormSubmissionAnswer>;
  booking_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  form: Form;
  form_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_host_submission: Scalars['Boolean']['output'];
  is_unread: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  status: FormSubmissionStatus;
  updated_at: Scalars['Timestamp']['output'];
  url?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
  user_id?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type FormSubmissionAnswer = {
  __typename?: 'FormSubmissionAnswer';
  input_id: Scalars['String']['output'];
  value: FormSubmissionAnswerValue;
};

export type FormSubmissionAnswerInput = {
  input_id: Scalars['String']['input'];
  value: FormSubmissionAnswerValueInput;
};

export type FormSubmissionAnswerValue = {
  __typename?: 'FormSubmissionAnswerValue';
  boolean_value?: Maybe<Scalars['Boolean']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  listing_ids?: Maybe<Array<Scalars['String']['output']>>;
  media?: Maybe<Media>;
  numeric_value?: Maybe<Scalars['PositiveInt']['output']>;
  pricing_package_ids?: Maybe<Array<Scalars['String']['output']>>;
  text_list_value?: Maybe<Array<Scalars['String']['output']>>;
  text_value?: Maybe<Scalars['String']['output']>;
};

export type FormSubmissionAnswerValueInput = {
  boolean_value?: InputMaybe<Scalars['Boolean']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  media?: InputMaybe<MediaInput>;
  numeric_value?: InputMaybe<Scalars['PositiveInt']['input']>;
  pricing_package_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  text_list_value?: InputMaybe<Array<Scalars['String']['input']>>;
  text_value?: InputMaybe<Scalars['String']['input']>;
};

export enum FormSubmissionStatus {
  Completed = 'COMPLETED',
  Pending = 'PENDING'
}

export type FormWithSubmissions = {
  __typename?: 'FormWithSubmissions';
  form: Form;
  is_completed?: Maybe<Scalars['Boolean']['output']>;
  submissions: Array<FormSubmission>;
};

export type GearInput = {
  other?: InputMaybe<Scalars['String']['input']>;
};

export type GearProps = {
  __typename?: 'GearProps';
  other?: Maybe<Scalars['String']['output']>;
};

export type GenericAvailabilityEntry = {
  __typename?: 'GenericAvailabilityEntry';
  available_slots: Scalars['NonNegativeInt']['output'];
  booked_slots: Scalars['NonNegativeInt']['output'];
  created_at: Scalars['Timestamp']['output'];
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_ai_suggestion?: Maybe<Scalars['Boolean']['output']>;
  is_available: Scalars['Boolean']['output'];
  resource_id: Scalars['ID']['output'];
  resource_type: Scalars['String']['output'];
  single_use_ref_id?: Maybe<Scalars['ID']['output']>;
  single_use_ref_type?: Maybe<EntityType>;
  time_windows?: Maybe<Array<AvailabilityTimeWindow>>;
  total_slots: Scalars['NonNegativeInt']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type GenericAvailabilityNote = {
  __typename?: 'GenericAvailabilityNote';
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type GenericEvent = {
  __typename?: 'GenericEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  metadata: Scalars['JSONObject']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type GenericSearchSuggestionGroup = {
  __typename?: 'GenericSearchSuggestionGroup';
  items: Array<GenericSearchSuggestionItem>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type GenericSearchSuggestionItem = {
  __typename?: 'GenericSearchSuggestionItem';
  cta_url?: Maybe<Scalars['String']['output']>;
  icon_url?: Maybe<Scalars['String']['output']>;
  image_url?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type GetEntityCustomPropertiesResult = {
  __typename?: 'GetEntityCustomPropertiesResult';
  data: Array<EntityCustomProperty>;
};

export type GetGenericAvailabilityInput = {
  ai_suggestion_id?: InputMaybe<Scalars['ID']['input']>;
  end_date: Scalars['Timestamp']['input'];
  resource_id: Scalars['ID']['input'];
  resource_type: Scalars['String']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export type GroupPay = {
  __typename?: 'GroupPay';
  created_at: Scalars['Timestamp']['output'];
  host: User;
  id: Scalars['ID']['output'];
  members: Array<Maybe<GroupPayMember>>;
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type GroupPayMember = {
  __typename?: 'GroupPayMember';
  created_at: Scalars['Timestamp']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  stripe_user_id: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type GroupPayShare = {
  __typename?: 'GroupPayShare';
  booking?: Maybe<Booking>;
  created_at: Scalars['Timestamp']['output'];
  created_by: User;
  group_pay: GroupPay;
  id: Scalars['ID']['output'];
  join_url?: Maybe<Scalars['URL']['output']>;
  last_payment_due_date?: Maybe<Scalars['Timestamp']['output']>;
  remaining_slots?: Maybe<Scalars['NonNegativeInt']['output']>;
  shares: Array<SlotShare>;
  updated_at: Scalars['Timestamp']['output'];
};

export type GroupPayShareCheckoutPreview = {
  __typename?: 'GroupPayShareCheckoutPreview';
  payment_plan_previews: Array<GroupPaySharePaymentPlanPreview>;
};

export type GroupPaySharePaymentPlanPreview = {
  __typename?: 'GroupPaySharePaymentPlanPreview';
  payment_plan: QuotePaymentPlan;
  total: Scalars['NonNegativeInt']['output'];
  totals?: Maybe<Array<QuotePrice>>;
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
};

export type GuestUserInput = {
  email: Scalars['EmailAddress']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone: Scalars['PhoneNumber']['input'];
};

/** High priority outfitter banner section containing multiple banners */
export type HighPriorityOutfitterBannerSection = BaseDashboardSection & {
  __typename?: 'HighPriorityOutfitterBannerSection';
  banners: Array<Banner>;
  id: Scalars['String']['output'];
  order: Scalars['PositiveInt']['output'];
  title: Scalars['String']['output'];
};

export enum HowSoonAreYouLookingToBook {
  BookNow = 'BOOK_NOW',
  JustLookingForNow = 'JUST_LOOKING_FOR_NOW',
  Next_3_5Months = 'NEXT_3_5_MONTHS',
  Unknown = 'UNKNOWN'
}

export type HubspotCompanySearchResult = {
  __typename?: 'HubspotCompanySearchResult';
  companies: Array<HubspotCompanySearchResultItem>;
  total: Scalars['Int']['output'];
};

export type HubspotCompanySearchResultItem = {
  __typename?: 'HubspotCompanySearchResultItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type IdAndName = {
  __typename?: 'IdAndName';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ImpersonationDetails = {
  __typename?: 'ImpersonationDetails';
  acts_as_user_id?: Maybe<Scalars['String']['output']>;
  is_impersonated: Scalars['Boolean']['output'];
  original_user_id?: Maybe<Scalars['ID']['output']>;
};

export type ImpersonationMember = {
  __typename?: 'ImpersonationMember';
  role: TeamMemberRole;
  user: User;
};

/**
 * A single row of a bulk booking import. Maps minimal external data onto an off-platform
 * booking. The trip total is computed from the referenced pricing package; no payments are
 * recorded and listing availability is not tracked.
 */
export type ImportBookingInput = {
  email: Scalars['EmailAddress']['input'];
  /** Inclusive last day of the trip. */
  end_date: Scalars['Timestamp']['input'];
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  /** Listing the trip belongs to. Per-row so a single import can span multiple listings. */
  listing_id: Scalars['ID']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  /** Number of guests. Defaults to 1 when omitted. */
  number_of_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
  /** Pricing package used to compute the trip total. Per-row, must belong to listing_id. */
  pricing_package_id: Scalars['ID']['input'];
  /** Inclusive first day of the trip. */
  start_date: Scalars['Timestamp']['input'];
};

export type InitiateConnectionResult = {
  __typename?: 'InitiateConnectionResult';
  auth_uri: Scalars['String']['output'];
};

export enum IntegrationSource {
  AiAssistant = 'AI_ASSISTANT',
  Facebook = 'FACEBOOK',
  Form = 'FORM',
  Instagram = 'INSTAGRAM'
}

export enum IntegrationSourceEntityType {
  Form = 'FORM',
  Page = 'PAGE'
}

export enum JobPosition {
  Ceo = 'CEO',
  Cfo = 'CFO',
  Director = 'Director',
  Gm = 'GM',
  GeneralCounsel = 'GeneralCounsel',
  Other = 'Other',
  Vp = 'VP'
}

export type JoinGroupPayInput = {
  bookingId: Scalars['ID']['input'];
  insuranceQuoteId?: InputMaybe<Scalars['ID']['input']>;
  invitationId: Scalars['ID']['input'];
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  paymentPlanType?: InputMaybe<PaymentPlanType>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  slots: Scalars['PositiveInt']['input'];
  sportsmanZipCode?: InputMaybe<Scalars['String']['input']>;
};

export type JoinGroupPayShareInput = {
  bookingId: Scalars['ID']['input'];
  invitationId: Scalars['ID']['input'];
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  memberId: Scalars['ID']['input'];
  paymentMethodId?: InputMaybe<Scalars['ID']['input']>;
  slots: Scalars['PositiveInt']['input'];
};

export enum KnowledgeAccessScope {
  Internal = 'INTERNAL',
  Outfitter = 'OUTFITTER',
  Public = 'PUBLIC',
  Sportsman = 'SPORTSMAN'
}

export type KnowledgeArticle = {
  __typename?: 'KnowledgeArticle';
  access_scope: KnowledgeAccessScope;
  contexts: Array<KnowledgeContext>;
  created_at: Scalars['Timestamp']['output'];
  created_by: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  is_public: Scalars['Boolean']['output'];
  product: KnowledgeProduct;
  published_at?: Maybe<Scalars['Timestamp']['output']>;
  sections: Array<KnowledgeSection>;
  slug: Scalars['String']['output'];
  status: KnowledgeArticleStatus;
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  updated_by: Scalars['ID']['output'];
  version: Scalars['Int']['output'];
};

export type KnowledgeArticleContent = {
  __typename?: 'KnowledgeArticleContent';
  article: KnowledgeArticle;
  sections: Array<KnowledgeSection>;
};

export type KnowledgeArticleIndexInput = {
  product?: InputMaybe<KnowledgeProduct>;
};

export type KnowledgeArticleIndexItem = {
  __typename?: 'KnowledgeArticleIndexItem';
  id: Scalars['ID']['output'];
  product: KnowledgeProduct;
  published_at?: Maybe<Scalars['Timestamp']['output']>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export enum KnowledgeArticleStatus {
  Archived = 'ARCHIVED',
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type KnowledgeBlock = {
  __typename?: 'KnowledgeBlock';
  id: Scalars['ID']['output'];
  media_ref_ids: Array<Scalars['ID']['output']>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type KnowledgeBlockInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  media_ref_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  text: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type KnowledgeChunk = {
  __typename?: 'KnowledgeChunk';
  article_id: Scalars['ID']['output'];
  chunk_index: Scalars['Int']['output'];
  citation: KnowledgeChunkCitation;
  content_hash: Scalars['String']['output'];
  embedded_at?: Maybe<Scalars['Timestamp']['output']>;
  embedding_error?: Maybe<Scalars['String']['output']>;
  embedding_model?: Maybe<Scalars['String']['output']>;
  embedding_status: KnowledgeEmbeddingStatus;
  id: Scalars['ID']['output'];
  section_id: Scalars['ID']['output'];
  section_version: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  token_count: Scalars['Int']['output'];
};

export type KnowledgeChunkCitation = {
  __typename?: 'KnowledgeChunkCitation';
  article_id: Scalars['ID']['output'];
  article_slug: Scalars['String']['output'];
  article_title: Scalars['String']['output'];
  chunk_id: Scalars['ID']['output'];
  section_heading: Scalars['String']['output'];
  section_id: Scalars['ID']['output'];
  section_version: Scalars['Int']['output'];
};

export type KnowledgeContext = {
  __typename?: 'KnowledgeContext';
  page_url?: Maybe<Scalars['String']['output']>;
  product: KnowledgeProduct;
  screen_name?: Maybe<Scalars['String']['output']>;
};

export type KnowledgeContextInput = {
  page_url?: InputMaybe<Scalars['String']['input']>;
  product: KnowledgeProduct;
  screen_name?: InputMaybe<Scalars['String']['input']>;
};

export enum KnowledgeEmbeddingStatus {
  Embedded = 'EMBEDDED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type KnowledgeMediaRef = {
  __typename?: 'KnowledgeMediaRef';
  alt_text?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  mime_type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type KnowledgeMediaRefInput = {
  alt_text?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export enum KnowledgeProduct {
  Dashboard = 'DASHBOARD',
  Future = 'FUTURE',
  Marketplace = 'MARKETPLACE',
  Mobile = 'MOBILE'
}

export type KnowledgeRetrievalInput = {
  access_scope?: KnowledgeAccessScope;
  limit?: InputMaybe<Scalars['PositiveInt']['input']>;
  page_url?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  screen_name?: InputMaybe<Scalars['String']['input']>;
};

export type KnowledgeRetrievalResult = {
  __typename?: 'KnowledgeRetrievalResult';
  article: KnowledgeArticle;
  chunk: KnowledgeChunk;
  score?: Maybe<Scalars['Float']['output']>;
  section: KnowledgeSection;
};

export type KnowledgeSection = {
  __typename?: 'KnowledgeSection';
  access_scope: KnowledgeAccessScope;
  article_id: Scalars['ID']['output'];
  blocks: Array<KnowledgeBlock>;
  contexts: Array<KnowledgeContext>;
  created_at: Scalars['Timestamp']['output'];
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  media_refs: Array<KnowledgeMediaRef>;
  order: Scalars['Int']['output'];
  plain_text: Scalars['String']['output'];
  tool_refs: Array<KnowledgeToolReference>;
  updated_at: Scalars['Timestamp']['output'];
  version: Scalars['Int']['output'];
};

export type KnowledgeSectionInput = {
  access_scope?: InputMaybe<KnowledgeAccessScope>;
  blocks: Array<KnowledgeBlockInput>;
  contexts?: InputMaybe<Array<KnowledgeContextInput>>;
  heading: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  media_refs?: InputMaybe<Array<KnowledgeMediaRefInput>>;
  order: Scalars['Int']['input'];
  tool_refs?: InputMaybe<Array<KnowledgeToolReferenceInput>>;
};

export type KnowledgeToolReference = {
  __typename?: 'KnowledgeToolReference';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type KnowledgeToolReferenceInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  label: Scalars['String']['input'];
};

export type Lead = {
  __typename?: 'Lead';
  address?: Maybe<Address>;
  available_at?: Maybe<Scalars['Timestamp']['output']>;
  client_id?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  disqualification?: Maybe<Disqualification>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  gross_sales?: Maybe<Scalars['Int']['output']>;
  group_size?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  integration_source?: Maybe<IntegrationSource>;
  integration_source_image_url?: Maybe<Scalars['String']['output']>;
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  is_unread: Scalars['Boolean']['output'];
  last_booking_date?: Maybe<Scalars['Timestamp']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<Note>>;
  number_of_comments?: Maybe<Scalars['Int']['output']>;
  outfitter_id: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['PhoneNumber']['output']>;
  prior_bookings?: Maybe<Scalars['Int']['output']>;
  quality?: Maybe<LeadQuality>;
  referral_source?: Maybe<ReferralSource>;
  schedule_new_lead_at?: Maybe<Scalars['Timestamp']['output']>;
  source_entity?: Maybe<LeadSourceEntity>;
  source_entity_id?: Maybe<Scalars['String']['output']>;
  source_entity_type?: Maybe<IntegrationSourceEntityType>;
  source_form_data?: Maybe<Array<SourceFormDataField>>;
  source_sub_entity_id?: Maybe<Scalars['ID']['output']>;
  source_sub_entity_type?: Maybe<EntityType>;
  source_url?: Maybe<Scalars['String']['output']>;
  status?: Maybe<LeadStatus>;
  trip_amount?: Maybe<Scalars['PositiveInt']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user: PublicUser;
  user_id?: Maybe<Scalars['String']['output']>;
};

export type LeadFilterInput = {
  ad_name?: InputMaybe<Scalars['String']['input']>;
  date_added_from?: InputMaybe<Scalars['Timestamp']['input']>;
  date_added_to?: InputMaybe<Scalars['Timestamp']['input']>;
  group_size_from?: InputMaybe<Scalars['PositiveInt']['input']>;
  group_size_to?: InputMaybe<Scalars['PositiveInt']['input']>;
  how_soon_are_you_looking_to_book?: InputMaybe<HowSoonAreYouLookingToBook>;
  integration_source?: InputMaybe<IntegrationSource>;
  quality?: InputMaybe<LeadQuality>;
  referral_source?: InputMaybe<ReferralSource>;
  trip_amount_from?: InputMaybe<Scalars['PositiveInt']['input']>;
  trip_amount_to?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export enum LeadQuality {
  Cold = 'COLD',
  Hot = 'HOT',
  Warm = 'WARM'
}

export type LeadSourceEntity = {
  __typename?: 'LeadSourceEntity';
  name?: Maybe<Scalars['String']['output']>;
};

export enum LeadStatus {
  Booked = 'BOOKED',
  Contacted = 'CONTACTED',
  Disqualified = 'DISQUALIFIED',
  Lost = 'LOST',
  New = 'NEW',
  Quoted = 'QUOTED'
}

/** A type that describes hunting & fishing license info of a state */
export type LicenseInfo = {
  __typename?: 'LicenseInfo';
  country: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  fishing_info_url?: Maybe<Scalars['String']['output']>;
  general_info_url?: Maybe<Scalars['String']['output']>;
  hunting_info_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  online_portal_url?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type LineItem = {
  __typename?: 'LineItem';
  details_label?: Maybe<Scalars['String']['output']>;
  details_value?: Maybe<Scalars['String']['output']>;
  display_value: Scalars['String']['output'];
  key?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  section_key?: Maybe<Scalars['String']['output']>;
  sub_items?: Maybe<Array<SubItem>>;
  total: Scalars['Int']['output'];
};

export type LinkToBookingConfigs = {
  __typename?: 'LinkToBookingConfigs';
  has_to_be_filled_per_member?: Maybe<Scalars['Boolean']['output']>;
  listings?: Maybe<Array<Scalars['String']['output']>>;
  pricing_packages?: Maybe<Array<Scalars['String']['output']>>;
};

export type LinkToBookingConfigsInput = {
  has_to_be_filled_per_member?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['String']['input']>>;
  pricing_packages?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A type that describes a listing */
export type Listing = {
  __typename?: 'Listing';
  admin_note?: Maybe<Scalars['String']['output']>;
  amenities: Array<Amenity>;
  badges?: Maybe<Array<Badge>>;
  booking_fee_fixed?: Maybe<Scalars['Float']['output']>;
  booking_fee_rate?: Maybe<Scalars['Float']['output']>;
  booking_instructions?: Maybe<Scalars['String']['output']>;
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  check_in_config?: Maybe<CheckInConfig>;
  check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  color: Scalars['String']['output'];
  cover_image?: Maybe<Scalars['URL']['output']>;
  created_at: Scalars['Timestamp']['output'];
  deposit_percentage: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<ListingDuration>;
  featured?: Maybe<Scalars['Boolean']['output']>;
  gear_list?: Maybe<Scalars['String']['output']>;
  guides?: Maybe<Array<TeamMember>>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_marketplace: Scalars['Boolean']['output'];
  is_unavailable?: Maybe<Scalars['Boolean']['output']>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  license_info?: Maybe<LicenseInfo>;
  license_required?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Address>;
  lodging?: Maybe<Lodging>;
  lodgings: Array<Lodging>;
  lowest_pricing_package?: Maybe<PricingPackage>;
  max_guest?: Maybe<Scalars['PositiveInt']['output']>;
  meeting_location?: Maybe<Address>;
  min_guest?: Maybe<Scalars['PositiveInt']['output']>;
  next_availability?: Maybe<GenericAvailabilityEntry>;
  notes: Array<ListingNote>;
  order?: Maybe<Scalars['PositiveInt']['output']>;
  outfitter: Outfitter;
  payment_fee_settings?: Maybe<PaymentFeeSettings>;
  photos: Array<Media>;
  pricing_packages: Array<PricingPackage>;
  published?: Maybe<Scalars['Boolean']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  should_allow_quote_requests?: Maybe<Scalars['Boolean']['output']>;
  species: Array<Species>;
  tax_rate?: Maybe<Scalars['Float']['output']>;
  time_of_day?: Maybe<ListingTimeOfDay>;
  time_zone?: Maybe<Scalars['TimeZone']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ListingType>;
  updated_at: Scalars['Timestamp']['output'];
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
};

export enum ListingDuration {
  MultiDay = 'MULTI_DAY',
  SingleDay = 'SINGLE_DAY'
}

export type ListingNote = {
  __typename?: 'ListingNote';
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  listing_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ListingProgress = {
  __typename?: 'ListingProgress';
  is_add_ons_complete: Scalars['Boolean']['output'];
  is_amenities_complete: Scalars['Boolean']['output'];
  is_availability_complete: Scalars['Boolean']['output'];
  is_basic_info_complete: Scalars['Boolean']['output'];
  is_description_complete: Scalars['Boolean']['output'];
  is_listing_complete: Scalars['Boolean']['output'];
  is_location_complete: Scalars['Boolean']['output'];
  is_lodging_complete: Scalars['Boolean']['output'];
  is_photos_complete: Scalars['Boolean']['output'];
  is_post_trip_payments_complete: Scalars['Boolean']['output'];
  is_pricing_complete: Scalars['Boolean']['output'];
  is_species_complete: Scalars['Boolean']['output'];
};

export type ListingSearchResults = {
  __typename?: 'ListingSearchResults';
  results: Array<Listing>;
  total: Scalars['NonNegativeInt']['output'];
};

export enum ListingTimeOfDay {
  Afternoon = 'AFTERNOON',
  AllDay = 'ALL_DAY',
  Evening = 'EVENING',
  Morning = 'MORNING'
}

export enum ListingType {
  Activity = 'ACTIVITY',
  BlastCast = 'BLAST_CAST',
  Fishing = 'FISHING',
  Hunting = 'HUNTING',
  LodgingOnly = 'LODGING_ONLY'
}

export type ListingVisitedEvent = BaseEvent & {
  __typename?: 'ListingVisitedEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  metadata: ListingVisitedEventMetadata;
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ListingVisitedEventMetadata = {
  __typename?: 'ListingVisitedEventMetadata';
  has_availability: Scalars['Boolean']['output'];
  listing_id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
};

/** A type that describes a lodging room or space */
export type Lodging = {
  __typename?: 'Lodging';
  capacity: Scalars['PositiveInt']['output'];
  cover_image: Scalars['URL']['output'];
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Media>>;
  is_archived: Scalars['Boolean']['output'];
  is_single_use?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Address>;
  name: Scalars['String']['output'];
  outfitter: Outfitter;
  type: LodgingType;
  type_name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export enum LodgingType {
  Bedroom = 'BEDROOM',
  CommonArea = 'COMMON_AREA',
  LivingRoom = 'LIVING_ROOM',
  Lodge = 'LODGE',
  Other = 'OTHER',
  Tent = 'TENT'
}

export type Media = {
  __typename?: 'Media';
  description?: Maybe<Scalars['String']['output']>;
  file_name?: Maybe<Scalars['String']['output']>;
  mime_type?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type MediaInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  file_name?: InputMaybe<Scalars['String']['input']>;
  mime_type?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

export type MemberPaymentSummary = {
  __typename?: 'MemberPaymentSummary';
  member_id: Scalars['ID']['output'];
  member_name: Scalars['String']['output'];
  prices: Array<QuotePrice>;
  totals: Array<QuotePrice>;
};

export enum MessageRecipientType {
  Client = 'CLIENT',
  GroupPayMember = 'GROUP_PAY_MEMBER',
  Lead = 'LEAD',
  User = 'USER'
}

export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  channel: MessageTemplateChannel;
  created_at: Scalars['Timestamp']['output'];
  editor_data?: Maybe<Scalars['JSONObject']['output']>;
  email?: Maybe<MessageTemplateEmailContent>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_automation_template?: Maybe<Scalars['Boolean']['output']>;
  is_original?: Maybe<Scalars['Boolean']['output']>;
  is_system_defined: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  outfitter_id: Scalars['ID']['output'];
  sms?: Maybe<MessageTemplateSmsContent>;
  type: MessageTemplateType;
  updated_at: Scalars['Timestamp']['output'];
  variables: Array<TemplateVariable>;
};

export enum MessageTemplateChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type MessageTemplateEmailContent = {
  __typename?: 'MessageTemplateEmailContent';
  fonts: Array<WebsiteFont>;
  subject: Scalars['String']['output'];
};

export type MessageTemplateEmailContentInput = {
  css?: InputMaybe<Scalars['String']['input']>;
  fonts?: InputMaybe<Array<WebsiteFontInput>>;
  html?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
};

export type MessageTemplateFilters = {
  channel?: InputMaybe<MessageTemplateChannel>;
  types?: InputMaybe<Array<MessageTemplateType>>;
};

export enum MessageTemplateKey {
  BookingApprovedSportsman = 'BOOKING_APPROVED_SPORTSMAN',
  BookingCanceledSportsman = 'BOOKING_CANCELED_SPORTSMAN',
  BookingDeclinedSportsman = 'BOOKING_DECLINED_SPORTSMAN',
  BookingInviteInvoiceSportsman = 'BOOKING_INVITE_INVOICE_SPORTSMAN',
  BookingInviteSportsman = 'BOOKING_INVITE_SPORTSMAN',
  BookingReceiptSportsman = 'BOOKING_RECEIPT_SPORTSMAN',
  BookingRequestedSportsman = 'BOOKING_REQUESTED_SPORTSMAN',
  BookingRequestReviewSportsman = 'BOOKING_REQUEST_REVIEW_SPORTSMAN',
  BookingUpdatedSportsman = 'BOOKING_UPDATED_SPORTSMAN',
  FailedPaymentSportsman = 'FAILED_PAYMENT_SPORTSMAN',
  FormSubmissionSportsman = 'FORM_SUBMISSION_SPORTSMAN',
  GearListSportsman = 'GEAR_LIST_SPORTSMAN',
  PaymentRequestCreatedSportsman = 'PAYMENT_REQUEST_CREATED_SPORTSMAN',
  PaymentRequestReceiptSportsman = 'PAYMENT_REQUEST_RECEIPT_SPORTSMAN',
  PaymentRequestReminderSportsman = 'PAYMENT_REQUEST_REMINDER_SPORTSMAN',
  PaymentRequestUrgentReminderSportsman = 'PAYMENT_REQUEST_URGENT_REMINDER_SPORTSMAN',
  PreTripReminderSportsman = 'PRE_TRIP_REMINDER_SPORTSMAN',
  QuickPayReceiptSportsman = 'QUICK_PAY_RECEIPT_SPORTSMAN',
  QuoteReminderSportsman = 'QUOTE_REMINDER_SPORTSMAN',
  RefundInitiatedSportsman = 'REFUND_INITIATED_SPORTSMAN',
  TripDetailReminderSportsman = 'TRIP_DETAIL_REMINDER_SPORTSMAN'
}

export type MessageTemplateSearchResults = {
  __typename?: 'MessageTemplateSearchResults';
  results: Array<MessageTemplate>;
  total: Scalars['NonNegativeInt']['output'];
};

export type MessageTemplateSmsContent = {
  __typename?: 'MessageTemplateSmsContent';
  content: Scalars['String']['output'];
};

export type MessageTemplateSmsContentInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export enum MessageTemplateSnippetType {
  BookingChanges = 'BOOKING_CHANGES',
  BookingDetails = 'BOOKING_DETAILS',
  FormsWarning = 'FORMS_WARNING',
  GearList = 'GEAR_LIST',
  LeadDetails = 'LEAD_DETAILS',
  Logo = 'LOGO',
  QuoteDetails = 'QUOTE_DETAILS',
  QuotePriceSummary = 'QUOTE_PRICE_SUMMARY',
  WhatToExpect = 'WHAT_TO_EXPECT'
}

export enum MessageTemplateType {
  AdditionalPayment = 'ADDITIONAL_PAYMENT',
  Booking = 'BOOKING',
  BookingInvite = 'BOOKING_INVITE',
  FormSubmission = 'FORM_SUBMISSION',
  Lead = 'LEAD',
  Payment = 'PAYMENT',
  Refund = 'REFUND',
  Sportsman = 'SPORTSMAN'
}

export type MessageTemplatesResults = {
  __typename?: 'MessageTemplatesResults';
  count: Scalars['Int']['output'];
  data: Array<MessageTemplate>;
  pages: Scalars['Int']['output'];
};

export type MessageTo = {
  id: Scalars['ID']['input'];
  type: MessageRecipientType;
};

export type MetaAd = {
  __typename?: 'MetaAd';
  ad_account_id: Scalars['String']['output'];
  ad_campaign_id: Scalars['String']['output'];
  ad_campaign_name?: Maybe<Scalars['String']['output']>;
  ad_set_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_created_via_dashboard?: Maybe<Scalars['Boolean']['output']>;
  meta_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MetaAdAccount = {
  __typename?: 'MetaAdAccount';
  account_status: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  meta_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type MetaAdAccountsResults = {
  __typename?: 'MetaAdAccountsResults';
  count: Scalars['Int']['output'];
  data: Array<MetaAdAccount>;
  pages: Scalars['Int']['output'];
};

export type MetaAdCampaign = {
  __typename?: 'MetaAdCampaign';
  ad_account_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  meta_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  objective: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MetaAdCampaignsResults = {
  __typename?: 'MetaAdCampaignsResults';
  count: Scalars['Int']['output'];
  data: Array<MetaAdCampaign>;
  pages: Scalars['Int']['output'];
};

export type MetaAdCreativeInput = {
  creative_name: Scalars['String']['input'];
  image_url: Scalars['String']['input'];
  link_url: Scalars['String']['input'];
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type MetaAdInput = {
  name: Scalars['String']['input'];
};

export type MetaAdMetrics = {
  __typename?: 'MetaAdMetrics';
  account_id: Scalars['String']['output'];
  account_name: Scalars['String']['output'];
  ad_id: Scalars['String']['output'];
  ad_name: Scalars['String']['output'];
  adset_id: Scalars['String']['output'];
  adset_name?: Maybe<Scalars['String']['output']>;
  campaign_id: Scalars['String']['output'];
  campaign_name?: Maybe<Scalars['String']['output']>;
  metrics: Array<Metric>;
  objective: Scalars['String']['output'];
};

export type MetaAdMetricsInput = {
  ad_account_id: Scalars['String']['input'];
  facets: Array<MetaAggregatedAdMetricsFacetInput>;
  month?: InputMaybe<Scalars['PositiveInt']['input']>;
  outfitter_id: Scalars['String']['input'];
  year: Scalars['PositiveInt']['input'];
};

export type MetaAdMetricsResult = {
  __typename?: 'MetaAdMetricsResult';
  data: Array<MetaAdMetrics>;
};

export type MetaAdSet = {
  __typename?: 'MetaAdSet';
  ad_account_id: Scalars['String']['output'];
  ad_campaign_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  meta_id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MetaAdSetInput = {
  end_time?: InputMaybe<Scalars['Timestamp']['input']>;
  name: Scalars['String']['input'];
};

export type MetaAdSetsResults = {
  __typename?: 'MetaAdSetsResults';
  count: Scalars['Int']['output'];
  data: Array<MetaAdSet>;
  pages: Scalars['Int']['output'];
};

export enum MetaAdStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED'
}

export type MetaAdsResults = {
  __typename?: 'MetaAdsResults';
  count: Scalars['Int']['output'];
  data: Array<MetaAd>;
  pages: Scalars['Int']['output'];
};

export type MetaAggregatedAdMetricsFacetInput = {
  facet_name: MetaFacetName;
  facet_value: Scalars['String']['input'];
};

export type MetaAggregatedAdMetricsInput = {
  ad_account_id: Scalars['String']['input'];
  facets: Array<MetaAggregatedAdMetricsFacetInput>;
  month?: InputMaybe<Scalars['PositiveInt']['input']>;
  outfitter_id: Scalars['String']['input'];
  year: Scalars['PositiveInt']['input'];
};

export type MetaAggregatedAdMetricsResult = {
  __typename?: 'MetaAggregatedAdMetricsResult';
  data: Array<Metric>;
};

export type MetaCampaignInput = {
  daily_budget: Scalars['PositiveInt']['input'];
  name: Scalars['String']['input'];
};

export type MetaConnection = {
  __typename?: 'MetaConnection';
  closest_expiration_date: Scalars['Timestamp']['output'];
  connecting_user_email?: Maybe<Scalars['String']['output']>;
  connecting_user_name?: Maybe<Scalars['String']['output']>;
  data_access_expires_at: Scalars['Timestamp']['output'];
  is_inhouse_managed?: Maybe<Scalars['Boolean']['output']>;
  page_id: Scalars['String']['output'];
  page_name: Scalars['String']['output'];
  page_url: Scalars['String']['output'];
  token_expires_at: Scalars['Timestamp']['output'];
};

export type MetaConnectionInput = {
  outfitter_id: Scalars['ID']['input'];
  redirect_to?: InputMaybe<MetaRedirectLocation>;
};

export type MetaConnectionsResult = {
  __typename?: 'MetaConnectionsResult';
  meta_connections: Array<MetaConnection>;
};

export enum MetaFacetName {
  AdId = 'ad_id',
  AdsetId = 'adset_id',
  CampaignId = 'campaign_id'
}

export enum MetaInsightsLevel {
  Account = 'account',
  Ad = 'ad',
  Adset = 'adset',
  Campaign = 'campaign'
}

export type MetaLeadFormInput = {
  description: Scalars['String']['input'];
  follow_up_action_url: Scalars['String']['input'];
  name: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export enum MetaRedirectLocation {
  Ads = 'ads',
  AdsReporting = 'ads_reporting',
  Integrations = 'integrations'
}

/** A type that describes a metric */
export type Metric = {
  __typename?: 'Metric';
  created_at: Scalars['Timestamp']['output'];
  date_timestamp: Scalars['Timestamp']['output'];
  delta: MetricDelta;
  description: Scalars['String']['output'];
  formatted_value: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  metric_bucket: MetricBucket;
  metric_key: Scalars['String']['output'];
  outfitter_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
};

export enum MetricBucket {
  Day = 'DAY',
  Month = 'MONTH',
  Total = 'TOTAL',
  Year = 'YEAR'
}

export type MetricByOutfitterAndKeysParams = {
  end_date: Scalars['Timestamp']['input'];
  metric_bucket: MetricBucket;
  metric_keys: Array<Scalars['String']['input']>;
  outfitter_id: Scalars['ID']['input'];
  start_date: Scalars['Timestamp']['input'];
};

export enum MetricChangeType {
  Bad = 'BAD',
  Good = 'GOOD',
  Neutral = 'NEUTRAL'
}

export type MetricDelta = {
  __typename?: 'MetricDelta';
  change: Scalars['String']['output'];
  change_type: MetricChangeType;
};

export enum MetricKey {
  BookingCountNewCustomerBookingDate = 'BOOKING_COUNT_NEW_CUSTOMER_BOOKING_DATE',
  BookingCountNewCustomerTripDate = 'BOOKING_COUNT_NEW_CUSTOMER_TRIP_DATE',
  BookingCountOffsiteBookingDate = 'BOOKING_COUNT_OFFSITE_BOOKING_DATE',
  BookingCountOffsiteTripDate = 'BOOKING_COUNT_OFFSITE_TRIP_DATE',
  BookingCountOnlineBookingDate = 'BOOKING_COUNT_ONLINE_BOOKING_DATE',
  BookingCountOnlineTripDate = 'BOOKING_COUNT_ONLINE_TRIP_DATE',
  BookingCountReturningCustomerBookingDate = 'BOOKING_COUNT_RETURNING_CUSTOMER_BOOKING_DATE',
  BookingCountReturningCustomerTripDate = 'BOOKING_COUNT_RETURNING_CUSTOMER_TRIP_DATE',
  BookingCountSendQuoteBookingDate = 'BOOKING_COUNT_SEND_QUOTE_BOOKING_DATE',
  BookingCountSendQuoteTripDate = 'BOOKING_COUNT_SEND_QUOTE_TRIP_DATE',
  BookingCountTotalBookingDate = 'BOOKING_COUNT_TOTAL_BOOKING_DATE',
  BookingCountTotalTripDate = 'BOOKING_COUNT_TOTAL_TRIP_DATE',
  BookingCountTotalUserBooking = 'BOOKING_COUNT_TOTAL_USER_BOOKING',
  BookingCountWebsiteBookingDate = 'BOOKING_COUNT_WEBSITE_BOOKING_DATE',
  BookingCountWebsiteTripDate = 'BOOKING_COUNT_WEBSITE_TRIP_DATE',
  BookingCountWidgetBookingDate = 'BOOKING_COUNT_WIDGET_BOOKING_DATE',
  BookingCountWidgetTripDate = 'BOOKING_COUNT_WIDGET_TRIP_DATE',
  FailedPaymentsNetRevenue = 'FAILED_PAYMENTS_NET_REVENUE',
  FailedPaymentsTotal = 'FAILED_PAYMENTS_TOTAL',
  FailedPaymentsTotalOnCompletedTrips = 'FAILED_PAYMENTS_TOTAL_ON_COMPLETED_TRIPS',
  GrossRevenueNewCustomerBookingDate = 'GROSS_REVENUE_NEW_CUSTOMER_BOOKING_DATE',
  GrossRevenueNewCustomerTripDate = 'GROSS_REVENUE_NEW_CUSTOMER_TRIP_DATE',
  GrossRevenueOffsiteBookingDate = 'GROSS_REVENUE_OFFSITE_BOOKING_DATE',
  GrossRevenueOffsiteTripDate = 'GROSS_REVENUE_OFFSITE_TRIP_DATE',
  GrossRevenueOnlineBookingDate = 'GROSS_REVENUE_ONLINE_BOOKING_DATE',
  GrossRevenueOnlineTripDate = 'GROSS_REVENUE_ONLINE_TRIP_DATE',
  GrossRevenueReturningCustomerBookingDate = 'GROSS_REVENUE_RETURNING_CUSTOMER_BOOKING_DATE',
  GrossRevenueReturningCustomerTripDate = 'GROSS_REVENUE_RETURNING_CUSTOMER_TRIP_DATE',
  GrossRevenueSendQuoteBookingDate = 'GROSS_REVENUE_SEND_QUOTE_BOOKING_DATE',
  GrossRevenueSendQuoteTripDate = 'GROSS_REVENUE_SEND_QUOTE_TRIP_DATE',
  GrossRevenueTotalBookingDate = 'GROSS_REVENUE_TOTAL_BOOKING_DATE',
  GrossRevenueTotalTripDate = 'GROSS_REVENUE_TOTAL_TRIP_DATE',
  GrossRevenueTotalUserBooking = 'GROSS_REVENUE_TOTAL_USER_BOOKING',
  GrossRevenueWebsiteBookingDate = 'GROSS_REVENUE_WEBSITE_BOOKING_DATE',
  GrossRevenueWebsiteTripDate = 'GROSS_REVENUE_WEBSITE_TRIP_DATE',
  GrossRevenueWidgetBookingDate = 'GROSS_REVENUE_WIDGET_BOOKING_DATE',
  GrossRevenueWidgetTripDate = 'GROSS_REVENUE_WIDGET_TRIP_DATE',
  MetaClicks = 'META_CLICKS',
  MetaCpc = 'META_CPC',
  MetaCpl = 'META_CPL',
  MetaCpm = 'META_CPM',
  MetaCtr = 'META_CTR',
  MetaImpressions = 'META_IMPRESSIONS',
  MetaReach = 'META_REACH',
  MetaSpend = 'META_SPEND',
  PendingPaymentsNetRevenue = 'PENDING_PAYMENTS_NET_REVENUE',
  PendingPaymentsTotal = 'PENDING_PAYMENTS_TOTAL',
  SuccessAchPaymentsCount = 'SUCCESS_ACH_PAYMENTS_COUNT',
  SuccessAchPaymentsNetRevenue = 'SUCCESS_ACH_PAYMENTS_NET_REVENUE',
  SuccessCardPaymentsCount = 'SUCCESS_CARD_PAYMENTS_COUNT',
  SuccessCardPaymentsNetRevenue = 'SUCCESS_CARD_PAYMENTS_NET_REVENUE',
  SuccessCashPaymentsCount = 'SUCCESS_CASH_PAYMENTS_COUNT',
  SuccessCashPaymentsNetRevenue = 'SUCCESS_CASH_PAYMENTS_NET_REVENUE',
  SuccessCheckPaymentsCount = 'SUCCESS_CHECK_PAYMENTS_COUNT',
  SuccessCheckPaymentsNetRevenue = 'SUCCESS_CHECK_PAYMENTS_NET_REVENUE',
  SuccessOtherPaymentsCount = 'SUCCESS_OTHER_PAYMENTS_COUNT',
  SuccessOtherPaymentsNetRevenue = 'SUCCESS_OTHER_PAYMENTS_NET_REVENUE',
  SuccessPaymentsNetRevenue = 'SUCCESS_PAYMENTS_NET_REVENUE',
  WebsiteAvgSessionDuration = 'WEBSITE_AVG_SESSION_DURATION',
  WebsiteNewUsers = 'WEBSITE_NEW_USERS',
  WebsiteNewUsersPercentage = 'WEBSITE_NEW_USERS_PERCENTAGE',
  WebsitePageViews = 'WEBSITE_PAGE_VIEWS',
  WebsiteSessions = 'WEBSITE_SESSIONS',
  WebsiteTotalUsers = 'WEBSITE_TOTAL_USERS'
}

export type MetricParams = {
  end_date?: InputMaybe<Scalars['Timestamp']['input']>;
  metric_bucket: MetricBucket;
  metric_key: Scalars['String']['input'];
  outfitter_id: Scalars['ID']['input'];
  start_date?: InputMaybe<Scalars['Timestamp']['input']>;
  user_id?: InputMaybe<Scalars['String']['input']>;
};

export type MinimalResource = {
  __typename?: 'MinimalResource';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type: ResourceType;
};

export type MinimalResourceInput = {
  id: Scalars['ID']['input'];
  type: ResourceType;
};

export type MoveBookingInput = {
  dates: Array<Scalars['Timestamp']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['Void']['output']>;
  acceptAuctionBids: Array<AuctionRequest>;
  acceptAvailabilityAiSuggestion: Array<GenericAvailabilityEntry>;
  acceptAwardedItem: AwardedItem;
  acceptBooking: Booking;
  acceptPaymentRequest: PaymentRequest;
  acceptTeamMemberInvitation: TeamMember;
  addContactsToContactList: ContactList;
  addPackageToQuote: Quote;
  applyQuoteCoupon: Quote;
  archiveBanner: Banner;
  archiveBookingInvite: BookingInvite;
  archiveCalendarEvent: CalendarEvent;
  archiveCalendarSubscription: CalendarSubscription;
  archiveContactLists?: Maybe<Scalars['Void']['output']>;
  archiveContacts?: Maybe<Scalars['Void']['output']>;
  archiveDefaultAvailabilityRule: DefaultAvailabilityRule;
  archiveLeads?: Maybe<Scalars['Void']['output']>;
  archiveMessageTemplate: MessageTemplate;
  archiveNoteThread?: Maybe<Scalars['Void']['output']>;
  archiveOnboarding?: Maybe<Scalars['Void']['output']>;
  archiveOutfitterCustomProperties?: Maybe<Scalars['Void']['output']>;
  archiveOutfitterDocument?: Maybe<Scalars['Void']['output']>;
  archiveQuoteRequest: QuoteRequest;
  archiveSyncedCalendar: SyncedCalendar;
  assignGuidesToBooking: Booking;
  assignLodgingsToBooking: Booking;
  assignResourcesToBooking: Booking;
  bidOnAuction: AuctionRequest;
  cancelBooking: Booking;
  cancelPayment: Payment;
  cancelPaymentRequest: PaymentRequest;
  changeUserPassword: Scalars['Boolean']['output'];
  confirmOfflinePaymentRequest: PaymentRequest;
  convertGuestToUser?: Maybe<Scalars['Void']['output']>;
  createAddOn: AddOn;
  createAdditionalBookingPayment: Payment;
  createAiOnboarding: AiOnboarding;
  createAmenity: Amenity;
  createAuction: Auction;
  createBadge: Badge;
  createBooking: Booking;
  createBookingAsOutfitter: Booking;
  /** Queue an async bulk import of off-platform bookings for an outfitter. Each row carries its own listing_id/pricing_package_id. The whole batch is validated up front; the request is rejected (nothing queued) if any row is invalid. */
  createBookingBulkImport: BulkOperation;
  createBookingForAwardedItem: Booking;
  createBookingInvite: BookingInvite;
  createBookingStartedEvent: BookingStartedEvent;
  createBookingTripInsurancePolicy: Booking;
  createCalendarSubscription: CalendarSubscription;
  createContact: Contact;
  createContactList: ContactList;
  createContacts: BulkOperation;
  createCoupon: Coupon;
  createDefaultAvailabilityRule: DefaultAvailabilityRule;
  createDraftOnboarding: Onboarding;
  createESignCompliantFormSubmission: FormSubmission;
  createEventGroup: EventGroup;
  createForm: Form;
  createFormSubmission: FormSubmission;
  createGenericEvent: GenericEvent;
  createGroupPayMemberSetupIntent: StripeSetupIntent;
  createGuestUser: User;
  createKnowledgeArticle: KnowledgeArticle;
  createLead: Lead;
  createLeads: BulkOperation;
  createListing: Listing;
  createListingVisitedEvent: ListingVisitedEvent;
  createLodging: Lodging;
  createMessageTemplate: MessageTemplate;
  createMetaAdAndCampaign: CreateMetaAdAndCampaignResult;
  createNote: Note;
  createOnboarding: Onboarding;
  createOutfitterCustomProperty: OutfitterCustomProperty;
  createOutfitterDocument: OutfitterDocument;
  createOutfitterFromHubspotCompany: Outfitter;
  createOutfitterImages: Array<OutfitterImage>;
  createPaymentRequest: PaymentRequest;
  createPricingPackage: PricingPackage;
  createQuickPayPayment: Payment;
  createQuote: Quote;
  createQuoteRequest: QuoteRequest;
  createRefund: Refund;
  createResource: Resource;
  createSetupIntent: StripeSetupIntent;
  createSetupIntentOnBehalfOf: StripeSetupIntent;
  createSpecies: Species;
  createSyncedCalendar: SyncedCalendar;
  createTeamMember: TeamMember;
  createUser: User;
  createWidget: Widget;
  createWishlist: Wishlist;
  declineBooking: Booking;
  deleteEventGroup: EventGroup;
  deleteForm: Scalars['Void']['output'];
  deleteListing: Listing;
  deleteLodging?: Maybe<Scalars['Void']['output']>;
  deleteNote?: Maybe<Scalars['Void']['output']>;
  deleteOfflinePayment?: Maybe<Scalars['Void']['output']>;
  deletePaymentFeeSettings?: Maybe<Scalars['Void']['output']>;
  deletePaymentMethod: Array<PaymentBlock>;
  deleteResource?: Maybe<Scalars['Void']['output']>;
  deleteSpecies: Species;
  deleteTeamMember?: Maybe<Scalars['Void']['output']>;
  deleteUser: User;
  disableQuotePaymentGroup: Quote;
  disconnectMeta: DisconnectMetaResult;
  disconnectQuickBooks: QuickBooksDisconnectResult;
  duplicateBookingInvite: BookingInvite;
  duplicateForm: Form;
  duplicateListing: Listing;
  duplicateMessageTemplate: MessageTemplate;
  enableQuotePaymentGroup: Quote;
  initiateCustomEmailDomainAuth: OutfitterIntegrationSettings;
  initiateMetaConnection: InitiateConnectionResult;
  initiateQuickBooksConnection: InitiateConnectionResult;
  initiateTransferToOutfiterForPayment?: Maybe<Payment>;
  joinGroupPay: GroupPayShare;
  logInAsGuestUser: Scalars['String']['output'];
  logInAsGuestUserWithAccessCode: Scalars['String']['output'];
  markEntityAsRead: UnreadEntitiesMutationResult;
  markNoteAsUnread: Note;
  markNoteThreadAsRead: Array<Note>;
  markNoteThreadAsResolved: Array<Note>;
  markNoteThreadAsUnresolved: Array<Note>;
  markPaymentAsNotNeedingRefund: Payment;
  markPaymentAsPaidOffline: Payment;
  markPaymentAsRefunded: Payment;
  optOutClientFromMarketing: ClientMarketingOptOut;
  payPendingBookingPayment: Payment;
  processQuickPayPayment: Payment;
  processTerminalPaymentIntentForPaymentEntity: ProcessTerminalPaymentIntentResult;
  publishKnowledgeArticle: KnowledgeArticle;
  publishWebsite?: Maybe<Scalars['Void']['output']>;
  reassignOutfitterOwner: Outfitter;
  registerForSms: OutfitterTwilioConfiguration;
  removeAddOn?: Maybe<Scalars['Void']['output']>;
  removeContactsFromContactList: ContactList;
  removeCoupon?: Maybe<Scalars['Void']['output']>;
  removeCustomEmailDomain: OutfitterIntegrationSettings;
  removeOffsiteBooking?: Maybe<Scalars['Void']['output']>;
  removeOutfitter: Outfitter;
  removePackageFromQuote: Quote;
  removePricingPackage?: Maybe<Scalars['Void']['output']>;
  removeQuoteCoupon: Quote;
  removeWidget?: Maybe<Scalars['Void']['output']>;
  removeWishlist?: Maybe<Scalars['Void']['output']>;
  restoreTemplateToDefault: MessageTemplate;
  retryBookingTripInsurancePurchase: Booking;
  retryPayment: Payment;
  sendAwardedItem: AwardedItem;
  sendBookingNotification?: Maybe<Scalars['Void']['output']>;
  sendContactListMarketingEmail: BulkOperation;
  sendContactListMarketingSms: BulkOperation;
  sendContactMarketingEmail?: Maybe<Scalars['Void']['output']>;
  sendContactMarketingSms?: Maybe<Scalars['Void']['output']>;
  sendInvoice?: Maybe<Scalars['Void']['output']>;
  sendMessages?: Maybe<Scalars['Void']['output']>;
  sendNotificationTemplatePreviewMock?: Maybe<Scalars['Void']['output']>;
  sendTeamMemberInvite?: Maybe<Scalars['Void']['output']>;
  setDefaultPaymentMethod: Array<PaymentBlock>;
  setEntityCustomProperties: SetEntityCustomPropertiesResult;
  setRemainingPaymentIsArchived: RemainingPayment;
  startImpersonation?: Maybe<Scalars['Void']['output']>;
  stopImpersonation?: Maybe<Scalars['Void']['output']>;
  submitReviewForm?: Maybe<Scalars['Void']['output']>;
  suspendOutfitter: Outfitter;
  updateAddOn: AddOn;
  updateAddOnOrders: Array<AddOn>;
  updateAmenity: Amenity;
  updateAuction: Auction;
  updateAvailability?: Maybe<Scalars['Void']['output']>;
  updateBadge: Badge;
  updateBooking: Booking;
  updateBookingAttribution: Booking;
  updateBookingDatesGuestsAndAddons: Booking;
  updateBookingInvite: BookingInvite;
  updateCalendarEvent: CalendarEvent;
  updateCalendarSubscription: CalendarSubscription;
  updateContact: Contact;
  updateContactList: ContactList;
  updateDefaultAvailabilityRule: DefaultAvailabilityRule;
  updateESignCompliantFormSubmission: FormSubmission;
  updateEventGroup: EventGroup;
  updateEventOrganizer: EventOrganizer;
  updateFixedPriceBooking: Booking;
  updateForm: Form;
  updateFormSubmission: FormSubmission;
  updateGroupPayMember: GroupPayMember;
  updateKnowledgeArticle: KnowledgeArticle;
  updateLead: Lead;
  updateLeads: UpdateLeadsResult;
  updateLicenseInfo: LicenseInfo;
  updateListing: Listing;
  updateListingLodgings: Listing;
  updateListingRates: Listing;
  updateListingRatesAsOwner: Listing;
  updateListingsOrder: Array<Listing>;
  updateLodging: Lodging;
  updateMessageTemplate: MessageTemplate;
  updateMetaAd: UpdateMetaAdResult;
  updateNote: Note;
  updateOnboarding: Onboarding;
  updateOutfitter: Outfitter;
  updateOutfitterAutomationSetting: OutfitterAutomationSetting;
  updateOutfitterBadges: Outfitter;
  updateOutfitterDocument: OutfitterDocument;
  updateOutfitterFeatureAccessSettings?: Maybe<Scalars['Void']['output']>;
  updateOutfitterFees: Outfitter;
  updateOutfitterFeesAsOutfitterOwner: Outfitter;
  updateOutfitterRoleNotificationSettings: OutfitterRoleNotificationSettings;
  updateOutfitterSubscription?: Maybe<Scalars['Void']['output']>;
  updatePackageOnQuote: Quote;
  updatePayment: Payment;
  updatePaymentDueDate: Payment;
  updatePaymentMethodOnPayment: Payment;
  updatePricingPackage: PricingPackage;
  updatePricingPackagesOrder: Array<PricingPackage>;
  updateQuickBooksClassMapping: QuickBooksListingClassMapping;
  updateQuickBooksItemMapping: QuickBooksItemMapping;
  updateQuotePaymentDueDate: Quote;
  updateResource: Resource;
  updateSelfOnboardingStep: Outfitter;
  updateSpecies: Species;
  updateSyncedCalendar: SyncedCalendar;
  updateTeamMember: TeamMember;
  updateUser: User;
  updateUserNotificationPreferences: UserNotificationPreferences;
  updateWebsite: Website;
  updateWidget: Widget;
  updateWishlist: Wishlist;
  upsertOutfitterIntegrationSettings: OutfitterIntegrationSettings;
  upsertPaymentFeeSettings: PaymentFeeSettings;
  upsertPaymentSettings: PaymentSettings;
  verifyCustomEmailDomain: OutfitterIntegrationSettings;
  verifyMicroDeposits: Scalars['Boolean']['output'];
};


export type MutationAcceptAuctionBidsArgs = {
  acceptedBids: Array<AcceptedBidInput>;
};


export type MutationAcceptAvailabilityAiSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptAwardedItemArgs = {
  code: Scalars['String']['input'];
  data: AcceptAwardedItemInput;
  id: Scalars['ID']['input'];
};


export type MutationAcceptBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptPaymentRequestArgs = {
  data: AcceptPaymentRequestInput;
  id: Scalars['ID']['input'];
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationAcceptTeamMemberInvitationArgs = {
  invitationId: Scalars['ID']['input'];
  teamMemberId: Scalars['ID']['input'];
};


export type MutationAddContactsToContactListArgs = {
  contactIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationAddPackageToQuoteArgs = {
  data: AddPackageToQuoteInput;
  quoteId: Scalars['ID']['input'];
};


export type MutationApplyQuoteCouponArgs = {
  couponCode: Scalars['String']['input'];
  quoteId: Scalars['ID']['input'];
};


export type MutationArchiveBannerArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveBookingInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveCalendarEventArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveCalendarSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveContactListsArgs = {
  ids: Array<Scalars['ID']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationArchiveContactsArgs = {
  contactIds: Array<Scalars['ID']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationArchiveDefaultAvailabilityRuleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveLeadsArgs = {
  leadIds: Array<Scalars['ID']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationArchiveMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveNoteThreadArgs = {
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
  threadId: Scalars['String']['input'];
};


export type MutationArchiveOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveOutfitterCustomPropertiesArgs = {
  ids: Array<Scalars['ID']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationArchiveOutfitterDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveQuoteRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveSyncedCalendarArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAssignGuidesToBookingArgs = {
  data: AssignGuidesToBookingInput;
  id: Scalars['ID']['input'];
};


export type MutationAssignLodgingsToBookingArgs = {
  data: AssignLodgingsToBookingInput;
  id: Scalars['ID']['input'];
};


export type MutationAssignResourcesToBookingArgs = {
  data: AssignResourcesToBookingInput;
  id: Scalars['ID']['input'];
};


export type MutationBidOnAuctionArgs = {
  auctionRequestId: Scalars['ID']['input'];
  data: BidOnAuctionInput;
};


export type MutationCancelBookingArgs = {
  id: Scalars['ID']['input'];
  reason?: InputMaybe<CancelBookingReasonInput>;
  refunds?: InputMaybe<Array<CancelBookingRefundInput>>;
};


export type MutationCancelPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelPaymentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeUserPasswordArgs = {
  newPassword: Scalars['String']['input'];
};


export type MutationConfirmOfflinePaymentRequestArgs = {
  id: Scalars['ID']['input'];
};


export type MutationConvertGuestToUserArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationCreateAddOnArgs = {
  data: CreateAddOnInput;
};


export type MutationCreateAdditionalBookingPaymentArgs = {
  bookingId: Scalars['ID']['input'];
  data: CreateAdditionalBookingPaymentInput;
};


export type MutationCreateAiOnboardingArgs = {
  entityCreationScope?: InputMaybe<AiOnboardingEntityCreationScope>;
  outfitterId: Scalars['ID']['input'];
  sourceDocuments?: InputMaybe<Array<AiOnboardingSourceDocumentInput>>;
  sourceType?: InputMaybe<AiOnboardingSourceType>;
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAmenityArgs = {
  data: CreateAmenityInput;
};


export type MutationCreateAuctionArgs = {
  data: CreateAuctionInput;
};


export type MutationCreateBadgeArgs = {
  icon_url: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateBookingArgs = {
  data: CreateBookingInput;
};


export type MutationCreateBookingAsOutfitterArgs = {
  bookingInput: CreateBookingInput;
  isMallardBayProcessingPayment: Scalars['Boolean']['input'];
  isRequestingSportsmanPayment?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  paymentNotes?: InputMaybe<Scalars['String']['input']>;
  shouldEmailPaymentLinkToSportsman?: InputMaybe<Scalars['Boolean']['input']>;
  shouldSendSportsmanConfirmationNotification?: InputMaybe<Scalars['Boolean']['input']>;
  sportsmanId?: InputMaybe<Scalars['ID']['input']>;
  userInput: CreateUserInput;
};


export type MutationCreateBookingBulkImportArgs = {
  dataList: Array<ImportBookingInput>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateBookingForAwardedItemArgs = {
  data: CreateBookingForAwardedItemInput;
};


export type MutationCreateBookingInviteArgs = {
  data: CreateBookingInviteInput;
  isInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  referralId?: InputMaybe<Scalars['String']['input']>;
  shouldSendNotification?: InputMaybe<Scalars['Boolean']['input']>;
  userInput?: InputMaybe<EntityUserInput>;
};


export type MutationCreateBookingStartedEventArgs = {
  data: CreateBookingStartedEventInput;
};


export type MutationCreateBookingTripInsurancePolicyArgs = {
  data: TripInsurancePolicyInput;
};


export type MutationCreateCalendarSubscriptionArgs = {
  data: CreateCalendarSubscriptionInput;
  userId: Scalars['ID']['input'];
};


export type MutationCreateContactArgs = {
  data: CreateContactInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateContactListArgs = {
  data: ContactListInput;
};


export type MutationCreateContactsArgs = {
  dataList: Array<CreateContactInput>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateCouponArgs = {
  data: CreateCouponInput;
};


export type MutationCreateDefaultAvailabilityRuleArgs = {
  data: DefaultAvailabilityRuleInput;
};


export type MutationCreateESignCompliantFormSubmissionArgs = {
  data: CreateESignCompliantFormSubmissionInput;
  formId: Scalars['String']['input'];
  smsMarketingConsent?: InputMaybe<SmsMarketingConsentInput>;
};


export type MutationCreateEventGroupArgs = {
  data: CreateEventGroupInput;
};


export type MutationCreateFormArgs = {
  data: CreateFormInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateFormSubmissionArgs = {
  data: CreateFormSubmissionInput;
  formId: Scalars['String']['input'];
  smsMarketingConsent?: InputMaybe<SmsMarketingConsentInput>;
};


export type MutationCreateGenericEventArgs = {
  data: CreateGenericEventInput;
};


export type MutationCreateGroupPayMemberSetupIntentArgs = {
  memberId: Scalars['ID']['input'];
};


export type MutationCreateGuestUserArgs = {
  data: CreateUserInput;
};


export type MutationCreateKnowledgeArticleArgs = {
  input: CreateKnowledgeArticleInput;
};


export type MutationCreateLeadArgs = {
  data: CreateLeadInput;
  outfitter_id: Scalars['String']['input'];
};


export type MutationCreateLeadsArgs = {
  dataList: Array<CreateLeadInput>;
  outfitterId: Scalars['String']['input'];
  shouldDeduplicate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateListingArgs = {
  data: CreateListingInput;
};


export type MutationCreateListingVisitedEventArgs = {
  data: CreateListingVisitedEventInput;
};


export type MutationCreateLodgingArgs = {
  data: CreateLodgingInput;
};


export type MutationCreateMessageTemplateArgs = {
  data: CreateMessageTemplateInput;
};


export type MutationCreateMetaAdAndCampaignArgs = {
  createMetaAdAndCampaignInput: CreateMetaAdAndCampaignInput;
};


export type MutationCreateNoteArgs = {
  data: CreateNoteInput;
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
};


export type MutationCreateOnboardingArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateOutfitterCustomPropertyArgs = {
  data: CreateOutfitterCustomPropertyInput;
};


export type MutationCreateOutfitterDocumentArgs = {
  data: CreateOutfitterDocumentInput;
};


export type MutationCreateOutfitterFromHubspotCompanyArgs = {
  companyId: Scalars['String']['input'];
};


export type MutationCreateOutfitterImagesArgs = {
  images: Array<CreateOutfitterImageInput>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreatePaymentRequestArgs = {
  booking: Scalars['ID']['input'];
  data: CreatePaymentRequestInput;
  isMallardBayProcessingPayment?: InputMaybe<Scalars['Boolean']['input']>;
  paymentData?: InputMaybe<ExternalPaymentInfoInput>;
};


export type MutationCreatePricingPackageArgs = {
  data: CreatePricingPackageInput;
  listing: Scalars['ID']['input'];
};


export type MutationCreateQuickPayPaymentArgs = {
  data: CreateQuickPayPaymentInput;
};


export type MutationCreateQuoteArgs = {
  data: CreateQuoteInput;
};


export type MutationCreateQuoteRequestArgs = {
  data: QuoteRequestInput;
};


export type MutationCreateRefundArgs = {
  data: CreateRefundInput;
};


export type MutationCreateResourceArgs = {
  data: CreateResourceInput;
};


export type MutationCreateSetupIntentArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateSetupIntentOnBehalfOfArgs = {
  data: CreateSetupIntentOnBehalfOfInput;
};


export type MutationCreateSpeciesArgs = {
  data: CreateSpeciesInput;
};


export type MutationCreateSyncedCalendarArgs = {
  data: SyncedCalendarInput;
};


export type MutationCreateTeamMemberArgs = {
  data: CreateTeamMemberInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationCreateUserArgs = {
  data: CreateUserInput;
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateWidgetArgs = {
  data: CreateWidgetInput;
};


export type MutationCreateWishlistArgs = {
  data: CreateWishlistInput;
};


export type MutationDeclineBookingArgs = {
  denialReasons?: InputMaybe<Array<DenialReasonInput>>;
  id: Scalars['ID']['input'];
};


export type MutationDeleteEventGroupArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteListingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLodgingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteNoteArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteOfflinePaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentFeeSettingsArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeletePaymentMethodArgs = {
  groupPayMemberId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteResourceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSpeciesArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTeamMemberArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableQuotePaymentGroupArgs = {
  quoteId: Scalars['ID']['input'];
};


export type MutationDisconnectMetaArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type MutationDisconnectQuickBooksArgs = {
  disconnectData: QuickBooksDisconnectInput;
};


export type MutationDuplicateBookingInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateFormArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateListingArgs = {
  data?: InputMaybe<DuplicateListingInput>;
  id: Scalars['ID']['input'];
};


export type MutationDuplicateMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableQuotePaymentGroupArgs = {
  hostSlots: Scalars['PositiveInt']['input'];
  quoteId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationInitiateCustomEmailDomainAuthArgs = {
  data: CustomEmailDomainConfigInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationInitiateMetaConnectionArgs = {
  connectionData: MetaConnectionInput;
};


export type MutationInitiateQuickBooksConnectionArgs = {
  connectionData: QuickBooksConnectionInput;
};


export type MutationInitiateTransferToOutfiterForPaymentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationJoinGroupPayArgs = {
  input: JoinGroupPayInput;
};


export type MutationLogInAsGuestUserArgs = {
  data: GuestUserInput;
};


export type MutationLogInAsGuestUserWithAccessCodeArgs = {
  code: Scalars['String']['input'];
};


export type MutationMarkEntityAsReadArgs = {
  entityId: Scalars['String']['input'];
  entityType: EntityType;
};


export type MutationMarkNoteAsUnreadArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkNoteThreadAsReadArgs = {
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
  threadId: Scalars['String']['input'];
};


export type MutationMarkNoteThreadAsResolvedArgs = {
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
  threadId: Scalars['String']['input'];
};


export type MutationMarkNoteThreadAsUnresolvedArgs = {
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
  threadId: Scalars['String']['input'];
};


export type MutationMarkPaymentAsNotNeedingRefundArgs = {
  id: Scalars['ID']['input'];
};


export type MutationMarkPaymentAsPaidOfflineArgs = {
  id: Scalars['ID']['input'];
  paymentData: ExternalPaymentInfoInput;
};


export type MutationMarkPaymentAsRefundedArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOptOutClientFromMarketingArgs = {
  clientId: Scalars['ID']['input'];
  outfitterId: Scalars['ID']['input'];
};


export type MutationPayPendingBookingPaymentArgs = {
  invitationId: Scalars['ID']['input'];
  paymentId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationProcessQuickPayPaymentArgs = {
  invitationId?: InputMaybe<Scalars['ID']['input']>;
  paymentId: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationProcessTerminalPaymentIntentForPaymentEntityArgs = {
  paymentIntentId: Scalars['String']['input'];
};


export type MutationPublishKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPublishWebsiteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReassignOutfitterOwnerArgs = {
  outfitterId: Scalars['ID']['input'];
  ownerId: Scalars['ID']['input'];
};


export type MutationRegisterForSmsArgs = {
  data: RegisterForSmsInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationRemoveAddOnArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveContactsFromContactListArgs = {
  contactIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationRemoveCouponArgs = {
  id: Scalars['String']['input'];
};


export type MutationRemoveCustomEmailDomainArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type MutationRemoveOffsiteBookingArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveOutfitterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemovePackageFromQuoteArgs = {
  packageId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
};


export type MutationRemovePricingPackageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveQuoteCouponArgs = {
  quoteId: Scalars['ID']['input'];
};


export type MutationRemoveWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveWishlistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRestoreTemplateToDefaultArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRetryBookingTripInsurancePurchaseArgs = {
  data: RetryBookingTripInsurancePurchaseInput;
};


export type MutationRetryPaymentArgs = {
  data: RetryPaymentInput;
  id: Scalars['ID']['input'];
};


export type MutationSendAwardedItemArgs = {
  data: SendAwardedItemInput;
  id: Scalars['ID']['input'];
};


export type MutationSendBookingNotificationArgs = {
  bookingId: Scalars['ID']['input'];
  customEmail?: InputMaybe<Scalars['EmailAddress']['input']>;
  groupPayMemberId?: InputMaybe<Scalars['ID']['input']>;
  type: NotificationType;
};


export type MutationSendContactListMarketingEmailArgs = {
  data: SendContactListMarketingEmailInput;
};


export type MutationSendContactListMarketingSmsArgs = {
  data: SendContactListMarketingSmsInput;
};


export type MutationSendContactMarketingEmailArgs = {
  data: SendContactMarketingEmailInput;
};


export type MutationSendContactMarketingSmsArgs = {
  data: SendContactMarketingSmsInput;
};


export type MutationSendInvoiceArgs = {
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type MutationSendMessagesArgs = {
  customMessage?: InputMaybe<CustomMessageInput>;
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  toList: Array<MessageTo>;
  topicEntityId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendNotificationTemplatePreviewMockArgs = {
  customMessage?: InputMaybe<CustomMessageInput>;
  email: Scalars['EmailAddress']['input'];
  messageRecipientType: MessageRecipientType;
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendTeamMemberInviteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultPaymentMethodArgs = {
  id: Scalars['String']['input'];
};


export type MutationSetEntityCustomPropertiesArgs = {
  entityId: Scalars['ID']['input'];
  entityType: CustomPropertyEntityType;
  properties: Array<EntityCustomPropertyInput>;
};


export type MutationSetRemainingPaymentIsArchivedArgs = {
  id: Scalars['ID']['input'];
  is_archived: Scalars['Boolean']['input'];
};


export type MutationStartImpersonationArgs = {
  actsAsUserId: Scalars['ID']['input'];
};


export type MutationSubmitReviewFormArgs = {
  data: SubmitReviewFormInput;
};


export type MutationSuspendOutfitterArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUpdateAddOnArgs = {
  data: UpdateAddOnInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAddOnOrdersArgs = {
  data: Array<UpdateAddOnOrderInput>;
};


export type MutationUpdateAmenityArgs = {
  data: UpdateAmenityInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAuctionArgs = {
  data: UpdateAuctionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateAvailabilityArgs = {
  data: AvailabilityUpdateInput;
};


export type MutationUpdateBadgeArgs = {
  data: BadgeInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingArgs = {
  data: UpdateBookingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingAttributionArgs = {
  data: AttributionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingDatesGuestsAndAddonsArgs = {
  data: UpdateBookingDatesGuestsAndAddonsInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateBookingInviteArgs = {
  data: UpdateBookingInviteInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCalendarEventArgs = {
  data: UpdateCalendarEventInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCalendarSubscriptionArgs = {
  data: UpdateCalendarSubscriptionInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContactArgs = {
  data: UpdateContactInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateContactListArgs = {
  data: UpdateContactListInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateDefaultAvailabilityRuleArgs = {
  data: UpdateDefaultAvailabilityRuleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateESignCompliantFormSubmissionArgs = {
  data: UpdateESignCompliantFormSubmissionInput;
  id: Scalars['ID']['input'];
  smsMarketingConsent?: InputMaybe<SmsMarketingConsentInput>;
};


export type MutationUpdateEventGroupArgs = {
  data: UpdateEventGroupInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateEventOrganizerArgs = {
  data: UpdateEventOrganizerInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFixedPriceBookingArgs = {
  data: UpdateFixedPriceBookingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFormArgs = {
  data: UpdateFormInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateFormSubmissionArgs = {
  data: UpdateFormSubmissionInput;
  id: Scalars['ID']['input'];
  smsMarketingConsent?: InputMaybe<SmsMarketingConsentInput>;
};


export type MutationUpdateGroupPayMemberArgs = {
  id: Scalars['ID']['input'];
  input: UpdateGroupPayMemberInput;
};


export type MutationUpdateKnowledgeArticleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeArticleInput;
};


export type MutationUpdateLeadArgs = {
  data: UpdateLeadInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateLeadsArgs = {
  data: BulkUpdateLeadsInput;
  leadIds: Array<Scalars['ID']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateLicenseInfoArgs = {
  data: UpdateLicenseInfoInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateListingArgs = {
  aiSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  data: UpdateListingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateListingLodgingsArgs = {
  listingId: Scalars['ID']['input'];
  lodgingIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateListingRatesArgs = {
  data: UpdateListingRatesInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateListingRatesAsOwnerArgs = {
  data: UpdateListingRatesAsOwnerInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateListingsOrderArgs = {
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateLodgingArgs = {
  data: UpdateLodgingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateMessageTemplateArgs = {
  data: UpdateMessageTemplateInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateMetaAdArgs = {
  outfitterId: Scalars['ID']['input'];
  updateMetaAdInput: UpdateMetaAdInput;
};


export type MutationUpdateNoteArgs = {
  data: UpdateNoteInput;
  id: Scalars['String']['input'];
};


export type MutationUpdateOnboardingArgs = {
  data: UpdateOnboardingInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterArgs = {
  aiSuggestionId?: InputMaybe<Scalars['ID']['input']>;
  data: UpdateOutfitterInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterAutomationSettingArgs = {
  automationType: AutomationType;
  data: UpdateOutfitterAutomationSettingInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterBadgesArgs = {
  badgeIds: Array<Scalars['ID']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterDocumentArgs = {
  data: UpdateOutfitterDocumentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterFeatureAccessSettingsArgs = {
  features: Array<FeatureAccessInput>;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterFeesArgs = {
  data: UpdateOutfitterFeesInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterFeesAsOutfitterOwnerArgs = {
  data: UpdateOutfitterFeesAsOutfitterOwnerInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterRoleNotificationSettingsArgs = {
  data: UpdateOutfitterRoleNotificationSettingsInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateOutfitterSubscriptionArgs = {
  data: UpdateOutfitterSubscriptionInput;
};


export type MutationUpdatePackageOnQuoteArgs = {
  data: UpdatePackageOnQuoteInput;
  packageId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
};


export type MutationUpdatePaymentArgs = {
  data: UpdatePaymentInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePaymentDueDateArgs = {
  date: Scalars['Timestamp']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdatePaymentMethodOnPaymentArgs = {
  id: Scalars['ID']['input'];
  paymentMethodId: Scalars['String']['input'];
};


export type MutationUpdatePricingPackageArgs = {
  data: UpdatePricingPackageInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdatePricingPackagesOrderArgs = {
  orderedIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateQuickBooksClassMappingArgs = {
  data: QuickBooksClassMappingInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateQuickBooksItemMappingArgs = {
  data: QuickBooksItemMappingInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpdateQuotePaymentDueDateArgs = {
  dueDate: Scalars['Timestamp']['input'];
  paymentPlanPaymentId: Scalars['ID']['input'];
  quoteId: Scalars['ID']['input'];
  quotePaymentPlanId: Scalars['ID']['input'];
};


export type MutationUpdateResourceArgs = {
  data: UpdateResourceInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSelfOnboardingStepArgs = {
  id: Scalars['ID']['input'];
  step: SelfOnboardingStepType;
};


export type MutationUpdateSpeciesArgs = {
  data: UpdateSpeciesInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateSyncedCalendarArgs = {
  data: SyncedCalendarUpdateInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateTeamMemberArgs = {
  data: UpdateTeamMemberInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUserArgs = {
  data: UpdateUserInput;
};


export type MutationUpdateUserNotificationPreferencesArgs = {
  contextEntityId: Scalars['ID']['input'];
  contextEntityType: NotificationPreferencesEntityType;
  data: UpdateUserNotificationPreferencesInput;
};


export type MutationUpdateWebsiteArgs = {
  data: UpdateWebsiteInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWidgetArgs = {
  data: UpdateWidgetInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWishlistArgs = {
  data: UpdateWishlistInput;
  id: Scalars['ID']['input'];
};


export type MutationUpsertOutfitterIntegrationSettingsArgs = {
  data: UpsertOutfitterIntegrationSettingsInput;
  outfitterId: Scalars['ID']['input'];
};


export type MutationUpsertPaymentFeeSettingsArgs = {
  data: UpsertPaymentFeeSettingsInput;
};


export type MutationUpsertPaymentSettingsArgs = {
  data: UpsertPaymentSettingsInput;
};


export type MutationVerifyCustomEmailDomainArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type MutationVerifyMicroDepositsArgs = {
  amount1?: InputMaybe<Scalars['Float']['input']>;
  amount2?: InputMaybe<Scalars['Float']['input']>;
  descriptorCode?: InputMaybe<Scalars['String']['input']>;
  paymentId?: InputMaybe<Scalars['ID']['input']>;
  setupIntentId?: InputMaybe<Scalars['String']['input']>;
};

export type NavigationMenuGroup = {
  __typename?: 'NavigationMenuGroup';
  items: Array<NavigationMenuItem>;
  label?: Maybe<Scalars['String']['output']>;
};

export type NavigationMenuItem = {
  __typename?: 'NavigationMenuItem';
  feature_status?: Maybe<FeatureStatus>;
  gate?: Maybe<FeatureGate>;
  icon_feature_key: FeatureIconKey;
  is_external_link: Scalars['Boolean']['output'];
  is_paywalled: Scalars['Boolean']['output'];
  label: Scalars['String']['output'];
  route?: Maybe<Scalars['String']['output']>;
  screen_name?: Maybe<ScreenName>;
  url: Scalars['String']['output'];
};

export type NewsfeedEvent = BaseEvent & {
  __typename?: 'NewsfeedEvent';
  created_at: Scalars['Timestamp']['output'];
  event_type: EventType;
  id: Scalars['ID']['output'];
  metadata: NewsfeedEventMetadata;
  updated_at: Scalars['Timestamp']['output'];
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type NewsfeedEventMetadata = {
  __typename?: 'NewsfeedEventMetadata';
  activity_id: Scalars['String']['output'];
  entity_id: Scalars['ID']['output'];
  entity_type: EntityType;
};

export type Note = {
  __typename?: 'Note';
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  entity_id: Scalars['String']['output'];
  entity_type: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  is_resolved?: Maybe<Scalars['Boolean']['output']>;
  is_start_of_thread?: Maybe<Scalars['Boolean']['output']>;
  is_unread?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Array<Media>>;
  number_of_replies: Scalars['NonNegativeInt']['output'];
  thread_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<PublicUser>;
};

export enum NotesEntityType {
  Booking = 'BOOKING',
  ClientDetails = 'CLIENT_DETAILS',
  Lead = 'LEAD',
  Payment = 'PAYMENT',
  Website = 'WEBSITE'
}

export enum NotificationChannel {
  Email = 'EMAIL',
  Sms = 'SMS'
}

export enum NotificationPreferencesEntityType {
  Outfitter = 'OUTFITTER'
}

export type NotificationSendLog = {
  __typename?: 'NotificationSendLog';
  channel: NotificationChannel;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  message: SendLogMessage;
  recipient_email?: Maybe<Scalars['String']['output']>;
  recipient_id: Scalars['String']['output'];
  recipient_phone?: Maybe<Scalars['String']['output']>;
  recipient_type: MessageRecipientType;
  sender_type: NotificationSenderType;
  sender_user_id?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  topic: Scalars['String']['output'];
  topic_entity_id?: Maybe<Scalars['String']['output']>;
  topic_entity_type?: Maybe<EntityType>;
  updated_at: Scalars['Timestamp']['output'];
};

export type NotificationSendLogsFilters = {
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type NotificationSendLogsResults = {
  __typename?: 'NotificationSendLogsResults';
  count: Scalars['Int']['output'];
  data: Array<NotificationSendLog>;
  pages: Scalars['Int']['output'];
};

export enum NotificationSenderType {
  MallardBay = 'MALLARD_BAY',
  Outfitter = 'OUTFITTER'
}

export type NotificationSettingInput = {
  channels: Array<UserNotificationPreferenceChannel>;
  topic: NotificationTopic;
};

export type NotificationTemplatePreviewEmail = {
  __typename?: 'NotificationTemplatePreviewEmail';
  html: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type NotificationTemplatePreviewResult = {
  __typename?: 'NotificationTemplatePreviewResult';
  channel: MessageTemplateChannel;
  email?: Maybe<NotificationTemplatePreviewEmail>;
  sms?: Maybe<NotificationTemplatePreviewSms>;
  warnings: Array<NotificationTemplatePreviewWarning>;
};

export type NotificationTemplatePreviewSms = {
  __typename?: 'NotificationTemplatePreviewSms';
  content: Scalars['String']['output'];
};

export type NotificationTemplatePreviewWarning = {
  __typename?: 'NotificationTemplatePreviewWarning';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum NotificationTopic {
  Auctions = 'AUCTIONS',
  BookingCanceled = 'BOOKING_CANCELED',
  BookingConfirmed = 'BOOKING_CONFIRMED',
  BookingRequests = 'BOOKING_REQUESTS',
  BookingUpdated = 'BOOKING_UPDATED',
  FormSubmissions = 'FORM_SUBMISSIONS',
  Leads = 'LEADS',
  Mentions = 'MENTIONS',
  Payments = 'PAYMENTS',
  PaymentReminders = 'PAYMENT_REMINDERS',
  QuoteRequests = 'QUOTE_REQUESTS',
  Reviews = 'REVIEWS',
  System = 'SYSTEM',
  WeeklyDigest = 'WEEKLY_DIGEST'
}

export enum NotificationType {
  AiOnboardingCrawlWebsite = 'ai_onboarding_crawl_website',
  AiOnboardingCreateEntities = 'ai_onboarding_create_entities',
  AiOnboardingParseEntities = 'ai_onboarding_parse_entities',
  AiOnboardingPrepareSource = 'ai_onboarding_prepare_source',
  AiOnboardingUploadImages = 'ai_onboarding_upload_images',
  AuctionBidAcceptedOutfitter = 'auction_bid_accepted_outfitter',
  AuctionRequestCreatedOutfitter = 'auction_request_created_outfitter',
  AwardedItemAcceptedEventOrganizer = 'awarded_item_accepted_event_organizer',
  AwardedItemAcceptedOutfitter = 'awarded_item_accepted_outfitter',
  AwardedItemWinner = 'awarded_item_winner',
  BidOnAuctionEventOrganizer = 'bid_on_auction_event_organizer',
  BookingCanceled = 'booking_canceled',
  BookingClientPropertyEvent = 'booking_client_property_event',
  BookingConfirmedSportsman = 'booking_confirmed_sportsman',
  BookingDeclined = 'booking_declined',
  BookingInvite = 'booking_invite',
  BookingInviteInvoice = 'booking_invite_invoice',
  BookingReceipt = 'booking_receipt',
  BookingRequestReviewSportsman = 'booking_request_review_sportsman',
  BookingRequestedSportsman = 'booking_requested_sportsman',
  BookingStartsSoonWithFailedPayments = 'booking_starts_soon_with_failed_payments',
  BookingUpdated = 'booking_updated',
  CreateBookingFormSubmissions = 'create_booking_form_submissions',
  CreateUnreadEntities = 'create_unread_entities',
  DashboardBookingPaymentRequest = 'dashboard_booking_payment_request',
  FailedPaymentOutfitter = 'failed_payment_outfitter',
  FailedPaymentSportsman = 'failed_payment_sportsman',
  FormSubmissionCompletedOutfitter = 'form_submission_completed_outfitter',
  FormSubmissionCompletedSportsman = 'form_submission_completed_sportsman',
  GearListSportsman = 'gear_list_sportsman',
  GuideAddedToBooking = 'guide_added_to_booking',
  LeadCoolingAlertOutfitter = 'lead_cooling_alert_outfitter',
  LeadCreated = 'lead_created',
  LeadIngested = 'lead_ingested',
  MetaConnectionsExpiring = 'meta_connections_expiring',
  NoteMention = 'note_mention',
  OnboardingPaymentLink = 'onboarding_payment_link',
  OnboardingSignUpInvite = 'onboarding_sign_up_invite',
  PaymentActions = 'payment_actions',
  PaymentMethodsWaitingForVerification = 'payment_methods_waiting_for_verification',
  PaymentRequestCreated = 'payment_request_created',
  PaymentRequestReceipt = 'payment_request_receipt',
  PaymentRequestReminder = 'payment_request_reminder',
  PaymentRequestUrgentReminder = 'payment_request_urgent_reminder',
  PreTripReminderSportsman = 'pre_trip_reminder_sportsman',
  PurchaseBookingInsurance = 'purchase_booking_insurance',
  PurchaseGroupPayShareInsurance = 'purchase_group_pay_share_insurance',
  QuickPayReceipt = 'quick_pay_receipt',
  QuoteReminderSportsman = 'quote_reminder_sportsman',
  QuoteRequestCreated = 'quote_request_created',
  ReferralAccepted = 'referral_accepted',
  ReferralCreated = 'referral_created',
  ReferralDeclined = 'referral_declined',
  ReferralNoLongerAvailable = 'referral_no_longer_available',
  RefundCreated = 'refund_created',
  SmsConsentOptIn = 'sms_consent_opt_in',
  TripDetailReminderSportsman = 'trip_detail_reminder_sportsman',
  WeeklyDigestOutfitter = 'weekly_digest_outfitter'
}

export type OffsetDaysConfig = {
  __typename?: 'OffsetDaysConfig';
  /** Whether the offset days feature is enabled for this automation. */
  is_offset_days_enabled: Scalars['Boolean']['output'];
  /** Days after the trigger event to run the automation. Must be a non-negative integer (0 = same day). */
  offset_days: Scalars['NonNegativeInt']['output'];
  /** Label to display for the offset days setting. */
  offset_days_label?: Maybe<Scalars['String']['output']>;
};

export type OffsetDaysConfigInput = {
  offset_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type Onboarding = {
  __typename?: 'Onboarding';
  add_ons: Array<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  email?: Maybe<Scalars['String']['output']>;
  errors: Array<PaymentError>;
  hubspot_company_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_currently_free_tier?: Maybe<Scalars['Boolean']['output']>;
  is_draft: Scalars['Boolean']['output'];
  is_legacy?: Maybe<Scalars['Boolean']['output']>;
  is_self_initiated?: Maybe<Scalars['Boolean']['output']>;
  outfitter?: Maybe<Outfitter>;
  payment_link_id?: Maybe<Scalars['String']['output']>;
  payment_link_url?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  promo_codes: Array<Scalars['String']['output']>;
  status: OnboardingStatus;
  subscription_tier_name?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<Scalars['String']['output']>;
  team_member?: Maybe<TeamMember>;
  updated_at: Scalars['Timestamp']['output'];
};

export type OnboardingFilters = {
  status?: InputMaybe<OnboardingStatus>;
};

export type OnboardingPaymentSummaryInput = {
  add_ons: Array<Scalars['String']['input']>;
  products: Array<Scalars['String']['input']>;
  promo_codes: Array<Scalars['String']['input']>;
};

export type OnboardingQueryResults = {
  __typename?: 'OnboardingQueryResults';
  results: Array<Onboarding>;
  total: Scalars['NonNegativeInt']['output'];
};

export enum OnboardingStatus {
  Initiated = 'INITIATED',
  ReadyForOutfitterPayment = 'READY_FOR_OUTFITTER_PAYMENT',
  Subscribed = 'SUBSCRIBED'
}

export type OnboardingStatusInfo = {
  __typename?: 'OnboardingStatusInfo';
  email?: Maybe<Scalars['String']['output']>;
  has_account: Scalars['Boolean']['output'];
  status: OnboardingStatus;
};

export type OnboardingSubscriptionOptions = {
  __typename?: 'OnboardingSubscriptionOptions';
  add_ons: Array<IdAndName>;
  products: Array<IdAndName>;
  promo_codes: Array<IdAndName>;
};

export type OnboardingTask = {
  __typename?: 'OnboardingTask';
  action: OnboardingTaskAction;
  blocked_feature_keys: Array<FeatureKey>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  is_complete: Scalars['Boolean']['output'];
  related_feature_keys: Array<FeatureKey>;
  title: Scalars['String']['output'];
};

export type OnboardingTaskAction = {
  __typename?: 'OnboardingTaskAction';
  action: DashboardActionType;
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OnboardingTaskSection = {
  __typename?: 'OnboardingTaskSection';
  description: Scalars['String']['output'];
  icon_feature_key: FeatureIconKey;
  id: Scalars['String']['output'];
  progress_percentage: Scalars['NonNegativeInt']['output'];
  tasks: Array<OnboardingTask>;
  title: Scalars['String']['output'];
};

/** A type that describes an outfitter */
export type Outfitter = {
  __typename?: 'Outfitter';
  about: Scalars['String']['output'];
  admin_note?: Maybe<Scalars['String']['output']>;
  ads_score?: Maybe<Scalars['PositiveInt']['output']>;
  avatar?: Maybe<Media>;
  badges?: Maybe<Array<Badge>>;
  booking_fee_fixed: Scalars['Float']['output'];
  booking_fee_rate: Scalars['Float']['output'];
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  cancellation_policy: OutfitterCancellationPolicy;
  check_in_config?: Maybe<CheckInConfig>;
  /** @deprecated Use primary_contact_email and primary_contact_phone instead */
  contacts?: Maybe<Array<OutfitterContact>>;
  coupons?: Maybe<Array<Coupon>>;
  cover_image?: Maybe<Scalars['URL']['output']>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  current_self_onboard_step?: Maybe<SelfOnboardingStepType>;
  default_check_in_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  default_check_out_minutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  enabled_integrations: EnabledOutfitterIntegrations;
  faqs?: Maybe<Array<FaqItem>>;
  feature_access: FeatureAccess;
  feature_set_id?: Maybe<Scalars['String']['output']>;
  featured: Scalars['Boolean']['output'];
  gmb_id?: Maybe<Scalars['String']['output']>;
  guides: Array<TeamMember>;
  hubspot_company_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_ach_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_archived: Scalars['Boolean']['output'];
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  is_free_tier_subscription: Scalars['Boolean']['output'];
  is_guide_tech?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_marketplace?: Maybe<Scalars['Boolean']['output']>;
  is_legacy_subscription: Scalars['Boolean']['output'];
  is_onboarding_flow_skipped?: Maybe<Scalars['Boolean']['output']>;
  is_processing_fee_payed_by_sportsman?: Maybe<Scalars['Boolean']['output']>;
  is_self_onboard_skipped?: Maybe<Scalars['Boolean']['output']>;
  is_self_onboarded?: Maybe<Scalars['Boolean']['output']>;
  is_stripe_terminal_enabled?: Maybe<Scalars['Boolean']['output']>;
  is_website_chat_widget_enabled?: Maybe<Scalars['Boolean']['output']>;
  land_size?: Maybe<Scalars['PositiveInt']['output']>;
  licensed: Scalars['Boolean']['output'];
  listings: Array<Listing>;
  listings_count: Scalars['NonNegativeInt']['output'];
  location?: Maybe<Address>;
  lodging_instructions?: Maybe<Scalars['String']['output']>;
  lodging_rules?: Maybe<Scalars['String']['output']>;
  lodgings: Array<Lodging>;
  mailing_address?: Maybe<Address>;
  max_booking_fee: Scalars['Float']['output'];
  meeting_location?: Maybe<Address>;
  my_roles: Array<TeamMember>;
  name: Scalars['String']['output'];
  other_info?: Maybe<OutfitterOtherInfo>;
  /** @deprecated Use Payment Fee Settings instead. */
  outfitter_fee_fixed: Scalars['Float']['output'];
  /** @deprecated Use Payment Fee Settings instead. */
  outfitter_fee_rate: Scalars['Float']['output'];
  owner: User;
  payment_fee_settings?: Maybe<PaymentFeeSettings>;
  photos: Array<Media>;
  primary_contact_email?: Maybe<Scalars['EmailAddress']['output']>;
  primary_contact_phone?: Maybe<Scalars['PhoneNumber']['output']>;
  processing_fee_ach_fixed: Scalars['Float']['output'];
  processing_fee_ach_max: Scalars['NonNegativeInt']['output'];
  processing_fee_ach_rate: Scalars['Float']['output'];
  processing_fee_fixed: Scalars['Float']['output'];
  processing_fee_rate: Scalars['Float']['output'];
  ranking_score?: Maybe<Scalars['NonNegativeInt']['output']>;
  resources: Array<Resource>;
  slug: Scalars['String']['output'];
  species: Array<Species>;
  status: OutfitterStatus;
  stripe_location_id?: Maybe<Scalars['String']['output']>;
  stripe_subscription_id?: Maybe<Scalars['String']['output']>;
  subscription_tier_name?: Maybe<Scalars['String']['output']>;
  tax_definitions?: Maybe<Array<OutfitterTaxDefinition>>;
  tax_rate: Scalars['Float']['output'];
  time_zone?: Maybe<Scalars['TimeZone']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  verified: Scalars['Boolean']['output'];
  video?: Maybe<Video>;
  website?: Maybe<Scalars['String']['output']>;
  years_in_operation: Scalars['PositiveInt']['output'];
};

export type OutfitterAssistantSuggestionsInput = {
  screen_name: ScreenName;
};

export enum OutfitterAssistantToolExecutionTarget {
  Client = 'CLIENT',
  Hybrid = 'HYBRID',
  Server = 'SERVER'
}

export type OutfitterAutomationRun = {
  __typename?: 'OutfitterAutomationRun';
  automation_type: AutomationType;
  channels?: Maybe<Array<MessageTemplateChannel>>;
  created_at: Scalars['Timestamp']['output'];
  entities_processed_count?: Maybe<Scalars['Int']['output']>;
  entity_id?: Maybe<Scalars['String']['output']>;
  entity_type?: Maybe<EntityType>;
  error?: Maybe<AutomationRunError>;
  id: Scalars['ID']['output'];
  notification_requests_created_count?: Maybe<Scalars['Int']['output']>;
  outfitter_id: Scalars['ID']['output'];
  ran_at: Scalars['Timestamp']['output'];
  scheduled_time?: Maybe<Scalars['String']['output']>;
  status: AutomationRunStatus;
  trigger_type?: Maybe<AutomationTriggerType>;
  updated_at: Scalars['Timestamp']['output'];
};

export type OutfitterAutomationSetting = {
  __typename?: 'OutfitterAutomationSetting';
  automation_group: AutomationGroup;
  automation_trigger_type: AutomationTriggerType;
  automation_type: AutomationType;
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  offset_days_config: OffsetDaysConfig;
  outfitter_id: Scalars['ID']['output'];
  schedule_times: Array<Scalars['String']['output']>;
  steps: Array<AutomationStep>;
  trigger: AutomationTrigger;
  updated_at: Scalars['Timestamp']['output'];
};

export type OutfitterAutomationSettingsByGroup = {
  __typename?: 'OutfitterAutomationSettingsByGroup';
  automation_group: AutomationGroup;
  settings: Array<OutfitterAutomationSetting>;
};

export enum OutfitterBookingCalendarGroupingOption {
  Atv = 'ATV',
  Blind = 'BLIND',
  Boat = 'BOAT',
  Gear = 'GEAR',
  Hourly = 'HOURLY',
  Listing = 'LISTING',
  Lodging = 'LODGING',
  TeamMember = 'TEAM_MEMBER',
  Vehicle = 'VEHICLE'
}

export type OutfitterBookingClient = {
  __typename?: 'OutfitterBookingClient';
  id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
  user: OutfitterClientUser;
};

export type OutfitterBookingsFilters = {
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<BookingStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type OutfitterCancellationPolicy = {
  __typename?: 'OutfitterCancellationPolicy';
  description: Scalars['String']['output'];
  policy_id: Scalars['String']['output'];
};

export type OutfitterCancellationPolicyInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  policy_id: Scalars['String']['input'];
};

export type OutfitterClient = {
  __typename?: 'OutfitterClient';
  booking_invites?: Maybe<Array<BookingInvite>>;
  bookings?: Maybe<Array<Booking>>;
  date_added?: Maybe<Scalars['Timestamp']['output']>;
  gross_revenue?: Maybe<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  last_booking_date?: Maybe<Scalars['Timestamp']['output']>;
  leads?: Maybe<Array<Lead>>;
  marketing_opt_out: ContactMarketingOptOutStatus;
  metrics: Array<Metric>;
  notes: Array<Note>;
  number_of_prior_bookings?: Maybe<Scalars['NonNegativeInt']['output']>;
  outfitter_id: Scalars['ID']['output'];
  quote_requests?: Maybe<Array<QuoteRequest>>;
  source?: Maybe<ReferralSource>;
  stage: ContactStage;
  user: OutfitterClientUser;
};

export type OutfitterClientUser = {
  __typename?: 'OutfitterClientUser';
  avatar_url?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last_name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type OutfitterContact = {
  __typename?: 'OutfitterContact';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  is_primary_contact?: Maybe<Scalars['Boolean']['output']>;
  linkedin?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  snapchat?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  title: OutfitterContactTitle;
  twitter?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
};

export type OutfitterContactInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  is_primary_contact?: InputMaybe<Scalars['Boolean']['input']>;
  linkedin?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  snapchat?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  title: OutfitterContactTitle;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  youtube?: InputMaybe<Scalars['String']['input']>;
};

export enum OutfitterContactTitle {
  Guide = 'Guide',
  Manager = 'Manager',
  Marketing = 'Marketing',
  Other = 'Other',
  Owner = 'Owner',
  Sales = 'Sales',
  Secretary = 'Secretary'
}

export type OutfitterCustomPropertiesFilters = {
  entity_type?: InputMaybe<CustomPropertyEntityType>;
  property_type?: InputMaybe<CustomPropertyType>;
};

export type OutfitterCustomPropertiesResults = {
  __typename?: 'OutfitterCustomPropertiesResults';
  count: Scalars['Int']['output'];
  data: Array<OutfitterCustomProperty>;
  pages: Scalars['Int']['output'];
};

export type OutfitterCustomProperty = CustomPropertyFields & {
  __typename?: 'OutfitterCustomProperty';
  created_at: Scalars['Timestamp']['output'];
  description: Scalars['String']['output'];
  entity_type: CustomPropertyEntityType;
  format_type?: Maybe<CustomPropertyFormatType>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_select: Scalars['Boolean']['output'];
  is_system_defined: Scalars['Boolean']['output'];
  /** @deprecated Use is_system_defined instead */
  is_system_property: Scalars['Boolean']['output'];
  outfitter_id?: Maybe<Scalars['ID']['output']>;
  property_key: Scalars['String']['output'];
  property_label: Scalars['String']['output'];
  property_type: CustomPropertyType;
  updated_at: Scalars['Timestamp']['output'];
};

export type OutfitterDocument = {
  __typename?: 'OutfitterDocument';
  created_at: Scalars['Timestamp']['output'];
  document?: Maybe<Media>;
  external_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  listing_ids?: Maybe<Array<Scalars['String']['output']>>;
  listings?: Maybe<Array<Listing>>;
  name: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  pricing_package_ids?: Maybe<Array<Scalars['String']['output']>>;
  pricing_packages?: Maybe<Array<PricingPackage>>;
  type: OutfitterDocumentType;
  updated_at: Scalars['Timestamp']['output'];
};

export enum OutfitterDocumentEntityType {
  Listing = 'Listing',
  PricingPackage = 'PricingPackage'
}

export enum OutfitterDocumentType {
  LiabilityWaiver = 'LiabilityWaiver',
  WhatToExpect = 'WhatToExpect'
}

export type OutfitterFeatureAccessInfo = {
  __typename?: 'OutfitterFeatureAccessInfo';
  available_features: Array<FeatureKey>;
  current_features: Array<FeatureAccessSetting>;
};

export type OutfitterForImpersonationSearchResult = {
  __typename?: 'OutfitterForImpersonationSearchResult';
  auto_select_member?: Maybe<ImpersonationMember>;
  members: Array<ImpersonationMember>;
  outfitter: Outfitter;
};

export type OutfitterImage = {
  __typename?: 'OutfitterImage';
  alt_text?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  url: Scalars['String']['output'];
};

export enum OutfitterImageEmbeddingStatus {
  Embedded = 'EMBEDDED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  Skipped = 'SKIPPED'
}

export type OutfitterImageGroup = {
  __typename?: 'OutfitterImageGroup';
  images: Array<OutfitterImage>;
  resource_id?: Maybe<Scalars['ID']['output']>;
  resource_type?: Maybe<ResourceType>;
  title: Scalars['String']['output'];
};

export enum OutfitterImageSearchMatchType {
  FullText = 'FULL_TEXT',
  Vector = 'VECTOR'
}

export enum OutfitterImageSearchMode {
  FullText = 'FULL_TEXT',
  Vector = 'VECTOR'
}

export type OutfitterImageSearchResult = {
  __typename?: 'OutfitterImageSearchResult';
  distance?: Maybe<Scalars['Float']['output']>;
  image: OutfitterImage;
  match_type: OutfitterImageSearchMatchType;
  score?: Maybe<Scalars['Float']['output']>;
};

export type OutfitterIntegrationSettings = {
  __typename?: 'OutfitterIntegrationSettings';
  created_at: Scalars['Timestamp']['output'];
  custom_email_domain?: Maybe<CustomEmailDomainConfig>;
  id: Scalars['ID']['output'];
  quick_books?: Maybe<QuickBooksIntegrationSettings>;
  updated_at: Scalars['Timestamp']['output'];
};

export type OutfitterOtherInfo = {
  __typename?: 'OutfitterOtherInfo';
  domain?: Maybe<Scalars['String']['output']>;
  has_website?: Maybe<Scalars['Boolean']['output']>;
  listings_type?: Maybe<ListingType>;
  nearest_airport?: Maybe<Scalars['String']['output']>;
  offers_corporate_trips?: Maybe<Scalars['Boolean']['output']>;
  required_licenses?: Maybe<Array<Scalars['String']['output']>>;
  what_to_bring?: Maybe<Scalars['String']['output']>;
};

export type OutfitterOtherInfoInput = {
  domain?: InputMaybe<Scalars['String']['input']>;
  has_website?: InputMaybe<Scalars['Boolean']['input']>;
  listings_type?: InputMaybe<ListingType>;
  nearest_airport?: InputMaybe<Scalars['String']['input']>;
  offers_corporate_trips?: InputMaybe<Scalars['Boolean']['input']>;
  required_licenses?: InputMaybe<Array<Scalars['String']['input']>>;
  what_to_bring?: InputMaybe<Scalars['String']['input']>;
};

export type OutfitterRoleNotificationSettings = {
  __typename?: 'OutfitterRoleNotificationSettings';
  enabled_notification_topics: Array<NotificationTopic>;
  outfitter_id: Scalars['ID']['output'];
  role: TeamMemberRole;
};

export type OutfitterRoleNotificationSettingsResult = {
  __typename?: 'OutfitterRoleNotificationSettingsResult';
  catalog: UserNotificationPreferenceCatalog;
  settings: Array<OutfitterRoleNotificationSettings>;
};

export type OutfitterSearchResults = {
  __typename?: 'OutfitterSearchResults';
  pages: Scalars['NonNegativeInt']['output'];
  results: Array<Outfitter>;
  total: Scalars['NonNegativeInt']['output'];
};

export type OutfitterSlugResult = {
  __typename?: 'OutfitterSlugResult';
  slug: Scalars['String']['output'];
  valid: Scalars['Boolean']['output'];
};

export enum OutfitterStatus {
  Approved = 'APPROVED',
  PendingApproval = 'PENDING_APPROVAL',
  Suspended = 'SUSPENDED'
}

export type OutfitterSubscriptionInfo = {
  __typename?: 'OutfitterSubscriptionInfo';
  add_ons: Array<Scalars['String']['output']>;
  current_period_end: Scalars['String']['output'];
  current_period_start: Scalars['String']['output'];
  outfitter_name: Scalars['String']['output'];
  products: Array<Scalars['String']['output']>;
  promo_codes: Array<Scalars['String']['output']>;
  subscription_start: Scalars['String']['output'];
  subscription_tier_name: Scalars['String']['output'];
};

export type OutfitterTaxDefinition = {
  __typename?: 'OutfitterTaxDefinition';
  code?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  sort_order?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type OutfitterTaxDefinitionInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  sort_order?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type OutfitterTeamMemberPeriodDigest = {
  __typename?: 'OutfitterTeamMemberPeriodDigest';
  end_date: Scalars['Timestamp']['output'];
  entity_stats: Array<OutfitterTeamMemberPeriodDigestEntityStat>;
  formatted_period: Scalars['String']['output'];
  start_date: Scalars['Timestamp']['output'];
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  upcoming_bookings: Array<Booking>;
};

export enum OutfitterTeamMemberPeriodDigestEntity {
  Bookings = 'BOOKINGS',
  FormSubmissions = 'FORM_SUBMISSIONS',
  Leads = 'LEADS',
  QuoteRequests = 'QUOTE_REQUESTS'
}

export type OutfitterTeamMemberPeriodDigestEntityStat = {
  __typename?: 'OutfitterTeamMemberPeriodDigestEntityStat';
  color_scheme: DashboardSearchTagColor;
  entity: OutfitterTeamMemberPeriodDigestEntity;
  feature_key: FeatureIconKey;
  new_count: Scalars['NonNegativeInt']['output'];
  title: Scalars['String']['output'];
  unread_count: Scalars['NonNegativeInt']['output'];
  url: Scalars['String']['output'];
};

export type OutfitterTwilioConfiguration = {
  __typename?: 'OutfitterTwilioConfiguration';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_marketing_setup_completed?: Maybe<Scalars['Boolean']['output']>;
  is_transactional_setup_completed?: Maybe<Scalars['Boolean']['output']>;
  outfitter_id: Scalars['ID']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type OutfitterWebsiteTrackingAggregatedData = {
  __typename?: 'OutfitterWebsiteTrackingAggregatedData';
  device_type_breakdown: DeviceTypeBreakdown;
  top_pages: Array<PageRouteMetric>;
  top_referrers: Array<ReferrerMetric>;
};

export type OutfitterWebsiteTrackingMetrics = {
  __typename?: 'OutfitterWebsiteTrackingMetrics';
  avg_session_duration: Array<Metric>;
  new_users: Array<Metric>;
  new_users_percentage: Metric;
  page_views: Array<Metric>;
  sessions: Array<Metric>;
  time_series: Array<Metric>;
  total_users: Array<Metric>;
};

export type OutfittersForImpersonationSearchResults = {
  __typename?: 'OutfittersForImpersonationSearchResults';
  pages: Scalars['NonNegativeInt']['output'];
  results: Array<OutfitterForImpersonationSearchResult>;
  total: Scalars['NonNegativeInt']['output'];
};

export type PackageInput = {
  add_ons: Array<QuoteAddOnInput>;
  id: Scalars['ID']['input'];
  line_item_key?: InputMaybe<Scalars['ID']['input']>;
  number_of_guests: Scalars['PositiveInt']['input'];
  pricing_package: Scalars['ID']['input'];
};

export type PageRouteMetric = {
  __typename?: 'PageRouteMetric';
  route: Scalars['String']['output'];
  session_count: Scalars['Int']['output'];
};

export type PageSubsection = {
  __typename?: 'PageSubsection';
  items: Array<PageSubsectionItem>;
  label: Scalars['String']['output'];
  sub_label?: Maybe<Scalars['String']['output']>;
};

export type PageSubsectionItem = {
  __typename?: 'PageSubsectionItem';
  cta_url?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  sub_label?: Maybe<Scalars['String']['output']>;
};

export type PaginatedAuditLogs = {
  __typename?: 'PaginatedAuditLogs';
  count: Scalars['Int']['output'];
  data: Array<AuditLog>;
  pages: Scalars['Int']['output'];
};

export type PaginatedFormSubmissions = {
  __typename?: 'PaginatedFormSubmissions';
  count: Scalars['Int']['output'];
  data: Array<FormSubmission>;
  pages: Scalars['Int']['output'];
};

export type PaginatedForms = {
  __typename?: 'PaginatedForms';
  count: Scalars['Int']['output'];
  data: Array<Form>;
  pages: Scalars['Int']['output'];
};

export type PaginatedLeadList = {
  __typename?: 'PaginatedLeadList';
  count: Scalars['Int']['output'];
  data: Array<Lead>;
  pages: Scalars['Int']['output'];
};

export type PaginatedOutfitterAutomationRuns = {
  __typename?: 'PaginatedOutfitterAutomationRuns';
  count: Scalars['Int']['output'];
  data: Array<OutfitterAutomationRun>;
  pages: Scalars['Int']['output'];
};

export type PaginatedOutfitterClientList = {
  __typename?: 'PaginatedOutfitterClientList';
  count: Scalars['Int']['output'];
  data: Array<OutfitterClient>;
  pages: Scalars['Int']['output'];
};

export type PaginatedOutfitterList = {
  __typename?: 'PaginatedOutfitterList';
  count: Scalars['Int']['output'];
  data?: Maybe<Array<Outfitter>>;
  pages: Scalars['Int']['output'];
};

export type Paging = {
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Payment = {
  __typename?: 'Payment';
  booking?: Maybe<Booking>;
  booking_fee: Scalars['Float']['output'];
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  customer?: Maybe<PaymentCustomer>;
  date: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  errors: Array<PaymentError>;
  external_payment_reference_id?: Maybe<Scalars['String']['output']>;
  external_payment_type?: Maybe<ExternalPaymentType>;
  group_pay_member?: Maybe<GroupPayMember>;
  id: Scalars['ID']['output'];
  intent_id?: Maybe<Scalars['String']['output']>;
  invoice_id?: Maybe<Scalars['String']['output']>;
  is_ach?: Maybe<Scalars['Boolean']['output']>;
  is_additional_booking_payment?: Maybe<Scalars['Boolean']['output']>;
  is_offline?: Maybe<Scalars['Boolean']['output']>;
  is_payment_method_unverified?: Maybe<Scalars['Boolean']['output']>;
  is_quick_pay?: Maybe<Scalars['Boolean']['output']>;
  is_refund_needed?: Maybe<Scalars['Boolean']['output']>;
  mb_amount: Scalars['Float']['output'];
  note?: Maybe<Scalars['String']['output']>;
  outfitter: Outfitter;
  outfitter_amount: Scalars['Float']['output'];
  outfitter_fee: Scalars['Float']['output'];
  payment_method_id?: Maybe<Scalars['String']['output']>;
  payment_processor_type?: Maybe<PaymentProcessorType>;
  payment_request?: Maybe<PaymentRequest>;
  payment_url?: Maybe<Scalars['URL']['output']>;
  processing_fee: Scalars['Float']['output'];
  rates?: Maybe<Rates>;
  /** @deprecated Booking referrals removed; retained for older mobile clients. */
  referral_fee?: Maybe<Scalars['NonNegativeInt']['output']>;
  refund_needed_note?: Maybe<Scalars['String']['output']>;
  refunds: Array<Refund>;
  retries?: Maybe<Array<PaymentRetry>>;
  sales_tax: Scalars['Float']['output'];
  service_fee: Scalars['Float']['output'];
  should_charge_last_day_of_trip?: Maybe<Scalars['Boolean']['output']>;
  status: PaymentStatus;
  stripe_user_id?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  transfer_by?: Maybe<User>;
  transfer_date?: Maybe<Scalars['Timestamp']['output']>;
  transfer_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  value: Scalars['Float']['output'];
  was_refunded?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentBlock = {
  __typename?: 'PaymentBlock';
  brand?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_default?: Maybe<Scalars['Boolean']['output']>;
  is_pending?: Maybe<Scalars['Boolean']['output']>;
  payment_gateway: PaymentGateway;
  setup_intent_id?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  subtitle2?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<PaymentBlockType>;
};

export enum PaymentBlockType {
  BankAccount = 'BANK_ACCOUNT',
  Card = 'CARD'
}

export type PaymentCustomer = {
  __typename?: 'PaymentCustomer';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
};

export type PaymentCustomerInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type PaymentError = {
  __typename?: 'PaymentError';
  code?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Timestamp']['output']>;
  message: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentErrorInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
};

export type PaymentFeeSettings = {
  __typename?: 'PaymentFeeSettings';
  created_at: Scalars['Timestamp']['output'];
  dashboard_rate: Scalars['NonNegativeFloat']['output'];
  entity_id: Scalars['ID']['output'];
  entity_type: PaymentFeeSettingsEntityType;
  id: Scalars['ID']['output'];
  is_overriding: Scalars['Boolean']['output'];
  marketplace_quote_rate: Scalars['NonNegativeFloat']['output'];
  standard_quote_rate: Scalars['NonNegativeFloat']['output'];
  updated_at: Scalars['Timestamp']['output'];
  website_rate: Scalars['NonNegativeFloat']['output'];
  widget_rate: Scalars['NonNegativeFloat']['output'];
};

export enum PaymentFeeSettingsEntityType {
  Listing = 'LISTING',
  Outfitter = 'OUTFITTER',
  SubscriptionTier = 'SUBSCRIPTION_TIER'
}

export enum PaymentGateway {
  Stripe = 'STRIPE'
}

export type PaymentItemRequest = {
  __typename?: 'PaymentItemRequest';
  add_on_id?: Maybe<Scalars['ID']['output']>;
  amount: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  remaining_payment_id?: Maybe<Scalars['ID']['output']>;
};

export type PaymentItemRequestInput = {
  amount: Scalars['Float']['input'];
  currency?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  remaining_payment_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum PaymentPlanType {
  PayInFull = 'PAY_IN_FULL',
  PayInTwo = 'PAY_IN_TWO'
}

export enum PaymentProcessorType {
  Stripe = 'STRIPE'
}

export type PaymentRequest = {
  __typename?: 'PaymentRequest';
  add_ons?: Maybe<Array<PaymentRequestAddOn>>;
  booking: Booking;
  created_at: Scalars['Timestamp']['output'];
  created_by: User;
  currency?: Maybe<Scalars['String']['output']>;
  errors: Array<PaymentError>;
  id: Scalars['ID']['output'];
  intent_id?: Maybe<Scalars['String']['output']>;
  invoice_id?: Maybe<Scalars['String']['output']>;
  items: Array<PaymentItemRequest>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  outfitter: Outfitter;
  paid_offline?: Maybe<Scalars['Boolean']['output']>;
  payment_method_id?: Maybe<Scalars['String']['output']>;
  payments: Array<Payment>;
  processing_fee?: Maybe<Scalars['NonNegativeInt']['output']>;
  sales_tax?: Maybe<Scalars['NonNegativeInt']['output']>;
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  should_include_taxes?: Maybe<Scalars['Boolean']['output']>;
  sportsman: User;
  status: PaymentRequestStatus;
  subtotal?: Maybe<Scalars['NonNegativeInt']['output']>;
  timing?: Maybe<PaymentRequestTiming>;
  type?: Maybe<PaymentRequestType>;
  updated_at: Scalars['Timestamp']['output'];
  value: Scalars['Float']['output'];
  was_acknowledged_by_sportsman?: Maybe<Scalars['Boolean']['output']>;
};

export type PaymentRequestAddOn = {
  __typename?: 'PaymentRequestAddOn';
  id: Scalars['ID']['output'];
  number_of_days?: Maybe<Scalars['PositiveInt']['output']>;
  number_of_guests?: Maybe<Scalars['PositiveInt']['output']>;
  quantity: Scalars['PositiveInt']['output'];
  total: Scalars['Int']['output'];
};

export type PaymentRequestAddOnInput = {
  id: Scalars['ID']['input'];
  number_of_days?: InputMaybe<Scalars['PositiveInt']['input']>;
  number_of_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  quantity: Scalars['PositiveInt']['input'];
};

export enum PaymentRequestStatus {
  Accepted = 'ACCEPTED',
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Requested = 'REQUESTED',
  Success = 'SUCCESS'
}

export enum PaymentRequestTiming {
  DuringTrip = 'DURING_TRIP',
  PostTrip = 'POST_TRIP',
  PreTrip = 'PRE_TRIP'
}

export enum PaymentRequestType {
  Card = 'CARD',
  Cash = 'CASH',
  Check = 'CHECK',
  EmailInvoice = 'EMAIL_INVOICE',
  Other = 'OTHER',
  QrCode = 'QR_CODE',
  StripeTerminal = 'STRIPE_TERMINAL'
}

export type PaymentResults = {
  __typename?: 'PaymentResults';
  count: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  payments: Array<Payment>;
};

export type PaymentRetry = {
  __typename?: 'PaymentRetry';
  by?: Maybe<User>;
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type PaymentSettings = {
  __typename?: 'PaymentSettings';
  allow_deposit: Scalars['Boolean']['output'];
  amount_deposit?: Maybe<Scalars['Int']['output']>;
  created_at: Scalars['Timestamp']['output'];
  day_balance_due_config?: Maybe<DayBalanceDueConfig>;
  days_before_trip_balance_due?: Maybe<Scalars['Int']['output']>;
  days_out_for_deposit_plan?: Maybe<Scalars['Int']['output']>;
  entity_id: Scalars['ID']['output'];
  entity_type: PaymentSettingsEntityType;
  id: Scalars['ID']['output'];
  is_deposit_per_day?: Maybe<Scalars['Boolean']['output']>;
  is_deposit_per_guest?: Maybe<Scalars['Boolean']['output']>;
  percent_deposit?: Maybe<Scalars['Int']['output']>;
  should_charge_last_day_of_trip?: Maybe<Scalars['Boolean']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum PaymentSettingsEntityType {
  Listing = 'LISTING',
  Outfitter = 'OUTFITTER'
}

export enum PaymentStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  FailedTransfer = 'FAILED_TRANSFER',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Replaced = 'REPLACED',
  Success = 'SUCCESS',
  Unpaid = 'UNPAID'
}

export type PaymentSummary = {
  __typename?: 'PaymentSummary';
  line_items: Array<LineItem>;
  prices: Array<QuotePrice>;
  /** @deprecated Use totals instead. */
  total: Scalars['Int']['output'];
  totals: Array<QuotePrice>;
};

export type PaymentSummaryInput = {
  attribution?: InputMaybe<AttributionInput>;
  coupon?: InputMaybe<Scalars['ID']['input']>;
  dates: Array<Scalars['Timestamp']['input']>;
  packages: Array<PackageInput>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type Payout = {
  __typename?: 'Payout';
  amount: Scalars['Int']['output'];
  arrival_date: Scalars['Timestamp']['output'];
  automatic: Scalars['Boolean']['output'];
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<PayoutDestination>;
  destination_display_name?: Maybe<Scalars['String']['output']>;
  failure_code?: Maybe<Scalars['String']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  method: Scalars['String']['output'];
  processor_type: PaymentProcessorType;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status: PayoutStatus;
  status_display_name: Scalars['String']['output'];
  timeline: Array<PayoutTimeline>;
};

export type PayoutDestination = {
  __typename?: 'PayoutDestination';
  bank_name?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  last4: Scalars['String']['output'];
};

export enum PayoutStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  InTransit = 'IN_TRANSIT',
  Paid = 'PAID',
  Pending = 'PENDING',
  Unknown = 'UNKNOWN',
  Withdrawn = 'WITHDRAWN'
}

export type PayoutTimeline = {
  __typename?: 'PayoutTimeline';
  description: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
};

export type PayoutTransaction = {
  __typename?: 'PayoutTransaction';
  id: Scalars['ID']['output'];
  payment?: Maybe<Payment>;
  payment_intent_id?: Maybe<Scalars['String']['output']>;
  transaction_amount: Scalars['Int']['output'];
  transaction_date: Scalars['Timestamp']['output'];
  transaction_fee: Scalars['Int']['output'];
  transaction_net: Scalars['Int']['output'];
  transaction_type: Scalars['String']['output'];
};

export type PayoutsList = {
  __typename?: 'PayoutsList';
  info: CursorPaginationInfo;
  payouts: Array<Payout>;
};

export type PendingAsyncTask = {
  __typename?: 'PendingAsyncTask';
  label: Scalars['String']['output'];
  type: PendingAsyncTaskType;
};

export enum PendingAsyncTaskType {
  CreateFormSubmissions = 'CREATE_FORM_SUBMISSIONS',
  Generic = 'GENERIC'
}

export type PortalEntitiesAdminSearchInput = {
  paging: Paging;
  portalType: PortalType;
  searchText: Scalars['String']['input'];
};

export type PortalEntitiesResponse = {
  __typename?: 'PortalEntitiesResponse';
  event_organizers: Array<EventOrganizer>;
  outfitters: Array<Outfitter>;
  portal_types: Array<PortalType>;
};

export enum PortalType {
  Outfitter = 'OUTFITTER',
  RegionalDirector = 'REGIONAL_DIRECTOR'
}

export type PreCheckoutData = {
  __typename?: 'PreCheckoutData';
  is_ach_available: Scalars['Boolean']['output'];
};

export enum PriceByDay {
  Hourly = 'HOURLY',
  PerDay = 'PER_DAY',
  SetDay = 'SET_DAY'
}

export enum PriceByGuest {
  PerGuest = 'PER_GUEST',
  SetGuest = 'SET_GUEST'
}

export type PriceSubsection = {
  __typename?: 'PriceSubsection';
  category?: Maybe<QuotePriceCategory>;
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type Pricing = {
  __typename?: 'Pricing';
  options: Array<PricingOption>;
  type: PricingType;
};

export type PricingInput = {
  options: Array<PricingOptionInput>;
  type: PricingType;
};

export type PricingOption = {
  __typename?: 'PricingOption';
  currency?: Maybe<Scalars['String']['output']>;
  day_rate: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  max: Scalars['PositiveInt']['output'];
  min: Scalars['NonNegativeInt']['output'];
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type PricingOptionInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  day_rate: Scalars['Float']['input'];
  id: Scalars['ID']['input'];
  max: Scalars['PositiveInt']['input'];
  min: Scalars['NonNegativeInt']['input'];
  name: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
};

export type PricingPackage = {
  __typename?: 'PricingPackage';
  applied_tax_definition_ids?: Maybe<Array<Scalars['ID']['output']>>;
  bookable_time_windows?: Maybe<Array<CheckoutCalendarAvailabilityTimeWindow>>;
  check_in_config?: Maybe<CheckInConfig>;
  created_for_entity_id?: Maybe<Scalars['ID']['output']>;
  created_for_entity_type?: Maybe<EntityType>;
  days_included: Scalars['NonNegativeInt']['output'];
  duration_minutes?: Maybe<Scalars['PositiveInt']['output']>;
  gear_rentals: Array<AddOn>;
  guests_included: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  included_add_ons: Array<AddOn>;
  included_lodging_id?: Maybe<Scalars['ID']['output']>;
  included_resource_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  is_active: Scalars['Boolean']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_available?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_outfitters?: Maybe<Scalars['Boolean']['output']>;
  is_hidden_from_sportsmen?: Maybe<Scalars['Boolean']['output']>;
  is_lodging_only?: Maybe<Scalars['Boolean']['output']>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  listing: Listing;
  lodging_included: Scalars['Boolean']['output'];
  max_guests?: Maybe<Scalars['PositiveInt']['output']>;
  meal_upgrades: Array<AddOn>;
  min_guests?: Maybe<Scalars['PositiveInt']['output']>;
  name: Scalars['String']['output'];
  not_available_reason?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['PositiveInt']['output']>;
  other_add_ons: Array<AddOn>;
  owner: User;
  price: Scalars['Float']['output'];
  price_by_day: PriceByDay;
  price_by_guest: PriceByGuest;
  start_times?: Maybe<Array<Scalars['NonNegativeInt']['output']>>;
  trophies: Array<AddOn>;
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
};

export enum PricingType {
  PerGuest = 'PER_GUEST'
}

export type ProcessTerminalPaymentIntentResult = {
  __typename?: 'ProcessTerminalPaymentIntentResult';
  payment: Payment;
  payment_request?: Maybe<PaymentRequest>;
};

export type PublicBooking = {
  __typename?: 'PublicBooking';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  listing: PublicListing;
  listing_id: Scalars['ID']['output'];
};

export type PublicKnowledgeArticle = {
  __typename?: 'PublicKnowledgeArticle';
  id: Scalars['ID']['output'];
  product: KnowledgeProduct;
  published_at?: Maybe<Scalars['Timestamp']['output']>;
  slug: Scalars['String']['output'];
  summary?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type PublicKnowledgeArticleContent = {
  __typename?: 'PublicKnowledgeArticleContent';
  article: PublicKnowledgeArticle;
  sections: Array<PublicKnowledgeSection>;
};

export type PublicKnowledgeSection = {
  __typename?: 'PublicKnowledgeSection';
  article_id: Scalars['ID']['output'];
  blocks: Array<KnowledgeBlock>;
  heading: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  media_refs: Array<KnowledgeMediaRef>;
  order: Scalars['Int']['output'];
  plain_text: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  version: Scalars['Int']['output'];
};

export type PublicListing = {
  __typename?: 'PublicListing';
  amenities: Array<Amenity>;
  badges?: Maybe<Array<Badge>>;
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  cover_image?: Maybe<Scalars['URL']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  gear_list?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_unavailable?: Maybe<Scalars['Boolean']['output']>;
  liability_waivers?: Maybe<Array<OutfitterDocument>>;
  license_info?: Maybe<LicenseInfo>;
  license_required?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Address>;
  lodgings: Array<PublicLodging>;
  lowest_pricing_package?: Maybe<PublicPricingPackage>;
  max_guest?: Maybe<Scalars['PositiveInt']['output']>;
  min_guest?: Maybe<Scalars['PositiveInt']['output']>;
  next_availability?: Maybe<GenericAvailabilityEntry>;
  outfitter: PublicOutfitter;
  photos: Array<Media>;
  published?: Maybe<Scalars['Boolean']['output']>;
  rule?: Maybe<Scalars['String']['output']>;
  should_allow_quote_requests?: Maybe<Scalars['Boolean']['output']>;
  species: Array<Species>;
  time_zone?: Maybe<Scalars['TimeZone']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ListingType>;
  what_to_expect_documents?: Maybe<Array<OutfitterDocument>>;
};

export type PublicListingSearchResults = {
  __typename?: 'PublicListingSearchResults';
  results: Array<PublicListing>;
  total: Scalars['NonNegativeInt']['output'];
};

export type PublicLodging = {
  __typename?: 'PublicLodging';
  capacity: Scalars['PositiveInt']['output'];
  cover_image: Scalars['URL']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Media>>;
  location?: Maybe<Address>;
  name: Scalars['String']['output'];
  type: LodgingType;
  type_name: Scalars['String']['output'];
};

export type PublicOutfitter = {
  __typename?: 'PublicOutfitter';
  about: Scalars['String']['output'];
  avatar?: Maybe<Media>;
  badges?: Maybe<Array<Badge>>;
  booking_reviews_aggregation?: Maybe<ReviewAggregation>;
  cover_image?: Maybe<Scalars['URL']['output']>;
  created_at: Scalars['Timestamp']['output'];
  faqs?: Maybe<Array<FaqItem>>;
  guides: Array<PublicTeamMember>;
  id: Scalars['ID']['output'];
  is_demo?: Maybe<Scalars['Boolean']['output']>;
  listings: Array<PublicListing>;
  listings_count: Scalars['NonNegativeInt']['output'];
  location?: Maybe<Address>;
  lodgings: Array<PublicLodging>;
  name: Scalars['String']['output'];
  owner: PublicUser;
  photos: Array<Media>;
  resources: Array<Resource>;
  slug: Scalars['String']['output'];
  status: OutfitterStatus;
  video?: Maybe<Video>;
};

export type PublicOutfitterSearchResults = {
  __typename?: 'PublicOutfitterSearchResults';
  results: Array<PublicOutfitter>;
  total: Scalars['NonNegativeInt']['output'];
};

export type PublicPricingPackage = {
  __typename?: 'PublicPricingPackage';
  price: Scalars['Float']['output'];
};

export type PublicTeamMember = {
  __typename?: 'PublicTeamMember';
  avatar?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  role: TeamMemberRole;
  user?: Maybe<PublicUser>;
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type PublicTeamMemberResults = {
  __typename?: 'PublicTeamMemberResults';
  data: Array<PublicTeamMember>;
};

export type PublicUser = {
  __typename?: 'PublicUser';
  avatar_url?: Maybe<Scalars['URL']['output']>;
  bio: Scalars['String']['output'];
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_guest_conversion_disabled?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  socials?: Maybe<UserSocials>;
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['Void']['output']>;
  additionalBookingPaymentSummary: PaymentSummary;
  additionalPaymentSummary: AdditionalPaymentSummary;
  adminAiContext: Scalars['JSONObject']['output'];
  adminSearchLeads: PaginatedLeadList;
  adminSearchQuoteRequests: QuoteRequestSearchResults;
  aiConversationMessages: AiConversationMessagesResult;
  aiConversations: AiConversationsResult;
  aiOnboarding?: Maybe<AiOnboarding>;
  aiOnboardingById?: Maybe<AiOnboarding>;
  allAmenities: Array<Amenity>;
  allCoupons?: Maybe<Array<Coupon>>;
  allLicenseInfos: Array<LicenseInfo>;
  allSpecies: Array<Species>;
  appPrompts: Array<AppPrompt>;
  auction: Auction;
  auctionRequest: AuctionRequest;
  auctionRequests: AuctionRequestsResults;
  auctions: AuctionsResults;
  availability: Array<GenericAvailabilityEntry>;
  availableDatesAndTimesForCheckoutCalendar: Array<CheckoutCalendarDateWithTimeWindows>;
  availableDatesForCalendarEventResources: Array<Scalars['Timestamp']['output']>;
  availableDatesForEditBooking: Array<CheckoutCalendarDateWithTimeWindows>;
  awardedItem: AwardedItem;
  awardedItems: AwardedItemsResults;
  badges?: Maybe<Array<Badge>>;
  booking: Booking;
  bookingCancellationInfo: BookingCancellationInfo;
  /** get all attribution options for a booking deal */
  bookingDealAttributionOptions: Array<DealAttributionOption>;
  bookingInvite: BookingInvite;
  bookingInviteDealAttributionOptions: Array<DealAttributionOption>;
  bookingInviteInvoicePreview: Scalars['String']['output'];
  bookingInvites: BookingInvitesResults;
  /** Preview of changes from booking update */
  bookingUpdatesPreview: Array<ValueChange>;
  /** Query bookings by a user */
  bookings: Array<Booking>;
  bulkOperation: BulkOperation;
  bulkOperations: BulkOperationsResults;
  calendarEvent: CalendarEvent;
  calendarEvents: Array<CalendarEvent>;
  calendarEventsByResourceType: Array<CalendarEventsByResourceTypeRow>;
  calendarSubscription: CalendarSubscription;
  canConvertGuestToUser: Scalars['Boolean']['output'];
  cancellationPolicies: Array<CancellationPolicy>;
  contact: Contact;
  contactList: ContactList;
  contactListContacts: ContactsResults;
  contactListPreviewContacts: ContactsResults;
  contactLists: ContactListsResults;
  contacts: ContactsResults;
  couponsByOutfitter?: Maybe<Array<Coupon>>;
  dashboardCheckoutMaxAvailableSlots: CheckoutMaxSlots;
  /** Get dashboard home page data */
  dashboardHome: DashboardHome;
  dashboardNavigationMenu: Array<NavigationMenuGroup>;
  /** Search across all dashboard content */
  dashboardSearch: DashboardSearchResults;
  defaultAvailabilityRule: DefaultAvailabilityRule;
  defaultAvailabilityRulesForResource: DefaultAvailabilityRulesResults;
  denialReasons: Array<DenialReason>;
  draftQuote: DraftQuote;
  entityListCounts: CountsResponse;
  eventOrganizer: EventOrganizer;
  exportContactsCsv: Media;
  exportPaymentsCsvByOutfitter: Media;
  exportRemainingPaymentsCsvByOutfitter: Media;
  featureGate?: Maybe<FeatureGate>;
  form: Form;
  formSubmission: FormSubmission;
  formSubmissionPdf?: Maybe<Scalars['String']['output']>;
  formSubmissions: PaginatedFormSubmissions;
  forms: PaginatedForms;
  getAddOnsByListingAndOfferPeriod: Array<AddOn>;
  getAddOnsByOutfitterAndOfferPeriod: Array<AddOn>;
  getBookingInvitePaymentSummary: PaymentSummary;
  getCalendarSubscriptions?: Maybe<CalendarSubscriptionsResults>;
  getCourierInboxAuthToken: Scalars['String']['output'];
  getDefaultImage?: Maybe<Scalars['String']['output']>;
  getEntityCustomProperties: GetEntityCustomPropertiesResult;
  getEventGroup: EventGroup;
  getEventGroups: EventGroupsResults;
  getExtraAddOnsForListingAndPricingPackage: Array<AddOn>;
  getInvoicePdf?: Maybe<Scalars['String']['output']>;
  getMetaAdAccounts: MetaAdAccountsResults;
  getMetaAdCampaigns: MetaAdCampaignsResults;
  getMetaAdMetrics: MetaAdMetricsResult;
  getMetaAdSets: MetaAdSetsResults;
  getMetaAds: MetaAdsResults;
  getMetaAggregatedAdMetrics: MetaAggregatedAdMetricsResult;
  getMetric: Metric;
  getMetricsByOutfitterAndKeys: Array<Metric>;
  getOrCreateOutfitterWebsite: Website;
  getOutfitterAutomationSetting?: Maybe<OutfitterAutomationSetting>;
  getOutfitterAutomationSettingsByGroup: Array<OutfitterAutomationSettingsByGroup>;
  getOutfitterCustomProperties: OutfitterCustomPropertiesResults;
  getOutfitterIntegrationSettings: OutfitterIntegrationSettings;
  getOutfitterMetaConnectionsDetails: MetaConnectionsResult;
  getOutfitterRoleNotificationSettings: OutfitterRoleNotificationSettingsResult;
  getPaymentSettings?: Maybe<PaymentSettings>;
  getQuickBooksClassMappings?: Maybe<QuickBooksClassMappingsResult>;
  getQuickBooksClasses: QuickBooksClassesResult;
  getQuickBooksCompanyInfo: QuickBooksCompanyInfo;
  getQuickBooksDepositAccounts: QuickBooksDepositAccountsResult;
  getQuickBooksItemListingMappings: QuickBooksItemListingMappingsResult;
  getQuickBooksItemOutfitterMappings: QuickBooksItemOutfitterMappingsResult;
  getQuickBooksItems: QuickBooksItemsResult;
  getQuoteRequest: QuoteRequest;
  getQuoteRequestsForOutfitter: QuoteRequestsForOutfitterResponse;
  getRemainingPaymentsByBookingId: Array<RemainingPayment>;
  getRichTextAiSuggestion: RichTextAiSuggestion;
  getSearchSuggestionsForTrip: Array<GenericSearchSuggestionGroup>;
  getStripeTerminalInfoForPaymentEntity: StripeTerminalInfo;
  getSyncedCalendars?: Maybe<SyncedCalendarsResults>;
  getTimeseriesMetric: Array<Metric>;
  getUserNotificationPreferences: UserNotificationPreferences;
  groupPayMemberPaymentBlocks: Array<PaymentBlock>;
  groupPayShareCheckoutPreview: GroupPayShareCheckoutPreview;
  isUserUsingPasswordLogin: Scalars['Boolean']['output'];
  lead: Lead;
  leadList: PaginatedLeadList;
  listing: Listing;
  listingAvailabilityForDashboardCheckout: Array<Scalars['Timestamp']['output']>;
  listingProgress: ListingProgress;
  listingRegionAggregations: Region;
  listingsByOutfitter: Array<Listing>;
  lodging: Lodging;
  lodgingsByOutfitter: Array<Lodging>;
  lodgingsByOwner: Array<Lodging>;
  messageTemplate: MessageTemplate;
  messageTemplates?: Maybe<MessageTemplatesResults>;
  noteThreads: Array<Note>;
  notes: Array<Note>;
  notificationSendLogMessage: SendLogMessage;
  notificationSendLogs: NotificationSendLogsResults;
  notificationTemplatePreview: NotificationTemplatePreviewResult;
  notificationTemplatePreviewMock: NotificationTemplatePreviewResult;
  onboarding: Onboarding;
  onboardingPaymentSummary: PaymentSummary;
  onboardingStatusInfo: OnboardingStatusInfo;
  onboardingSubscriptionOptions: OnboardingSubscriptionOptions;
  onboardingTasks: Array<OnboardingTaskSection>;
  onboardings: OnboardingQueryResults;
  outfitter: Outfitter;
  outfitterAssistantSuggestions: Array<Scalars['String']['output']>;
  outfitterAutomationRuns: PaginatedOutfitterAutomationRuns;
  outfitterBookingCalendarGroupingOptions: Array<OutfitterBookingCalendarGroupingOption>;
  outfitterBookings: BookingResults;
  outfitterDocumentsByOutfitter: Array<OutfitterDocument>;
  outfitterFeatureAccessInfo: OutfitterFeatureAccessInfo;
  outfitterImages: Array<OutfitterImageGroup>;
  outfitterReviewAggregate?: Maybe<ReviewAggregation>;
  outfitterReviews: Array<Review>;
  outfitterSlug: OutfitterSlugResult;
  outfitterSubscriptionBillingPortalUrl: Scalars['String']['output'];
  outfitterSubscriptionInfo: OutfitterSubscriptionInfo;
  outfitterTeamMemberPeriodDigest: OutfitterTeamMemberPeriodDigest;
  outfitterWebsiteTrackingAggregatedData: OutfitterWebsiteTrackingAggregatedData;
  outfitterWebsiteTrackingMetrics: OutfitterWebsiteTrackingMetrics;
  outfittersByBadge?: Maybe<Array<Outfitter>>;
  outfittersByOwner: Array<Outfitter>;
  payment: Payment;
  paymentRequest: PaymentRequest;
  paymentsByOutfitter?: Maybe<PaymentResults>;
  payoutTransactions: Array<PayoutTransaction>;
  payouts: PayoutsList;
  portalEntities: PortalEntitiesResponse;
  preCheckoutData: PreCheckoutData;
  pricingPackage: PricingPackage;
  pricingPackagesByListing: Array<PricingPackage>;
  pricingPackagesByOutfitter: Array<PricingPackage>;
  pricingPackagesWithAddOn: Array<PricingPackage>;
  publicKnowledgeArticleIndex: Array<KnowledgeArticleIndexItem>;
  publicKnowledgeArticles: Array<PublicKnowledgeArticleContent>;
  publicListing: PublicListing;
  publicListings: Array<PublicListing>;
  publicLodgingsByListing: Array<PublicLodging>;
  publicOutfitterBySlug: PublicOutfitter;
  publicOutfitters: Array<PublicOutfitter>;
  publicTeamMembers: PublicTeamMemberResults;
  quickPayPayment: QuickPayPayment;
  quote: Quote;
  /** Most recent bookings */
  recentPublicBookings: Array<PublicBooking>;
  remainingPaymentsByOutfitter: RemainingPaymentResults;
  resource: Resource;
  resourceWithSupportForAvailability?: Maybe<ResourceWithAvailabilitySupport>;
  resourcesByOutfitter: Array<Resource>;
  resourcesWithSupportForAvailability: Array<ResourceWithAvailabilitySupport>;
  reviewForm: ReviewForm;
  reviewsByGroupId: Array<Review>;
  scheduledContactNotifications: ScheduledContactNotificationsResults;
  searchAllListings: ListingSearchResults;
  searchBookingInvitesByOutfitter: BookingInviteSearchResults;
  searchHubspotCompanies: HubspotCompanySearchResult;
  searchListingsForSportsmen: PublicListingSearchResults;
  searchMessageTemplatesByOutfitter: MessageTemplateSearchResults;
  searchOutfitters: OutfitterSearchResults;
  searchOutfittersForImpersonation: OutfittersForImpersonationSearchResults;
  searchOutfittersForSportsmen: PublicOutfitterSearchResults;
  searchQuoteRequestsByOutfitter: QuoteRequestSearchResults;
  searchSpecies: Array<Species>;
  searchUsers: UsersSearchResults;
  smsMessage: Scalars['String']['output'];
  sportsmanPaymentBlocks: Array<PaymentBlock>;
  stripeAccountInfo: StripeAccountInfo;
  stripeBillingPortalUrl: Scalars['String']['output'];
  stripeConnectedAccountPortalUrl: Scalars['String']['output'];
  stripeCustomerEphemeralKey?: Maybe<EphemeralKeyAndCustomerId>;
  stripePaymentIntentInfo: StripePaymentIntentInfo;
  stripeSubscriptionPortalUrl: Scalars['String']['output'];
  teamMember: TeamMember;
  teamMembers: Array<TeamMember>;
  terminalConnectionToken: Scalars['String']['output'];
  tripInsuranceProduct?: Maybe<TripInsuranceProduct>;
  tripInsuranceQuote: BookingQuoteTripInsuranceQuote;
  twilioConfiguration?: Maybe<OutfitterTwilioConfiguration>;
  unpaidPayment: QuickPayPayment;
  user: User;
  userPaymentsHistory: Array<Payment>;
  userTrackingData: UserTrackingData;
  usersForMentions: Array<PublicUser>;
  widget: Widget;
  widgetsByOutfitter: Array<Widget>;
  wishlist: Wishlist;
  wishlistsByUser: Array<Wishlist>;
};


export type QueryAdditionalBookingPaymentSummaryArgs = {
  bookingId: Scalars['ID']['input'];
  data: AdditionalBookingPaymentSummaryInput;
};


export type QueryAdditionalPaymentSummaryArgs = {
  bookingId: Scalars['ID']['input'];
  data: AdditionalPaymentSummaryInput;
};


export type QueryAdminAiContextArgs = {
  outfitterId: Scalars['ID']['input'];
  purpose: AiContextPurpose;
};


export type QueryAdminSearchLeadsArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<LeadFilterInput>;
  paging: Paging;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAdminSearchQuoteRequestsArgs = {
  filters?: InputMaybe<QuoteRequestFilters>;
  paging: Paging;
  sort?: InputMaybe<Sort>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAiConversationMessagesArgs = {
  conversationId: Scalars['ID']['input'];
  paging: Paging;
};


export type QueryAiConversationsArgs = {
  input?: InputMaybe<AiConversationsInput>;
  paging: Paging;
};


export type QueryAiOnboardingArgs = {
  outfitterId: Scalars['ID']['input'];
  sourceType?: InputMaybe<AiOnboardingSourceType>;
};


export type QueryAiOnboardingByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAppPromptsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryAuctionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuctionRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryAuctionRequestsArgs = {
  filters: AuctionRequestFiltersInput;
  paging: Paging;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAuctionsArgs = {
  filters: AuctionFiltersInput;
  paging: Paging;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailabilityArgs = {
  data: GetGenericAvailabilityInput;
};


export type QueryAvailableDatesAndTimesForCheckoutCalendarArgs = {
  data: AvailableDatesForCheckoutCalendarInput;
};


export type QueryAvailableDatesForCalendarEventResourcesArgs = {
  data: AvailableDatesForCalendarEventResourcesInput;
};


export type QueryAvailableDatesForEditBookingArgs = {
  data: AvailableDatesForEditBookingInput;
};


export type QueryAwardedItemArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryAwardedItemsArgs = {
  filters: AwardedItemsFiltersInput;
  paging: Paging;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryBookingCancellationInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingInviteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingInviteInvoicePreviewArgs = {
  data: BookingInviteInvoicePreviewInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  isInvoice?: InputMaybe<Scalars['Boolean']['input']>;
  userInput?: InputMaybe<EntityUserInput>;
};


export type QueryBookingInvitesArgs = {
  filters?: InputMaybe<BookingInviteFilters>;
  listingId?: InputMaybe<Scalars['ID']['input']>;
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  paging?: InputMaybe<Paging>;
};


export type QueryBookingUpdatesPreviewArgs = {
  data: UpdateBookingDatesGuestsAndAddonsInput;
  id: Scalars['ID']['input'];
};


export type QueryBookingsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryBulkOperationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBulkOperationsArgs = {
  attributes?: InputMaybe<BulkOperationAttributesFilter>;
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
  types?: InputMaybe<Array<BulkOperationType>>;
};


export type QueryCalendarEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCalendarEventsArgs = {
  filters?: InputMaybe<CalendarEventFilters>;
  outfitterId: Scalars['ID']['input'];
  shouldGroupEvents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCalendarEventsByResourceTypeArgs = {
  filters: CalendarEventsByResourceTypeFilters;
  outfitterId: Scalars['ID']['input'];
  shouldGroupEvents?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCanConvertGuestToUserArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
};


export type QueryContactArgs = {
  id: Scalars['ID']['input'];
  outfitterId: Scalars['ID']['input'];
};


export type QueryContactListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContactListContactsArgs = {
  contactListId: Scalars['ID']['input'];
  paging: Paging;
};


export type QueryContactListPreviewContactsArgs = {
  filters: Array<ContactListFilterInput>;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
};


export type QueryContactListsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryContactsArgs = {
  filters: ContactsFiltersInput;
  paging: Paging;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCouponsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryDashboardCheckoutMaxAvailableSlotsArgs = {
  data: CheckoutMaxSlotsInput;
};


export type QueryDashboardHomeArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryDashboardNavigationMenuArgs = {
  portalEntityId?: InputMaybe<Scalars['ID']['input']>;
  portalType: PortalType;
};


export type QueryDashboardSearchArgs = {
  outfitterId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


export type QueryDefaultAvailabilityRuleArgs = {
  id: Scalars['ID']['input'];
};


export type QueryDefaultAvailabilityRulesForResourceArgs = {
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  resourceId: Scalars['ID']['input'];
  resourceType: ResourceType;
};


export type QueryDenialReasonsArgs = {
  entityType?: InputMaybe<EntityType>;
};


export type QueryDraftQuoteArgs = {
  data: CreateQuoteInput;
};


export type QueryEntityListCountsArgs = {
  key: EntityListCountsKey;
  outfitterId: Scalars['ID']['input'];
};


export type QueryEventOrganizerArgs = {
  id: Scalars['ID']['input'];
};


export type QueryExportContactsCsvArgs = {
  filters: ContactsFiltersInput;
  searchText?: InputMaybe<Scalars['String']['input']>;
};


export type QueryExportPaymentsCsvByOutfitterArgs = {
  data: ExportDataInput;
};


export type QueryExportRemainingPaymentsCsvByOutfitterArgs = {
  data: ExportDataInput;
};


export type QueryFeatureGateArgs = {
  featureKey: FeatureKey;
  portalEntityId: Scalars['ID']['input'];
  portalType: PortalType;
};


export type QueryFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFormSubmissionArgs = {
  access_code_id?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type QueryFormSubmissionPdfArgs = {
  access_code_id: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type QueryFormSubmissionsArgs = {
  form_id: Scalars['String']['input'];
  paging: Paging;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetAddOnsByListingAndOfferPeriodArgs = {
  idsToAlwaysInclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listingId: Scalars['ID']['input'];
  offerPeriod: AddOnOfferPeriod;
};


export type QueryGetAddOnsByOutfitterAndOfferPeriodArgs = {
  offerPeriod: AddOnOfferPeriod;
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetBookingInvitePaymentSummaryArgs = {
  data: PaymentSummaryInput;
};


export type QueryGetCalendarSubscriptionsArgs = {
  paging?: InputMaybe<Paging>;
  userId: Scalars['ID']['input'];
};


export type QueryGetDefaultImageArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
  species?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetEntityCustomPropertiesArgs = {
  entityId: Scalars['ID']['input'];
  entityType: CustomPropertyEntityType;
};


export type QueryGetEventGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEventGroupsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetExtraAddOnsForListingAndPricingPackageArgs = {
  listingId: Scalars['ID']['input'];
  pricingPackageId: Scalars['ID']['input'];
  shouldFilterHiddenAddons?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInvoicePdfArgs = {
  accessCodeId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['ID']['input'];
  entityType: EntityType;
};


export type QueryGetMetaAdAccountsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetMetaAdCampaignsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetMetaAdMetricsArgs = {
  adMetricsInput: MetaAdMetricsInput;
};


export type QueryGetMetaAdSetsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetMetaAdsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetMetaAggregatedAdMetricsArgs = {
  aggregatedAdMetricsInput: MetaAggregatedAdMetricsInput;
};


export type QueryGetMetricArgs = {
  metricParams: MetricParams;
};


export type QueryGetMetricsByOutfitterAndKeysArgs = {
  metricParams: MetricByOutfitterAndKeysParams;
};


export type QueryGetOrCreateOutfitterWebsiteArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetOutfitterAutomationSettingArgs = {
  automation_type: AutomationType;
  outfitter_id: Scalars['ID']['input'];
};


export type QueryGetOutfitterAutomationSettingsByGroupArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetOutfitterCustomPropertiesArgs = {
  filters?: InputMaybe<OutfitterCustomPropertiesFilters>;
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetOutfitterIntegrationSettingsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetOutfitterMetaConnectionsDetailsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetOutfitterRoleNotificationSettingsArgs = {
  outfitterId: Scalars['ID']['input'];
  role?: InputMaybe<TeamMemberRole>;
};


export type QueryGetPaymentSettingsArgs = {
  entity_id: Scalars['ID']['input'];
  entity_type: PaymentSettingsEntityType;
};


export type QueryGetQuickBooksClassMappingsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksClassesArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksCompanyInfoArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksDepositAccountsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksItemListingMappingsArgs = {
  listingId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksItemOutfitterMappingsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuickBooksItemsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryGetQuoteRequestArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQuoteRequestsForOutfitterArgs = {
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  listing_id?: InputMaybe<Scalars['ID']['input']>;
  outfitter_id: Scalars['ID']['input'];
  paging: Paging;
};


export type QueryGetRemainingPaymentsByBookingIdArgs = {
  booking_id: Scalars['ID']['input'];
};


export type QueryGetRichTextAiSuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSearchSuggestionsForTripArgs = {
  searchParams: SearchListingsForSportsmenInput;
};


export type QueryGetStripeTerminalInfoForPaymentEntityArgs = {
  entityId: Scalars['ID']['input'];
  entityType: Scalars['String']['input'];
};


export type QueryGetSyncedCalendarsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryGetTimeseriesMetricArgs = {
  metricParams: MetricParams;
};


export type QueryGetUserNotificationPreferencesArgs = {
  contextEntityId: Scalars['ID']['input'];
  contextEntityType: NotificationPreferencesEntityType;
};


export type QueryGroupPayMemberPaymentBlocksArgs = {
  groupPayMemberId: Scalars['ID']['input'];
};


export type QueryGroupPayShareCheckoutPreviewArgs = {
  bookingId: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  paymentPlanType?: InputMaybe<PaymentPlanType>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  slots: Scalars['PositiveInt']['input'];
  sportsmanZipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLeadArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLeadListArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<LeadFilterInput>;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<LeadStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingAvailabilityForDashboardCheckoutArgs = {
  data: DashboardCheckoutAvailabilityInput;
};


export type QueryListingProgressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryListingsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryLodgingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLodgingsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryLodgingsByOwnerArgs = {
  ownerId: Scalars['ID']['input'];
};


export type QueryMessageTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMessageTemplatesArgs = {
  filters?: InputMaybe<MessageTemplateFilters>;
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryNoteThreadsArgs = {
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNotesArgs = {
  entityId: Scalars['String']['input'];
  entityType: NotesEntityType;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  threadId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryNotificationSendLogMessageArgs = {
  id: Scalars['ID']['input'];
  outfitterId: Scalars['ID']['input'];
};


export type QueryNotificationSendLogsArgs = {
  filters: NotificationSendLogsFilters;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
};


export type QueryNotificationTemplatePreviewArgs = {
  customMessage?: InputMaybe<CustomMessageInput>;
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  to: MessageTo;
  topicEntityId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryNotificationTemplatePreviewMockArgs = {
  customMessage?: InputMaybe<CustomMessageInput>;
  messageRecipientType: MessageRecipientType;
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOnboardingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingPaymentSummaryArgs = {
  data: OnboardingPaymentSummaryInput;
};


export type QueryOnboardingStatusInfoArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingTasksArgs = {
  portalEntityId: Scalars['ID']['input'];
  portalType: PortalType;
};


export type QueryOnboardingsArgs = {
  filters?: InputMaybe<OnboardingFilters>;
  paging: Paging;
};


export type QueryOutfitterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOutfitterAssistantSuggestionsArgs = {
  input: OutfitterAssistantSuggestionsInput;
};


export type QueryOutfitterAutomationRunsArgs = {
  automation_type?: InputMaybe<AutomationType>;
  outfitter_id: Scalars['ID']['input'];
  paging: Paging;
  status?: InputMaybe<AutomationRunStatus>;
};


export type QueryOutfitterBookingCalendarGroupingOptionsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterBookingsArgs = {
  filters: OutfitterBookingsFilters;
  paging: Paging;
  searchText?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Sort>;
};


export type QueryOutfitterDocumentsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
  type?: InputMaybe<OutfitterDocumentType>;
};


export type QueryOutfitterFeatureAccessInfoArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterImagesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mode?: InputMaybe<OutfitterImageSearchMode>;
  outfitterId: Scalars['ID']['input'];
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryOutfitterReviewAggregateArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterReviewsArgs = {
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryOutfitterSlugArgs = {
  name: Scalars['String']['input'];
};


export type QueryOutfitterSubscriptionBillingPortalUrlArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterSubscriptionInfoArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterTeamMemberPeriodDigestArgs = {
  days?: InputMaybe<Scalars['PositiveInt']['input']>;
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterWebsiteTrackingAggregatedDataArgs = {
  dateRange: DateRange;
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfitterWebsiteTrackingMetricsArgs = {
  dateRange: DateRange;
  outfitterId: Scalars['ID']['input'];
};


export type QueryOutfittersByBadgeArgs = {
  badgeId: Scalars['ID']['input'];
};


export type QueryOutfittersByOwnerArgs = {
  ownerId: Scalars['ID']['input'];
};


export type QueryPaymentArgs = {
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryPaymentRequestArgs = {
  id: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  shouldCalculateFees?: InputMaybe<Scalars['Boolean']['input']>;
  tipAmount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryPaymentsByOutfitterArgs = {
  fromDate?: InputMaybe<Scalars['Timestamp']['input']>;
  isQuickPay?: InputMaybe<Scalars['Boolean']['input']>;
  outfitterId: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
  status?: InputMaybe<PaymentStatus>;
  toDate?: InputMaybe<Scalars['Timestamp']['input']>;
};


export type QueryPayoutTransactionsArgs = {
  outfitterId: Scalars['ID']['input'];
  payoutId: Scalars['ID']['input'];
};


export type QueryPayoutsArgs = {
  options?: InputMaybe<CursorPaginationOptions>;
  outfitterId: Scalars['ID']['input'];
};


export type QueryPortalEntitiesArgs = {
  adminSearch?: InputMaybe<PortalEntitiesAdminSearchInput>;
};


export type QueryPreCheckoutDataArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryPricingPackageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPricingPackagesByListingArgs = {
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  existingPackage?: InputMaybe<ExistingPackageInput>;
  idsToAlwaysInclude?: InputMaybe<Array<Scalars['ID']['input']>>;
  listing: Scalars['ID']['input'];
  numberOfGuests?: InputMaybe<Scalars['PositiveInt']['input']>;
  shouldIncludeHidden?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPricingPackagesByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryPricingPackagesWithAddOnArgs = {
  addOn: Scalars['ID']['input'];
};


export type QueryPublicKnowledgeArticleIndexArgs = {
  input?: InputMaybe<KnowledgeArticleIndexInput>;
};


export type QueryPublicKnowledgeArticlesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryPublicListingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPublicListingsArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPublicLodgingsByListingArgs = {
  listingId: Scalars['ID']['input'];
};


export type QueryPublicOutfitterBySlugArgs = {
  slug: Scalars['String']['input'];
};


export type QueryPublicOutfittersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryPublicTeamMembersArgs = {
  outfitterId: Scalars['ID']['input'];
  role?: InputMaybe<TeamMemberRole>;
};


export type QueryQuickPayPaymentArgs = {
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
  isAch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryQuoteArgs = {
  id: Scalars['ID']['input'];
  isAchPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  isExternalPaymentMethod?: InputMaybe<Scalars['Boolean']['input']>;
  paymentPlanType?: InputMaybe<PaymentPlanType>;
  shouldAcceptTripInsurance?: InputMaybe<Scalars['Boolean']['input']>;
  sportmanZipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRecentPublicBookingsArgs = {
  size?: InputMaybe<Scalars['PositiveInt']['input']>;
};


export type QueryRemainingPaymentsByOutfitterArgs = {
  outfitter_id: Scalars['ID']['input'];
  paging?: InputMaybe<Paging>;
};


export type QueryResourceArgs = {
  id: Scalars['String']['input'];
};


export type QueryResourceWithSupportForAvailabilityArgs = {
  id: Scalars['ID']['input'];
  outfitterId: Scalars['ID']['input'];
  resourceType: ResourceType;
};


export type QueryResourcesByOutfitterArgs = {
  outfitterId: Scalars['String']['input'];
};


export type QueryResourcesWithSupportForAvailabilityArgs = {
  outfitterId: Scalars['ID']['input'];
  resourceType: ResourceType;
};


export type QueryReviewFormArgs = {
  id: Scalars['ID']['input'];
};


export type QueryReviewsByGroupIdArgs = {
  groupId: Scalars['ID']['input'];
};


export type QueryScheduledContactNotificationsArgs = {
  data: ScheduledContactNotificationsInput;
};


export type QuerySearchAllListingsArgs = {
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  from: Scalars['NonNegativeInt']['input'];
  published?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['PositiveInt']['input']>;
  title: Scalars['String']['input'];
};


export type QuerySearchBookingInvitesByOutfitterArgs = {
  filters?: InputMaybe<BookingInviteFilters>;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  sort?: InputMaybe<Sort>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchHubspotCompaniesArgs = {
  searchTerm: Scalars['String']['input'];
};


export type QuerySearchListingsForSportsmenArgs = {
  options: SearchOptions;
  searchParams: SearchListingsForSportsmenInput;
};


export type QuerySearchMessageTemplatesByOutfitterArgs = {
  filters?: InputMaybe<SearchMessageTemplateFilters>;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchOutfittersArgs = {
  page: Scalars['NonNegativeInt']['input'];
  size: Scalars['PositiveInt']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type QuerySearchOutfittersForImpersonationArgs = {
  page: Scalars['NonNegativeInt']['input'];
  size: Scalars['PositiveInt']['input'];
  text: Scalars['String']['input'];
};


export type QuerySearchOutfittersForSportsmenArgs = {
  options: SearchOptions;
  searchParams: SearchOutfittersForSportsmenInput;
};


export type QuerySearchQuoteRequestsByOutfitterArgs = {
  filters?: InputMaybe<QuoteRequestFilters>;
  outfitterId: Scalars['ID']['input'];
  paging: Paging;
  sort?: InputMaybe<Sort>;
  text?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchSpeciesArgs = {
  data: SearchSpeciesInput;
};


export type QuerySearchUsersArgs = {
  page: Scalars['NonNegativeInt']['input'];
  size: Scalars['PositiveInt']['input'];
  text: Scalars['String']['input'];
};


export type QuerySmsMessageArgs = {
  customMessage?: InputMaybe<CustomSmsMessageInput>;
  outfitterId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  to: MessageTo;
  topicEntityId?: InputMaybe<Scalars['ID']['input']>;
};


export type QuerySportsmanPaymentBlocksArgs = {
  sportsmanId: Scalars['ID']['input'];
};


export type QueryStripeAccountInfoArgs = {
  onboardLinkUrls?: InputMaybe<AccountOnboardLinkInput>;
};


export type QueryStripeBillingPortalUrlArgs = {
  code: Scalars['String']['input'];
};


export type QueryStripeConnectedAccountPortalUrlArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryStripeCustomerEphemeralKeyArgs = {
  paymentId: Scalars['ID']['input'];
};


export type QueryStripePaymentIntentInfoArgs = {
  accessCode?: InputMaybe<Scalars['ID']['input']>;
  paymentId: Scalars['ID']['input'];
};


export type QueryStripeSubscriptionPortalUrlArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryTeamMemberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTeamMembersArgs = {
  outfitterId: Scalars['ID']['input'];
  role?: InputMaybe<TeamMemberRole>;
};


export type QueryTripInsuranceProductArgs = {
  insurableAmount: Scalars['PositiveInt']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryTripInsuranceQuoteArgs = {
  bookingId: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


export type QueryTwilioConfigurationArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryUnpaidPaymentArgs = {
  id: Scalars['ID']['input'];
  invitationId?: InputMaybe<Scalars['ID']['input']>;
  isAch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryUsersForMentionsArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryWidgetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWidgetsByOutfitterArgs = {
  outfitterId: Scalars['ID']['input'];
};


export type QueryWishlistArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWishlistsByUserArgs = {
  userId: Scalars['ID']['input'];
};

/** Quick access action button */
export type QuickAccessAction = {
  __typename?: 'QuickAccessAction';
  badge?: Maybe<FeatureBadgeType>;
  feature_key: FeatureIconKey;
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Quick access section with action buttons */
export type QuickAccessSection = BaseDashboardSection & {
  __typename?: 'QuickAccessSection';
  actions: Array<QuickAccessAction>;
  id: Scalars['String']['output'];
  order: Scalars['PositiveInt']['output'];
  title: Scalars['String']['output'];
};

export type QuickBooksClass = {
  __typename?: 'QuickBooksClass';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksClassMappingInput = {
  class_id?: InputMaybe<Scalars['String']['input']>;
  class_name?: InputMaybe<Scalars['String']['input']>;
  entity_id: Scalars['ID']['input'];
  entity_type: EntityIntegrationSettingsEntityType;
};

export type QuickBooksClassMappingsResult = {
  __typename?: 'QuickBooksClassMappingsResult';
  listing_class_mappings: Array<QuickBooksListingClassMapping>;
};

export type QuickBooksClassesResult = {
  __typename?: 'QuickBooksClassesResult';
  classes: Array<QuickBooksClass>;
};

export type QuickBooksCompanyInfo = {
  __typename?: 'QuickBooksCompanyInfo';
  account_owner_full_name?: Maybe<Scalars['String']['output']>;
  company_name?: Maybe<Scalars['String']['output']>;
};

export type QuickBooksConnectionInput = {
  outfitter_id: Scalars['String']['input'];
};

export type QuickBooksDepositAccount = {
  __typename?: 'QuickBooksDepositAccount';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksDepositAccountsResult = {
  __typename?: 'QuickBooksDepositAccountsResult';
  accounts: Array<QuickBooksDepositAccount>;
};

export type QuickBooksDisconnectInput = {
  outfitter_id: Scalars['String']['input'];
};

export type QuickBooksDisconnectResult = {
  __typename?: 'QuickBooksDisconnectResult';
  success: Scalars['Boolean']['output'];
};

export type QuickBooksIntegrationSettings = {
  __typename?: 'QuickBooksIntegrationSettings';
  default_product_service_id?: Maybe<Scalars['String']['output']>;
  deposit_account_id?: Maybe<Scalars['String']['output']>;
  invoice_date?: Maybe<QuickBooksInvoiceDateSetting>;
};

export enum QuickBooksInvoiceDateSetting {
  BookingApprovalDate = 'BOOKING_APPROVAL_DATE',
  BookingDate = 'BOOKING_DATE',
  TripStartDate = 'TRIP_START_DATE'
}

export type QuickBooksItem = {
  __typename?: 'QuickBooksItem';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuickBooksItemListingMappingsResult = {
  __typename?: 'QuickBooksItemListingMappingsResult';
  pricing_package_item_mappings: Array<QuickBooksItemMapping>;
};

export type QuickBooksItemMapping = {
  __typename?: 'QuickBooksItemMapping';
  entity_id: Scalars['ID']['output'];
  entity_order?: Maybe<Scalars['PositiveInt']['output']>;
  entity_title: Scalars['String']['output'];
  entity_type: EntityIntegrationSettingsEntityType;
  item_id?: Maybe<Scalars['String']['output']>;
  item_name?: Maybe<Scalars['String']['output']>;
};

export type QuickBooksItemMappingInput = {
  entity_id: Scalars['ID']['input'];
  entity_type: EntityIntegrationSettingsEntityType;
  item_id?: InputMaybe<Scalars['String']['input']>;
  item_name?: InputMaybe<Scalars['String']['input']>;
};

export type QuickBooksItemOutfitterMappingsResult = {
  __typename?: 'QuickBooksItemOutfitterMappingsResult';
  add_on_item_mappings: Array<QuickBooksItemMapping>;
};

export type QuickBooksItemsResult = {
  __typename?: 'QuickBooksItemsResult';
  items: Array<QuickBooksItem>;
};

export type QuickBooksListingClassMapping = {
  __typename?: 'QuickBooksListingClassMapping';
  class_id?: Maybe<Scalars['String']['output']>;
  class_name?: Maybe<Scalars['String']['output']>;
  listing_id: Scalars['ID']['output'];
  listing_order?: Maybe<Scalars['PositiveInt']['output']>;
  listing_title: Scalars['String']['output'];
};

export type QuickPayPayment = {
  __typename?: 'QuickPayPayment';
  id: Scalars['ID']['output'];
  outfitter: PublicOutfitter;
  payment_summary: PaymentSummary;
  status: PaymentStatus;
};

export type Quote = QuoteInterface & {
  __typename?: 'Quote';
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  coupon?: Maybe<Coupon>;
  created_at: Scalars['Timestamp']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  deposit_amount?: Maybe<Scalars['NonNegativeInt']['output']>;
  deposit_date?: Maybe<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  listing: Listing;
  lodging_included?: Maybe<Scalars['Boolean']['output']>;
  packages: Array<QuotePackage>;
  payment_group?: Maybe<QuotePaymentGroup>;
  payment_plans: Array<QuotePaymentPlan>;
  payment_summary?: Maybe<PaymentSummary>;
  should_allow_external_payment?: Maybe<Scalars['Boolean']['output']>;
  start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
  updated_at: Scalars['Timestamp']['output'];
};

export type QuoteAddOn = {
  __typename?: 'QuoteAddOn';
  category: Scalars['String']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  deposit_amount?: Maybe<Scalars['Float']['output']>;
  deposit_percentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  images?: Maybe<Array<Scalars['String']['output']>>;
  listings: Array<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  offer_period: AddOnOfferPeriod;
  order?: Maybe<Scalars['PositiveInt']['output']>;
  package_id?: Maybe<Scalars['String']['output']>;
  price_by_day?: Maybe<PriceByDay>;
  price_by_guest?: Maybe<PriceByGuest>;
  quantity: Scalars['PositiveInt']['output'];
  species?: Maybe<Species>;
  stripe_product_id?: Maybe<Scalars['String']['output']>;
  unit_price: Scalars['Float']['output'];
};

export type QuoteAddOnInput = {
  id: Scalars['ID']['input'];
  package_id?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['PositiveInt']['input'];
};

export type QuoteInterface = {
  add_ons?: Maybe<Array<QuoteAddOn>>;
  attribution?: Maybe<Attribution>;
  booking_invite?: Maybe<BookingInvite>;
  coupon?: Maybe<Coupon>;
  currency?: Maybe<Scalars['String']['output']>;
  dates: Array<Scalars['Timestamp']['output']>;
  deposit_amount?: Maybe<Scalars['NonNegativeInt']['output']>;
  deposit_date?: Maybe<Scalars['Timestamp']['output']>;
  discount?: Maybe<Scalars['Float']['output']>;
  items: Array<QuoteItem>;
  itinerary?: Maybe<TripItinerary>;
  listing: Listing;
  lodging_included?: Maybe<Scalars['Boolean']['output']>;
  packages: Array<QuotePackage>;
  payment_plans: Array<QuotePaymentPlan>;
  payment_summary?: Maybe<PaymentSummary>;
  start_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  trip_insurance?: Maybe<BookingQuoteTripInsuranceQuote>;
};

export type QuoteItem = {
  __typename?: 'QuoteItem';
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  option_id: Scalars['ID']['output'];
  price: Scalars['Float']['output'];
  quantity: Scalars['PositiveInt']['output'];
  rate: Scalars['Float']['output'];
};

export type QuoteItemInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  option_id: Scalars['ID']['input'];
  price: Scalars['Float']['input'];
  quantity: Scalars['PositiveInt']['input'];
  rate: Scalars['Float']['input'];
};

export type QuotePackage = {
  __typename?: 'QuotePackage';
  add_ons: Array<QuoteAddOn>;
  id: Scalars['ID']['output'];
  items: Array<QuoteItem>;
  line_item_key?: Maybe<Scalars['ID']['output']>;
  number_of_guests: Scalars['PositiveInt']['output'];
  pricing_package: PricingPackage;
};

export type QuotePayment = {
  __typename?: 'QuotePayment';
  booking_fee: Scalars['Float']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  date: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  mb_amount: Scalars['Float']['output'];
  outfitter_amount: Scalars['Float']['output'];
  outfitter_fee: Scalars['Float']['output'];
  processing_fee: Scalars['Float']['output'];
  sales_tax: Scalars['Float']['output'];
  service_fee: Scalars['Float']['output'];
  should_charge_last_day_of_trip?: Maybe<Scalars['Boolean']['output']>;
  total?: Maybe<Scalars['Float']['output']>;
  value: Scalars['Float']['output'];
};

export type QuotePaymentGroup = {
  __typename?: 'QuotePaymentGroup';
  host: QuotePaymentGroupMember;
  last_payment_due_date: Scalars['Timestamp']['output'];
  members: Array<QuotePaymentGroupMember>;
  remaining_slots: Scalars['PositiveInt']['output'];
};

export type QuotePaymentGroupMember = {
  __typename?: 'QuotePaymentGroupMember';
  amount: Scalars['NonNegativeInt']['output'];
  email: Scalars['EmailAddress']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  payment_plans: Array<QuotePaymentPlan>;
  slots: Scalars['NonNegativeInt']['output'];
};

export type QuotePaymentGroupMemberInput = {
  email: Scalars['EmailAddress']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  slots: Scalars['PositiveInt']['input'];
};

export type QuotePaymentPlan = {
  __typename?: 'QuotePaymentPlan';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  payments: Array<QuotePayment>;
  type: PaymentPlanType;
};

export type QuotePrice = {
  __typename?: 'QuotePrice';
  category?: Maybe<QuotePriceCategory>;
  currency?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
  subsections: Array<PriceSubsection>;
  value: Scalars['Float']['output'];
};

export enum QuotePriceCategory {
  BookingFee = 'BOOKING_FEE',
  Discount = 'DISCOUNT',
  GrandTotal = 'GRAND_TOTAL',
  Other = 'OTHER',
  ProcessingFee = 'PROCESSING_FEE',
  RemainingAfterDeposit = 'REMAINING_AFTER_DEPOSIT',
  RemainingGroupMembersTotal = 'REMAINING_GROUP_MEMBERS_TOTAL',
  SalesTax = 'SALES_TAX',
  Subtotal = 'SUBTOTAL',
  TaxesAndOtherFees = 'TAXES_AND_OTHER_FEES',
  Total = 'TOTAL',
  TotalWithoutProcessingFees = 'TOTAL_WITHOUT_PROCESSING_FEES',
  TripInsuranceTotal = 'TRIP_INSURANCE_TOTAL',
  YourSubtotal = 'YOUR_SUBTOTAL'
}

export type QuotePricingOptionInput = {
  id: Scalars['ID']['input'];
  quantity: Scalars['PositiveInt']['input'];
};

export type QuoteRequest = {
  __typename?: 'QuoteRequest';
  booking_invite?: Maybe<BookingInvite>;
  booking_invite_id?: Maybe<Scalars['ID']['output']>;
  contact: QuoteRequestContact;
  created_at: Scalars['Timestamp']['output'];
  dates: Array<Scalars['NonNegativeInt']['output']>;
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  is_unread: Scalars['Boolean']['output'];
  listing?: Maybe<Listing>;
  listing_id?: Maybe<Scalars['ID']['output']>;
  outfitter?: Maybe<Outfitter>;
  outfitter_id: Scalars['ID']['output'];
  trip_details: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type QuoteRequestContact = {
  __typename?: 'QuoteRequestContact';
  email: Scalars['String']['output'];
  first_name: Scalars['String']['output'];
  last_name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  preferred_method: QuoteRequestPreferredMethod;
};

export type QuoteRequestContactInput = {
  email: Scalars['String']['input'];
  first_name: Scalars['String']['input'];
  last_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  preferred_method: QuoteRequestPreferredMethod;
};

export type QuoteRequestFilters = {
  is_archived?: InputMaybe<Scalars['Boolean']['input']>;
  listing_id?: InputMaybe<Scalars['ID']['input']>;
};

export type QuoteRequestInput = {
  contact: QuoteRequestContactInput;
  dates: Array<Scalars['NonNegativeInt']['input']>;
  listing_id?: InputMaybe<Scalars['ID']['input']>;
  outfitter_id?: InputMaybe<Scalars['ID']['input']>;
  trip_details: Scalars['String']['input'];
};

export enum QuoteRequestPreferredMethod {
  Email = 'EMAIL',
  Phone = 'PHONE'
}

export type QuoteRequestSearchResults = {
  __typename?: 'QuoteRequestSearchResults';
  results: Array<QuoteRequest>;
  total: Scalars['NonNegativeInt']['output'];
};

export type QuoteRequestsForOutfitterResponse = {
  __typename?: 'QuoteRequestsForOutfitterResponse';
  count: Scalars['Int']['output'];
  data: Array<QuoteRequest>;
  pages: Scalars['Int']['output'];
};

export type Rates = {
  __typename?: 'Rates';
  booking_fee_fixed: Scalars['Float']['output'];
  booking_fee_rate: Scalars['Float']['output'];
  is_processing_fee_payed_by_sportsman?: Maybe<Scalars['Boolean']['output']>;
  max_booking_fee: Scalars['Float']['output'];
  max_service_fee: Scalars['Float']['output'];
  outfitter_fee_rate?: Maybe<Scalars['Float']['output']>;
  processing_fee_ach_fixed?: Maybe<Scalars['Float']['output']>;
  processing_fee_ach_max?: Maybe<Scalars['NonNegativeInt']['output']>;
  processing_fee_ach_rate?: Maybe<Scalars['Float']['output']>;
  processing_fee_fixed: Scalars['Float']['output'];
  processing_fee_rate: Scalars['Float']['output'];
  service_fee_fixed: Scalars['Float']['output'];
  service_fee_rate: Scalars['Float']['output'];
};

export type RatesInput = {
  booking_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  booking_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  max_booking_fee?: InputMaybe<Scalars['Float']['input']>;
  max_service_fee?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_max?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  processing_fee_ach_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  service_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  service_fee_rate?: InputMaybe<Scalars['Float']['input']>;
};

export enum ReferralSource {
  Ad = 'AD',
  BookingAgent = 'BOOKING_AGENT',
  CustomerReferral = 'CUSTOMER_REFERRAL',
  CustomForm = 'CUSTOM_FORM',
  Google = 'GOOGLE',
  QuoteRequest = 'QUOTE_REQUEST',
  TradeShow = 'TRADE_SHOW',
  Website = 'WEBSITE',
  WordOfMouth = 'WORD_OF_MOUTH'
}

export type ReferrerMetric = {
  __typename?: 'ReferrerMetric';
  new_user_count: Scalars['Int']['output'];
  referrer: Scalars['String']['output'];
  session_count: Scalars['Int']['output'];
};

export type Refund = {
  __typename?: 'Refund';
  amount: Scalars['PositiveInt']['output'];
  approved_by_name: Scalars['String']['output'];
  cancelled_at?: Maybe<Scalars['Timestamp']['output']>;
  cancelled_by?: Maybe<User>;
  created_at: Scalars['Timestamp']['output'];
  created_by: User;
  currency?: Maybe<Scalars['String']['output']>;
  error?: Maybe<PaymentError>;
  gateway_refund_id: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  payment_gateway: PaymentGateway;
  payment_id: Scalars['ID']['output'];
  status: RefundStatus;
  stripe_reason?: Maybe<StripeRefundReason>;
  updated_at: Scalars['Timestamp']['output'];
  user_reason: Scalars['String']['output'];
};

export enum RefundStatus {
  Canceled = 'CANCELED',
  Failed = 'FAILED',
  Pending = 'PENDING',
  RequiresAction = 'REQUIRES_ACTION',
  Succeeded = 'SUCCEEDED'
}

export type Region = {
  __typename?: 'Region';
  countries_subsection: PageSubsection;
  label: Scalars['String']['output'];
  states_subsection: PageSubsection;
  sub_label: Scalars['String']['output'];
};

export enum RegionsOfOperation {
  Africa = 'Africa',
  Asia = 'Asia',
  Europe = 'Europe',
  LatinAmerica = 'LatinAmerica',
  UsaAndCanada = 'UsaAndCanada'
}

export type RegisterForSmsInput = {
  authorized_representative: AuthorizedRepresentativeInput;
  business_address: BusinessAddressInput;
  business_ein: Scalars['String']['input'];
  business_name: Scalars['String']['input'];
  business_type: BusinessType;
  business_website: Scalars['String']['input'];
  company_type: CompanyType;
  marketing_campaign_description: Scalars['String']['input'];
  marketing_campaign_message_samples: Array<Scalars['String']['input']>;
  regions_of_operation: RegionsOfOperation;
};

export type RemainingPayment = {
  __typename?: 'RemainingPayment';
  amount: Scalars['Int']['output'];
  booking_add_on_id: Scalars['ID']['output'];
  booking_id: Scalars['ID']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_archived?: Maybe<Scalars['Boolean']['output']>;
  outfitter_id: Scalars['ID']['output'];
  payment_id?: Maybe<Scalars['ID']['output']>;
  payment_request_id?: Maybe<Scalars['ID']['output']>;
  status: PaymentStatus;
  updated_at: Scalars['Timestamp']['output'];
};

export type RemainingPaymentResults = {
  __typename?: 'RemainingPaymentResults';
  count: Scalars['Int']['output'];
  pages: Scalars['Int']['output'];
  remaining_payments: Array<RemainingPayment>;
};

/** Reporting overview section */
export type ReportingSection = BaseDashboardSection & {
  __typename?: 'ReportingSection';
  id: Scalars['String']['output'];
  metrics: Array<Metric>;
  order: Scalars['PositiveInt']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type Resource = {
  __typename?: 'Resource';
  atv_props?: Maybe<AtvProps>;
  blind_props?: Maybe<BlindProps>;
  boat_props?: Maybe<BoatProps>;
  capacity?: Maybe<Scalars['Int']['output']>;
  cover_image: Scalars['URL']['output'];
  created_at: Scalars['Timestamp']['output'];
  description?: Maybe<Scalars['String']['output']>;
  gear_props?: Maybe<GearProps>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Media>>;
  is_single_use?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  outfitter_id: Scalars['String']['output'];
  supports_hourly_availability: Scalars['Boolean']['output'];
  supports_slots: Scalars['Boolean']['output'];
  type: ResourceType;
  updated_at: Scalars['Timestamp']['output'];
  vehicle_props?: Maybe<VehicleProps>;
  year?: Maybe<Scalars['Int']['output']>;
};

export enum ResourceType {
  Atv = 'ATV',
  Blind = 'BLIND',
  Boat = 'BOAT',
  Gear = 'GEAR',
  Listing = 'LISTING',
  Lodging = 'LODGING',
  Outfitter = 'OUTFITTER',
  TeamMember = 'TEAM_MEMBER',
  Vehicle = 'VEHICLE'
}

export type ResourceWithAvailabilitySupport = {
  __typename?: 'ResourceWithAvailabilitySupport';
  cover_image?: Maybe<Scalars['URL']['output']>;
  id: Scalars['ID']['output'];
  is_single_use?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  notes?: Maybe<Array<GenericAvailabilityNote>>;
  supports_hourly_availability: Scalars['Boolean']['output'];
  supports_slots: Scalars['Boolean']['output'];
  type: ResourceType;
};

export type RetryBookingTripInsurancePurchaseInput = {
  booking_id: Scalars['String']['input'];
  payment_method_id: Scalars['String']['input'];
  quote_id?: InputMaybe<Scalars['String']['input']>;
};

export type RetryPaymentInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  payment_method_id: Scalars['String']['input'];
};

export type Review = {
  __typename?: 'Review';
  content: Scalars['String']['output'];
  created_at: Scalars['Timestamp']['output'];
  group_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  is_public: Scalars['Boolean']['output'];
  owner?: Maybe<Scalars['ID']['output']>;
  owner_type: ReviewOwnerType;
  photos: Array<Media>;
  rating: Scalars['PositiveInt']['output'];
  reviewer: User;
  sub_owner?: Maybe<Scalars['ID']['output']>;
  sub_owner_type?: Maybe<ReviewOwnerType>;
  subject?: Maybe<Scalars['ID']['output']>;
  subject_type: ReviewSubjectType;
  updated_at: Scalars['Timestamp']['output'];
};

export type ReviewAggregation = {
  __typename?: 'ReviewAggregation';
  average_rating: Scalars['NonNegativeFloat']['output'];
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_for_sub_owner?: Maybe<Scalars['Boolean']['output']>;
  number_of_reviews: Scalars['NonNegativeInt']['output'];
  owner?: Maybe<Scalars['ID']['output']>;
  owner_type: ReviewOwnerType;
  reviews: Array<Review>;
  subject?: Maybe<Scalars['ID']['output']>;
  subject_type?: Maybe<ReviewSubjectType>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ReviewForm = {
  __typename?: 'ReviewForm';
  id: Scalars['ID']['output'];
  main_subject_type: ReviewSubjectType;
  name: Scalars['String']['output'];
  owner_type: ReviewOwnerType;
  questions: Array<ReviewFormQuestion>;
  sub_owner_type?: Maybe<ReviewOwnerType>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type ReviewFormAnswerInput = {
  answer: CreateReviewInput;
  question_id: Scalars['ID']['input'];
};

export type ReviewFormQuestion = {
  __typename?: 'ReviewFormQuestion';
  id: Scalars['ID']['output'];
  is_question_required: Scalars['Boolean']['output'];
  should_collect_content: Scalars['Boolean']['output'];
  should_collect_photos: Scalars['Boolean']['output'];
  subject_type: ReviewSubjectType;
  subtitle_for_content?: Maybe<Scalars['String']['output']>;
  subtitle_for_photos?: Maybe<Scalars['String']['output']>;
  subtitle_for_rating?: Maybe<Scalars['String']['output']>;
  title_for_content: Scalars['String']['output'];
  title_for_photos: Scalars['String']['output'];
  title_for_rating: Scalars['String']['output'];
};

export type ReviewFormQuestionInput = {
  is_question_required: Scalars['Boolean']['input'];
  should_collect_content: Scalars['Boolean']['input'];
  should_collect_photos: Scalars['Boolean']['input'];
  subject_type: ReviewSubjectType;
  subtitle_for_content?: InputMaybe<Scalars['String']['input']>;
  subtitle_for_photos?: InputMaybe<Scalars['String']['input']>;
  subtitle_for_rating?: InputMaybe<Scalars['String']['input']>;
  title_for_content: Scalars['String']['input'];
  title_for_photos: Scalars['String']['input'];
  title_for_rating: Scalars['String']['input'];
};

export enum ReviewOwnerType {
  Listing = 'LISTING',
  Outfitter = 'OUTFITTER'
}

export enum ReviewSubjectType {
  Booking = 'BOOKING',
  Communication = 'COMMUNICATION',
  Hunt = 'HUNT',
  Listing = 'LISTING',
  Lodging = 'LODGING',
  Outfitter = 'OUTFITTER',
  Value = 'VALUE'
}

export type ReviewsPerScore = {
  __typename?: 'ReviewsPerScore';
  five?: Maybe<Scalars['NonNegativeInt']['output']>;
  four?: Maybe<Scalars['NonNegativeInt']['output']>;
  one?: Maybe<Scalars['NonNegativeInt']['output']>;
  three?: Maybe<Scalars['NonNegativeInt']['output']>;
  two?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type ReviewsPerScoreInput = {
  five?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  four?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  one?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  three?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  two?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type RichTextAiSuggestion = {
  __typename?: 'RichTextAiSuggestion';
  ai_agent: AiAgent;
  created_at: Scalars['Timestamp']['output'];
  has_been_applied: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  suggestion: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type ScheduledClientNotification = {
  __typename?: 'ScheduledClientNotification';
  channel: MessageTemplateChannel;
  created_at: Scalars['Timestamp']['output'];
  custom_message_body?: Maybe<Scalars['String']['output']>;
  custom_message_subject?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['Timestamp']['output']>;
  failure_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
  req_user_id: Scalars['ID']['output'];
  send_at: Scalars['Timestamp']['output'];
  sent_at?: Maybe<Scalars['Timestamp']['output']>;
  status: ScheduledClientNotificationStatus;
  target_client_id?: Maybe<Scalars['ID']['output']>;
  target_client_list_id?: Maybe<Scalars['ID']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export enum ScheduledClientNotificationStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processing = 'PROCESSING',
  Sent = 'SENT'
}

export type ScheduledClientNotificationsInput = {
  outfitter_id: Scalars['ID']['input'];
  paging: Paging;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledClientNotificationsResults = {
  __typename?: 'ScheduledClientNotificationsResults';
  count: Scalars['Int']['output'];
  data: Array<ScheduledClientNotification>;
  pages: Scalars['Int']['output'];
};

export type ScheduledContactNotification = {
  __typename?: 'ScheduledContactNotification';
  channel: MessageTemplateChannel;
  created_at: Scalars['Timestamp']['output'];
  custom_message_body?: Maybe<Scalars['String']['output']>;
  custom_message_subject?: Maybe<Scalars['String']['output']>;
  failed_at?: Maybe<Scalars['Timestamp']['output']>;
  failure_reason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  outfitter_id: Scalars['ID']['output'];
  req_user_id: Scalars['ID']['output'];
  send_at: Scalars['Timestamp']['output'];
  sent_at?: Maybe<Scalars['Timestamp']['output']>;
  status: ScheduledClientNotificationStatus;
  target_contact_id?: Maybe<Scalars['ID']['output']>;
  target_contact_list_id?: Maybe<Scalars['ID']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
};

export type ScheduledContactNotificationsInput = {
  outfitter_id: Scalars['ID']['input'];
  paging: Paging;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledContactNotificationsResults = {
  __typename?: 'ScheduledContactNotificationsResults';
  count: Scalars['Int']['output'];
  data: Array<ScheduledContactNotification>;
  pages: Scalars['Int']['output'];
};

export type ScorecardChartData = {
  __typename?: 'ScorecardChartData';
  delta?: Maybe<Scalars['Float']['output']>;
  delta_change_type?: Maybe<MetricChangeType>;
  delta_label?: Maybe<Scalars['String']['output']>;
  value: Scalars['Float']['output'];
  value_format: ChartValueFormat;
};

/**
 * Registry of product screen identifiers shared by the dashboard and mobile apps.
 * Screens are stable identities independent of routes/URLs; use this to key
 * assistant context, quick suggestions, knowledge contexts, and navigation menu items.
 */
export enum ScreenName {
  AdminBookingInviteRequests = 'ADMIN_BOOKING_INVITE_REQUESTS',
  AutomationCenter = 'AUTOMATION_CENTER',
  Bookings = 'BOOKINGS',
  Calendar = 'CALENDAR',
  Clients = 'CLIENTS',
  Coupons = 'COUPONS',
  EditTemplate = 'EDIT_TEMPLATE',
  Feedback = 'FEEDBACK',
  Forms = 'FORMS',
  General = 'GENERAL',
  Home = 'HOME',
  Integrations = 'INTEGRATIONS',
  Leads = 'LEADS',
  Listings = 'LISTINGS',
  ListingDetail = 'LISTING_DETAIL',
  MyOutfitter = 'MY_OUTFITTER',
  OnboardingTasks = 'ONBOARDING_TASKS',
  QuickPay = 'QUICK_PAY',
  Quotes = 'QUOTES',
  Reporting = 'REPORTING',
  Templates = 'TEMPLATES',
  WebBuilder = 'WEB_BUILDER',
  WebPerformance = 'WEB_PERFORMANCE'
}

export type SearchListingsForSportsmenInput = {
  amenities?: InputMaybe<Array<Scalars['ID']['input']>>;
  badges?: InputMaybe<Array<Scalars['ID']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  hasAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  hasIncludedLodging?: InputMaybe<Scalars['Boolean']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  maxGuest?: InputMaybe<Scalars['PositiveInt']['input']>;
  minGuest?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  priceMax?: InputMaybe<Scalars['PositiveInt']['input']>;
  priceMin?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type SearchMessageTemplateFilters = {
  channel?: InputMaybe<MessageTemplateChannel>;
  is_system_defined?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<MessageTemplateType>;
};

export type SearchOptions = {
  from?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  shouldUseAi?: InputMaybe<Scalars['Boolean']['input']>;
  size?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type SearchOutfittersForSportsmenInput = {
  badges?: InputMaybe<Array<Scalars['ID']['input']>>;
  country?: InputMaybe<Scalars['String']['input']>;
  isFeatured?: InputMaybe<Scalars['Boolean']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OutfitterStatus>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type SearchSpeciesInput = {
  text: Scalars['String']['input'];
};

export enum SelfOnboardingStepType {
  FinishedV2 = 'FINISHED_V2',
  ListingAddOnsV2 = 'LISTING_ADD_ONS_V2',
  ListingAvailabilityV2 = 'LISTING_AVAILABILITY_V2',
  ListingDescriptionV2 = 'LISTING_DESCRIPTION_V2',
  ListingDetailsV2 = 'LISTING_DETAILS_V2',
  ListingLodgingV2 = 'LISTING_LODGING_V2',
  ListingPackagesV2 = 'LISTING_PACKAGES_V2',
  ListingV2 = 'LISTING_V2',
  OutfitterAboutV2 = 'OUTFITTER_ABOUT_V2',
  OutfitterAddressesV2 = 'OUTFITTER_ADDRESSES_V2',
  OutfitterCancellationV2 = 'OUTFITTER_CANCELLATION_V2',
  OutfitterCheckInSettingsV2 = 'OUTFITTER_CHECK_IN_SETTINGS_V2',
  OutfitterInfoV2 = 'OUTFITTER_INFO_V2',
  OutfitterPhotosV2 = 'OUTFITTER_PHOTOS_V2',
  OutfitterV2 = 'OUTFITTER_V2',
  PaymentsDepositSettingsV2 = 'PAYMENTS_DEPOSIT_SETTINGS_V2',
  PaymentsStripeV2 = 'PAYMENTS_STRIPE_V2',
  PaymentsV2 = 'PAYMENTS_V2'
}

export type SendAwardedItemInput = {
  email: Scalars['String']['input'];
};

export type SendClientListMarketingEmailCustomMessageInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendClientListMarketingEmailInput = {
  client_list_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendClientListMarketingEmailCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendClientListMarketingSmsCustomMessageInput = {
  body: Scalars['String']['input'];
};

export type SendClientListMarketingSmsInput = {
  client_list_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendClientListMarketingSmsCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendClientMarketingEmailInput = {
  client_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendClientListMarketingEmailCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendClientMarketingSmsInput = {
  client_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendClientListMarketingSmsCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendContactListMarketingEmailCustomMessageInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendContactListMarketingEmailInput = {
  contact_list_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendContactListMarketingEmailCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendContactListMarketingSmsCustomMessageInput = {
  body: Scalars['String']['input'];
};

export type SendContactListMarketingSmsInput = {
  contact_list_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendContactListMarketingSmsCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendContactMarketingEmailCustomMessageInput = {
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type SendContactMarketingEmailInput = {
  contact_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendContactMarketingEmailCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendContactMarketingSmsCustomMessageInput = {
  body: Scalars['String']['input'];
};

export type SendContactMarketingSmsInput = {
  contact_id: Scalars['ID']['input'];
  custom_message?: InputMaybe<SendContactMarketingSmsCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type SendLogMessage = {
  __typename?: 'SendLogMessage';
  content?: Maybe<Scalars['String']['output']>;
  html?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type SeriesChartData = {
  __typename?: 'SeriesChartData';
  reference_lines?: Maybe<Array<ChartReferenceLine>>;
  series: Array<SeriesChartSeries>;
  show_legend?: Maybe<Scalars['Boolean']['output']>;
  value_format: ChartValueFormat;
  x_axis_label?: Maybe<Scalars['String']['output']>;
  y_axis_label?: Maybe<Scalars['String']['output']>;
};

export type SeriesChartPoint = {
  __typename?: 'SeriesChartPoint';
  label: Scalars['String']['output'];
  timestamp?: Maybe<Scalars['Timestamp']['output']>;
  value: Scalars['Float']['output'];
};

export type SeriesChartSeries = {
  __typename?: 'SeriesChartSeries';
  color?: Maybe<Scalars['String']['output']>;
  is_dashed?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  points: Array<SeriesChartPoint>;
};

export type SetEntityCustomPropertiesResult = {
  __typename?: 'SetEntityCustomPropertiesResult';
  properties: Array<EntityCustomProperty>;
};

export type SlotShare = {
  __typename?: 'SlotShare';
  is_host: Scalars['Boolean']['output'];
  is_invitation_accepted: Scalars['Boolean']['output'];
  member: GroupPayMember;
  payment_plan_type?: Maybe<PaymentPlanType>;
  payments: Array<Payment>;
  slots: Scalars['NonNegativeInt']['output'];
  total: Scalars['Int']['output'];
  trip_insurance?: Maybe<BookingTripInsurance>;
};

export type SmsMarketingConsentInput = {
  consent_text: Scalars['String']['input'];
  consent_type: ConsentType;
  opt_in_date: Scalars['Timestamp']['input'];
  opted_in: Scalars['Boolean']['input'];
  phone_number: Scalars['PhoneNumber']['input'];
  zip_code: Scalars['String']['input'];
};

export type SmsMarketingOptOut = {
  __typename?: 'SmsMarketingOptOut';
  consent_type: ConsentType;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  opt_out_date: Scalars['Timestamp']['output'];
  outfitter_id: Scalars['ID']['output'];
  phone_number: Scalars['PhoneNumber']['output'];
  updated_at: Scalars['Timestamp']['output'];
};

export type Sort = {
  direction: SortDirection;
  field: Scalars['String']['input'];
};

export enum SortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type SourceFormDataField = {
  __typename?: 'SourceFormDataField';
  field_name: Scalars['String']['output'];
  field_value?: Maybe<Scalars['String']['output']>;
};

export type Species = {
  __typename?: 'Species';
  category?: Maybe<SpeciesCategory>;
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  is_archived: Scalars['Boolean']['output'];
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  type: SpeciesType;
  updated_at: Scalars['Timestamp']['output'];
};

export type SpeciesCategory = {
  __typename?: 'SpeciesCategory';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<Media>;
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  name: Scalars['String']['output'];
  species?: Maybe<Array<Species>>;
  updated_at: Scalars['Timestamp']['output'];
};

export type SpeciesCategoryInput = {
  id: Scalars['ID']['input'];
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};

export enum SpeciesType {
  Fishing = 'FISHING',
  Hunting = 'HUNTING'
}

export type StatesAndCountries = {
  __typename?: 'StatesAndCountries';
  countries: Array<Scalars['String']['output']>;
  states: Array<Scalars['String']['output']>;
};

export type StripeAccountInfo = {
  __typename?: 'StripeAccountInfo';
  is_onboarded: Scalars['Boolean']['output'];
  login_link?: Maybe<Scalars['URL']['output']>;
  onboard_link?: Maybe<Scalars['URL']['output']>;
};

export type StripePaymentIntent = {
  __typename?: 'StripePaymentIntent';
  client_secret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type StripePaymentIntentInfo = {
  __typename?: 'StripePaymentIntentInfo';
  client_secret: Scalars['String']['output'];
  intent_id: Scalars['String']['output'];
  payment_method_id: Scalars['String']['output'];
};

export enum StripeRefundReason {
  Duplicate = 'duplicate',
  Fraudulent = 'fraudulent',
  RequestedByCustomer = 'requested_by_customer'
}

export type StripeSetupIntent = {
  __typename?: 'StripeSetupIntent';
  client_secret: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type StripeTerminalInfo = {
  __typename?: 'StripeTerminalInfo';
  location_id: Scalars['String']['output'];
  payment_intent_id: Scalars['String']['output'];
};

export type SubItem = {
  __typename?: 'SubItem';
  details_label?: Maybe<Scalars['String']['output']>;
  details_value?: Maybe<Scalars['String']['output']>;
  display_value?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type SubmitReviewFormInput = {
  answers: Array<ReviewFormAnswerInput>;
  form_id: Scalars['ID']['input'];
  main_subject_id: Scalars['ID']['input'];
};

export enum SubscriptionTier {
  Basics = 'BASICS',
  Custom = 'CUSTOM',
  Elite = 'ELITE',
  Foundations = 'FOUNDATIONS',
  Free = 'FREE',
  Growth = 'GROWTH',
  Legacy = 'LEGACY',
  Lite = 'LITE',
  Pro = 'PRO'
}

export type SyncedCalendar = {
  __typename?: 'SyncedCalendar';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  is_archived: Scalars['Boolean']['output'];
  outfitter_id: Scalars['ID']['output'];
  resources: Array<MinimalResource>;
  should_remove_all_slots: Scalars['Boolean']['output'];
  slots_to_remove: Scalars['NonNegativeInt']['output'];
  source: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
};

export type SyncedCalendarInput = {
  outfitter_id: Scalars['ID']['input'];
  resources: Array<MinimalResourceInput>;
  should_remove_all_slots: Scalars['Boolean']['input'];
  slots_to_remove: Scalars['NonNegativeInt']['input'];
  source: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SyncedCalendarUpdateInput = {
  resources?: InputMaybe<Array<MinimalResourceInput>>;
  should_remove_all_slots?: InputMaybe<Scalars['Boolean']['input']>;
  slots_to_remove?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type SyncedCalendarsResults = {
  __typename?: 'SyncedCalendarsResults';
  count: Scalars['NonNegativeInt']['output'];
  data: Array<SyncedCalendar>;
  pages: Scalars['NonNegativeInt']['output'];
};

export type TableChartData = {
  __typename?: 'TableChartData';
  columns: Array<Scalars['String']['output']>;
  rows: Array<Array<Scalars['String']['output']>>;
};

export type TeamMember = {
  __typename?: 'TeamMember';
  avatar?: Maybe<Scalars['String']['output']>;
  bio?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  email: Scalars['EmailAddress']['output'];
  entity_id: Scalars['ID']['output'];
  entity_type: EntityType;
  id: Scalars['ID']['output'];
  invite_url?: Maybe<Scalars['String']['output']>;
  is_archived: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  role: TeamMemberRole;
  updated_at: Scalars['Timestamp']['output'];
  user?: Maybe<User>;
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export enum TeamMemberRole {
  CoOwner = 'CO_OWNER',
  Guide = 'GUIDE',
  Owner = 'OWNER'
}

export type TemplateVariable = {
  __typename?: 'TemplateVariable';
  name: Scalars['String']['output'];
  template: Scalars['String']['output'];
  type: TemplateVariableType;
};

export enum TemplateVariableType {
  String = 'STRING',
  Url = 'URL'
}

/** Tip/help message */
export type Tip = {
  __typename?: 'Tip';
  action_label?: Maybe<Scalars['String']['output']>;
  action_url?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/** Tips and help section */
export type TipsSection = BaseDashboardSection & {
  __typename?: 'TipsSection';
  id: Scalars['String']['output'];
  order: Scalars['PositiveInt']['output'];
  tips: Array<Tip>;
  title: Scalars['String']['output'];
};

export type Transaction = {
  __typename?: 'Transaction';
  payment_processor_transaction_id: Scalars['ID']['output'];
  payment_processor_type: Scalars['String']['output'];
};

export type TripInsuranceCustomer = {
  __typename?: 'TripInsuranceCustomer';
  postal_code: Scalars['String']['output'];
};

export type TripInsuranceError = {
  __typename?: 'TripInsuranceError';
  date: Scalars['Timestamp']['output'];
  message: Scalars['String']['output'];
};

export type TripInsurancePolicy = {
  __typename?: 'TripInsurancePolicy';
  policy_attributes?: Maybe<TripInsurancePolicyAttribute>;
  policy_holder?: Maybe<TripInsurancePolicyHolder>;
  policy_number: Scalars['String']['output'];
  policy_status: Scalars['String']['output'];
  premium_amount: Scalars['String']['output'];
  quote_id?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['PositiveInt']['output']>;
};

export type TripInsurancePolicyAttribute = {
  __typename?: 'TripInsurancePolicyAttribute';
  event_end_date: Scalars['Timestamp']['output'];
  event_start_date: Scalars['Timestamp']['output'];
  insurable_amount: Scalars['PositiveInt']['output'];
  insurable_amount_currency: Scalars['String']['output'];
};

export type TripInsurancePolicyHolder = {
  __typename?: 'TripInsurancePolicyHolder';
  email_address?: Maybe<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
};

export type TripInsurancePolicyInput = {
  booking_id: Scalars['String']['input'];
  quote_id: Scalars['String']['input'];
  zip_code: Scalars['String']['input'];
};

export type TripInsuranceProduct = {
  __typename?: 'TripInsuranceProduct';
  accept_action_text?: Maybe<Scalars['String']['output']>;
  additional_policy_purchase_email_message?: Maybe<Scalars['String']['output']>;
  carrier_logo_url?: Maybe<Scalars['String']['output']>;
  decline_action_text?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  descriptors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  legal_disclaimer?: Maybe<Scalars['String']['output']>;
  peril_heading?: Maybe<Scalars['String']['output']>;
  perils?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  privacy_policy_url?: Maybe<Scalars['String']['output']>;
  promotional_description?: Maybe<Scalars['String']['output']>;
  promotional_header?: Maybe<Scalars['String']['output']>;
  terms_conditions_url?: Maybe<Scalars['String']['output']>;
};

export type TripInsuranceQuote = TripInsuranceQuoteInterface & {
  __typename?: 'TripInsuranceQuote';
  insurable_amount: Scalars['PositiveInt']['output'];
  policy_attributes: TripInsurancePolicyAttribute;
  product: TripInsuranceProduct;
  quote_id: Scalars['String']['output'];
  taxes_and_fees?: Maybe<Array<TripInsuranceTaxesAndFees>>;
  total: Scalars['PositiveInt']['output'];
};

export type TripInsuranceQuoteInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  event_end_date: Scalars['Timestamp']['input'];
  event_start_date: Scalars['Timestamp']['input'];
  insurable_amount: Scalars['PositiveInt']['input'];
  quote_id?: InputMaybe<Scalars['String']['input']>;
  zip_code: Scalars['String']['input'];
};

export type TripInsuranceQuoteInterface = {
  insurable_amount: Scalars['PositiveInt']['output'];
  policy_attributes: TripInsurancePolicyAttribute;
  product: TripInsuranceProduct;
  quote_id: Scalars['String']['output'];
  taxes_and_fees?: Maybe<Array<TripInsuranceTaxesAndFees>>;
  total: Scalars['PositiveInt']['output'];
};

export type TripInsuranceTaxesAndFees = {
  __typename?: 'TripInsuranceTaxesAndFees';
  amount: Scalars['PositiveInt']['output'];
  description: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type TripItinerary = {
  __typename?: 'TripItinerary';
  items: Array<TripItineraryItem>;
  label?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TripItineraryItem = {
  __typename?: 'TripItineraryItem';
  helper_text?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  timestamp: Scalars['Timestamp']['output'];
  title: Scalars['String']['output'];
  type: TripItineraryItemType;
};

export enum TripItineraryItemType {
  CheckIn = 'CHECK_IN',
  CheckOut = 'CHECK_OUT',
  End = 'END',
  Start = 'START'
}

export type UnreadEntitiesMutationResult = {
  __typename?: 'UnreadEntitiesMutationResult';
  booking?: Maybe<Booking>;
  formSubmission?: Maybe<FormSubmission>;
  lead?: Maybe<Lead>;
  quoteRequest?: Maybe<QuoteRequest>;
};

export type UpdateAddOnInput = {
  applied_tax_definition_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  apply_to_all_listings?: InputMaybe<Scalars['Boolean']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  category_id?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offer_period?: InputMaybe<AddOnOfferPeriod>;
  order?: InputMaybe<Scalars['Int']['input']>;
  price_by_day?: InputMaybe<PriceByDay>;
  price_by_guest?: InputMaybe<PriceByGuest>;
  species?: InputMaybe<Scalars['ID']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateAddOnOptionInput = {
  currency?: InputMaybe<Scalars['String']['input']>;
  deposit_amount?: InputMaybe<Scalars['Float']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  stripe_product_id?: InputMaybe<Scalars['String']['input']>;
  unit_price: Scalars['Float']['input'];
};

export type UpdateAddOnOrderInput = {
  id: Scalars['ID']['input'];
  order: Scalars['Int']['input'];
};

export type UpdateAmenityInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon_url?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateAuctionInput = {
  ends_at?: InputMaybe<Scalars['Timestamp']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_days?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  number_of_guests?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  quantity_requested?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<AuctionStatus>;
};

export type UpdateBookingDatesGuestsAndAddonsInput = {
  dates: Array<Scalars['NonNegativeInt']['input']>;
  groupPayHost?: InputMaybe<UpdateBookingGroupPayMemberInput>;
  groupPayMembers?: InputMaybe<Array<UpdateBookingGroupPayMemberInput>>;
  numberOfGuests: Scalars['NonNegativeInt']['input'];
  /** Minutes from midnight; only valid for hourly packages. */
  startTime?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateBookingGroupPayMemberInput = {
  id: Scalars['ID']['input'];
  slots: Scalars['NonNegativeInt']['input'];
};

export type UpdateBookingInput = {
  attribution?: InputMaybe<AttributionInput>;
  check_in_time?: InputMaybe<Scalars['Timestamp']['input']>;
  check_out_time?: InputMaybe<Scalars['Timestamp']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  dates?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  /** @deprecated end_date is now inferred from dates */
  end_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  guides?: InputMaybe<Array<Scalars['ID']['input']>>;
  items?: InputMaybe<Array<QuoteItemInput>>;
  message_to_outfitter?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  service_fee?: InputMaybe<Scalars['Float']['input']>;
  /** @deprecated start_date is now inferred from dates */
  start_date?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  state_tax?: InputMaybe<Scalars['Float']['input']>;
  sub_total?: InputMaybe<Scalars['Float']['input']>;
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateBookingInviteInput = {
  coupon?: InputMaybe<Scalars['ID']['input']>;
  custom_coupon?: InputMaybe<BookingInviteCustomCouponInput>;
  dates?: InputMaybe<Array<Scalars['Timestamp']['input']>>;
  editable_fields?: InputMaybe<BookingInviteEditableFieldsInput>;
  invoice_note?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  packages?: InputMaybe<Array<BookingInvitePackageInput>>;
  should_allow_external_payment?: InputMaybe<Scalars['Boolean']['input']>;
  sportsman_email?: InputMaybe<Scalars['String']['input']>;
  sportsman_name?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateCalendarEventInput = {
  no_side_effects_properties?: InputMaybe<UpdateCalendarEventNoSideEffectsPropertiesInput>;
  side_effects_properties?: InputMaybe<UpdateCalendarEventSideEffectsPropertiesInput>;
};

export type UpdateCalendarEventNoSideEffectsPropertiesInput = {
  base_color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCalendarEventSideEffectsPropertiesInput = {
  end_date?: InputMaybe<Scalars['Timestamp']['input']>;
  is_single_use_resources?: InputMaybe<Scalars['Boolean']['input']>;
  number_of_guests?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  start_date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UpdateCalendarSubscriptionInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  resources?: InputMaybe<Array<MinimalResourceInput>>;
};

export type UpdateClientInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type UpdateClientListInput = {
  filters?: InputMaybe<Array<ClientListFilterInput>>;
  name: Scalars['String']['input'];
};

export type UpdateContactInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type UpdateContactListInput = {
  filters?: InputMaybe<Array<ContactListFilterInput>>;
  name: Scalars['String']['input'];
};

export type UpdateDefaultAvailabilityRuleInput = {
  date_end?: InputMaybe<Scalars['Timestamp']['input']>;
  date_start?: InputMaybe<Scalars['Timestamp']['input']>;
  day_schedules?: InputMaybe<Array<DefaultAvailabilityRuleDayScheduleInput>>;
  name?: InputMaybe<Scalars['String']['input']>;
  repeats_yearly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateESignCompliantFormSubmissionInput = {
  access_code_id: Scalars['String']['input'];
  agreed_to_e_signature_disclosure?: InputMaybe<Scalars['Boolean']['input']>;
  answers: Array<FormSubmissionAnswerInput>;
};

export type UpdateEventGroupInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  event_compound_ids_input?: InputMaybe<Array<EventCompoundIdInput>>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventOrganizerInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  current_self_onboard_step?: InputMaybe<EventOrganizerSelfOnboardingStepType>;
  documents?: InputMaybe<Array<MediaInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  number_of_members?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  number_of_organized_events?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFixedPriceBookingInput = {
  end_date?: InputMaybe<Scalars['Timestamp']['input']>;
  number_of_guests?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  start_date?: InputMaybe<Scalars['Timestamp']['input']>;
  total?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateFormInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  external_form_url?: InputMaybe<Scalars['String']['input']>;
  form_inputs?: InputMaybe<Array<FormInputInput>>;
  is_published?: InputMaybe<Scalars['Boolean']['input']>;
  is_required?: InputMaybe<Scalars['Boolean']['input']>;
  link_to_booking_configs?: InputMaybe<LinkToBookingConfigsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  should_create_lead_from_submission?: InputMaybe<Scalars['Boolean']['input']>;
  success_redirect_url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFormSubmissionInput = {
  access_code_id: Scalars['String']['input'];
  answers: Array<FormSubmissionAnswerInput>;
};

export type UpdateGroupPayMemberInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
};

export type UpdateKnowledgeArticleInput = {
  access_scope?: InputMaybe<KnowledgeAccessScope>;
  contexts?: InputMaybe<Array<KnowledgeContextInput>>;
  is_public?: InputMaybe<Scalars['Boolean']['input']>;
  product?: InputMaybe<KnowledgeProduct>;
  sections?: InputMaybe<Array<KnowledgeSectionInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLeadInput = {
  disqualification?: InputMaybe<DisqualificationInput>;
  note?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<LeadQuality>;
  referral_source?: InputMaybe<ReferralSource>;
  schedule_new_lead_at?: InputMaybe<Scalars['Timestamp']['input']>;
  status?: InputMaybe<LeadStatus>;
};

export type UpdateLeadsResult = {
  __typename?: 'UpdateLeadsResult';
  data: Array<Lead>;
};

export type UpdateLicenseInfoInput = {
  country?: InputMaybe<Scalars['String']['input']>;
  fishing_info_url?: InputMaybe<Scalars['String']['input']>;
  general_info_url?: InputMaybe<Scalars['String']['input']>;
  hunting_info_url?: InputMaybe<Scalars['String']['input']>;
  online_portal_url?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateListingInput = {
  admin_note?: InputMaybe<Scalars['String']['input']>;
  amenities?: InputMaybe<Array<Scalars['ID']['input']>>;
  booking_instructions?: InputMaybe<Scalars['String']['input']>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  deposit_percentage?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<ListingDuration>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  gear_list?: InputMaybe<Scalars['String']['input']>;
  guides?: InputMaybe<Array<Scalars['ID']['input']>>;
  is_hidden_from_marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  license_info?: InputMaybe<Scalars['ID']['input']>;
  license_required?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging?: InputMaybe<Scalars['ID']['input']>;
  max_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  meeting_location?: InputMaybe<AddressInput>;
  min_guest?: InputMaybe<Scalars['PositiveInt']['input']>;
  order?: InputMaybe<Scalars['PositiveInt']['input']>;
  photos?: InputMaybe<Array<MediaInput>>;
  pricing?: InputMaybe<PricingInput>;
  pricing_packages?: InputMaybe<Array<Scalars['ID']['input']>>;
  published?: InputMaybe<Scalars['Boolean']['input']>;
  rule?: InputMaybe<Scalars['String']['input']>;
  should_allow_quote_requests?: InputMaybe<Scalars['Boolean']['input']>;
  species?: InputMaybe<Array<Scalars['ID']['input']>>;
  time_of_day?: InputMaybe<ListingTimeOfDay>;
  time_zone?: InputMaybe<Scalars['TimeZone']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ListingType>;
};

export type UpdateListingNoteInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['Timestamp']['input']>;
};

export type UpdateListingRatesAsOwnerInput = {
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateListingRatesInput = {
  booking_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  booking_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateLodgingInput = {
  capacity?: InputMaybe<Scalars['PositiveInt']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<LodgingType>;
};

export type UpdateMessageTemplateInput = {
  editor_data?: InputMaybe<Scalars['JSONObject']['input']>;
  email?: InputMaybe<MessageTemplateEmailContentInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  sms?: InputMaybe<MessageTemplateSmsContentInput>;
};

export type UpdateMetaAdInput = {
  id: Scalars['ID']['input'];
  status: MetaAdStatus;
};

export type UpdateMetaAdResult = {
  __typename?: 'UpdateMetaAdResult';
  ad: MetaAd;
};

export type UpdateNoteInput = {
  content: Scalars['String']['input'];
  media?: InputMaybe<Array<MediaInput>>;
};

export type UpdateOnboardingInput = {
  add_ons: Array<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  outfitter_name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  products: Array<Scalars['String']['input']>;
  promo_codes: Array<Scalars['String']['input']>;
  should_send_pay_link?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOutfitterAutomationSettingInput = {
  is_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  offset_days_config?: InputMaybe<OffsetDaysConfigInput>;
  template_updates?: InputMaybe<Array<AutomationTemplateUpdateInput>>;
};

export type UpdateOutfitterDocumentInput = {
  document?: InputMaybe<MediaInput>;
  external_url?: InputMaybe<Scalars['String']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  pricing_package_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<OutfitterDocumentType>;
};

export type UpdateOutfitterFeesAsOutfitterOwnerInput = {
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOutfitterFeesInput = {
  booking_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  booking_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  max_booking_fee?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  outfitter_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_ach_max?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  processing_fee_ach_rate?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_fixed?: InputMaybe<Scalars['Float']['input']>;
  processing_fee_rate?: InputMaybe<Scalars['Float']['input']>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateOutfitterInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  admin_note?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<MediaInput>;
  cancellation_policy?: InputMaybe<OutfitterCancellationPolicyInput>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  default_check_in_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  default_check_out_minutes?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  faqs?: InputMaybe<Array<FaqItemInput>>;
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  gmb_id?: InputMaybe<Scalars['String']['input']>;
  hubspot_company_id?: InputMaybe<Scalars['String']['input']>;
  is_guide_tech?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_marketplace?: InputMaybe<Scalars['Boolean']['input']>;
  is_onboarding_flow_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_self_onboard_skipped?: InputMaybe<Scalars['Boolean']['input']>;
  is_website_chat_widget_enabled?: InputMaybe<Scalars['Boolean']['input']>;
  land_size?: InputMaybe<Scalars['PositiveInt']['input']>;
  licensed?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<AddressInput>;
  lodging_instructions?: InputMaybe<Scalars['String']['input']>;
  lodging_rules?: InputMaybe<Scalars['String']['input']>;
  mailing_address?: InputMaybe<AddressInput>;
  meeting_location?: InputMaybe<AddressInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  other_info?: InputMaybe<OutfitterOtherInfoInput>;
  photos?: InputMaybe<Array<MediaInput>>;
  primary_contact_email?: InputMaybe<Scalars['EmailAddress']['input']>;
  primary_contact_phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  status?: InputMaybe<OutfitterStatus>;
  tax_definitions?: InputMaybe<Array<OutfitterTaxDefinitionInput>>;
  tax_rate?: InputMaybe<Scalars['Float']['input']>;
  time_zone?: InputMaybe<Scalars['String']['input']>;
  verified?: InputMaybe<Scalars['Boolean']['input']>;
  video?: InputMaybe<VideoInput>;
  website?: InputMaybe<Scalars['String']['input']>;
  years_in_operation?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type UpdateOutfitterRoleNotificationSettingsInput = {
  enabled_notification_topics: Array<NotificationTopic>;
  role: TeamMemberRole;
};

export type UpdateOutfitterSubscriptionInput = {
  add_ons: Array<Scalars['String']['input']>;
  outfitter_id: Scalars['String']['input'];
  products: Array<Scalars['String']['input']>;
  promo_codes: Array<Scalars['String']['input']>;
};

export type UpdatePackageOnQuoteInput = {
  add_ons?: InputMaybe<Array<QuoteAddOnInput>>;
  number_of_guests: Scalars['PositiveInt']['input'];
};

export type UpdatePaymentInput = {
  customer?: InputMaybe<PaymentCustomerInput>;
  is_processing_fee_payed_by_sportsman?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePricingPackageInput = {
  applied_tax_definition_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  check_in_config?: InputMaybe<CheckInConfigInput>;
  days_included?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  duration_minutes?: InputMaybe<Scalars['PositiveInt']['input']>;
  gear_rentals?: InputMaybe<Array<Scalars['ID']['input']>>;
  guests_included?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  included_lodging_id?: InputMaybe<Scalars['ID']['input']>;
  included_resource_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_outfitters?: InputMaybe<Scalars['Boolean']['input']>;
  is_hidden_from_sportsmen?: InputMaybe<Scalars['Boolean']['input']>;
  is_lodging_only?: InputMaybe<Scalars['Boolean']['input']>;
  lodging_included?: InputMaybe<Scalars['Boolean']['input']>;
  max_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  meal_upgrades?: InputMaybe<Array<Scalars['ID']['input']>>;
  min_guests?: InputMaybe<Scalars['PositiveInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  other_add_ons?: InputMaybe<Array<Scalars['ID']['input']>>;
  price?: InputMaybe<Scalars['Float']['input']>;
  price_by_day?: InputMaybe<PriceByDay>;
  price_by_guest?: InputMaybe<PriceByGuest>;
  start_times?: InputMaybe<Array<Scalars['NonNegativeInt']['input']>>;
  trophies?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateResourceInput = {
  atv_props?: InputMaybe<AtvInput>;
  blind_props?: InputMaybe<BlindInput>;
  boat_props?: InputMaybe<BoatInput>;
  capacity?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  gear_props?: InputMaybe<GearInput>;
  images?: InputMaybe<Array<MediaInput>>;
  is_single_use?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  vehicle_props?: InputMaybe<VehicleInput>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateReviewFormInput = {
  main_subject_type?: InputMaybe<ReviewSubjectType>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner_type?: InputMaybe<ReviewOwnerType>;
  questions?: InputMaybe<Array<ReviewFormQuestionInput>>;
  sub_owner_type?: InputMaybe<ReviewOwnerType>;
  subtitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduledClientNotificationInput = {
  client_id?: InputMaybe<Scalars['ID']['input']>;
  client_list_id?: InputMaybe<Scalars['ID']['input']>;
  custom_message?: InputMaybe<SendClientListMarketingEmailCustomMessageInput>;
  send_at?: InputMaybe<Scalars['Timestamp']['input']>;
  template_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpeciesCategoryInput = {
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSpeciesInput = {
  category?: InputMaybe<SpeciesCategoryInput>;
  image?: InputMaybe<MediaInput>;
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<SpeciesType>;
};

export type UpdateTeamMemberInput = {
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TeamMemberRole>;
};

export type UpdateTransactionInput = {
  payment_processor_transaction_id?: InputMaybe<Scalars['ID']['input']>;
  payment_processor_type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  avatar_url?: InputMaybe<Scalars['String']['input']>;
  bio?: InputMaybe<Scalars['String']['input']>;
  date_of_birth?: InputMaybe<Scalars['PositiveInt']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  favorite_game?: InputMaybe<Array<Scalars['String']['input']>>;
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  socials?: InputMaybe<UserSocialsInput>;
  years_of_experience?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type UpdateUserNotificationPreferencesInput = {
  notification_settings: Array<NotificationSettingInput>;
};

export type UpdateWebsiteInput = {
  editor_data?: InputMaybe<Scalars['JSONObject']['input']>;
  favicon?: InputMaybe<Scalars['String']['input']>;
  fonts?: InputMaybe<Array<WebsiteFontInput>>;
  pages?: InputMaybe<Array<WebsitePageInput>>;
  scripts?: InputMaybe<Array<WebsiteScriptInput>>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWidgetInput = {
  button_color?: InputMaybe<Scalars['String']['input']>;
  button_text?: InputMaybe<Scalars['String']['input']>;
  google_analytics_id?: InputMaybe<Scalars['String']['input']>;
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  is_external?: InputMaybe<Scalars['Boolean']['input']>;
  listing_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  pixel_id?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  text_color?: InputMaybe<Scalars['String']['input']>;
  trigger_type?: InputMaybe<WidgetTriggerType>;
  widget_name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWishlistInput = {
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  listings?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertOutfitterIntegrationSettingsInput = {
  quick_books?: InputMaybe<UpsertQuickBooksSettingsInput>;
};

export type UpsertPaymentFeeSettingsInput = {
  dashboard_rate: Scalars['NonNegativeFloat']['input'];
  entity_id: Scalars['ID']['input'];
  entity_type: PaymentFeeSettingsEntityType;
  id?: InputMaybe<Scalars['ID']['input']>;
  marketplace_quote_rate: Scalars['NonNegativeFloat']['input'];
  standard_quote_rate: Scalars['NonNegativeFloat']['input'];
  website_rate: Scalars['NonNegativeFloat']['input'];
  widget_rate: Scalars['NonNegativeFloat']['input'];
};

export type UpsertPaymentSettingsInput = {
  allow_deposit?: InputMaybe<Scalars['Boolean']['input']>;
  amount_deposit?: InputMaybe<Scalars['Int']['input']>;
  day_balance_due_config?: InputMaybe<DayBalanceDueConfigInput>;
  days_before_trip_balance_due?: InputMaybe<Scalars['Int']['input']>;
  days_out_for_deposit_plan?: InputMaybe<Scalars['Int']['input']>;
  entity_id: Scalars['ID']['input'];
  entity_type: PaymentSettingsEntityType;
  id?: InputMaybe<Scalars['ID']['input']>;
  is_deposit_per_day?: InputMaybe<Scalars['Boolean']['input']>;
  is_deposit_per_guest?: InputMaybe<Scalars['Boolean']['input']>;
  percent_deposit?: InputMaybe<Scalars['Int']['input']>;
  should_charge_last_day_of_trip?: InputMaybe<Scalars['Boolean']['input']>;
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertQuickBooksSettingsInput = {
  default_product_service_id?: InputMaybe<Scalars['String']['input']>;
  deposit_account_id?: InputMaybe<Scalars['String']['input']>;
  invoice_date?: InputMaybe<QuickBooksInvoiceDateSetting>;
};

/** A type that describes a user */
export type User = {
  __typename?: 'User';
  avatar_url?: Maybe<Scalars['URL']['output']>;
  bio: Scalars['String']['output'];
  bookings: Array<Booking>;
  created_at: Scalars['Timestamp']['output'];
  date_of_birth?: Maybe<Scalars['Timestamp']['output']>;
  email: Scalars['EmailAddress']['output'];
  favorite_game: Array<Scalars['String']['output']>;
  first_name?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  impersonation_details?: Maybe<ImpersonationDetails>;
  is_admin?: Maybe<Scalars['Boolean']['output']>;
  is_deleted?: Maybe<Scalars['Boolean']['output']>;
  is_developer?: Maybe<Scalars['Boolean']['output']>;
  is_guest?: Maybe<Scalars['Boolean']['output']>;
  is_guest_conversion_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_owner?: Maybe<Scalars['Boolean']['output']>;
  is_team_member?: Maybe<Scalars['Boolean']['output']>;
  last_name?: Maybe<Scalars['String']['output']>;
  location: Scalars['String']['output'];
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  settings?: Maybe<UserSetting>;
  socials?: Maybe<UserSocials>;
  stripe_connected_account_id?: Maybe<Scalars['String']['output']>;
  stripe_user_id?: Maybe<Scalars['String']['output']>;
  updated_at: Scalars['Timestamp']['output'];
  years_of_experience?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type UserMetadata = {
  __typename?: 'UserMetadata';
  email?: Maybe<Scalars['String']['output']>;
  email_verified?: Maybe<Scalars['Boolean']['output']>;
  family_name?: Maybe<Scalars['String']['output']>;
  given_name?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  phone_verified?: Maybe<Scalars['Boolean']['output']>;
  picture?: Maybe<Scalars['String']['output']>;
};

export type UserNotificationPreferenceCatalog = {
  __typename?: 'UserNotificationPreferenceCatalog';
  topics: Array<UserNotificationPreferenceCatalogTopic>;
};

export type UserNotificationPreferenceCatalogTopic = {
  __typename?: 'UserNotificationPreferenceCatalogTopic';
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  supported_channels: Array<UserNotificationPreferenceChannel>;
  topic: NotificationTopic;
};

export enum UserNotificationPreferenceChannel {
  Email = 'email',
  Inbox = 'inbox',
  Push = 'push',
  Sms = 'sms'
}

export type UserNotificationPreferences = {
  __typename?: 'UserNotificationPreferences';
  catalog: UserNotificationPreferenceCatalog;
  context_entity_id: Scalars['ID']['output'];
  context_entity_type: NotificationPreferencesEntityType;
  notification_settings: Array<UserNotificationSetting>;
  user_id: Scalars['ID']['output'];
};

export type UserNotificationSetting = {
  __typename?: 'UserNotificationSetting';
  channels: Array<UserNotificationPreferenceChannel>;
  topic: NotificationTopic;
};

export type UserSetting = {
  __typename?: 'UserSetting';
  push_notifications?: Maybe<Scalars['Boolean']['output']>;
  theme: Scalars['String']['output'];
};

export type UserSocials = {
  __typename?: 'UserSocials';
  facebook: Scalars['String']['output'];
  instagram: Scalars['String']['output'];
  twitter: Scalars['String']['output'];
};

export type UserSocialsInput = {
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
};

export type UserTrackingData = {
  __typename?: 'UserTrackingData';
  props: Array<UserTrackingProp>;
};

export type UserTrackingProp = {
  __typename?: 'UserTrackingProp';
  boolean_value?: Maybe<Scalars['Boolean']['output']>;
  number_value?: Maybe<Scalars['Int']['output']>;
  prop: Scalars['String']['output'];
  string_value?: Maybe<Scalars['String']['output']>;
  value_prop_name: Scalars['String']['output'];
};

export type UsersSearchResults = {
  __typename?: 'UsersSearchResults';
  pages: Scalars['NonNegativeInt']['output'];
  results: Array<User>;
  total: Scalars['NonNegativeInt']['output'];
};

export type ValueChange = {
  __typename?: 'ValueChange';
  label: Scalars['String']['output'];
  new_value: Scalars['String']['output'];
  previous_value: Scalars['String']['output'];
};

export enum VehicleCategory {
  Coupe = 'COUPE',
  Jeep = 'JEEP',
  Minivan = 'MINIVAN',
  Sedan = 'SEDAN',
  SideBySide = 'SIDE_BY_SIDE',
  Suv = 'SUV',
  Truck = 'TRUCK'
}

export type VehicleInput = {
  category: VehicleCategory;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleProps = {
  __typename?: 'VehicleProps';
  category: VehicleCategory;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type Video = {
  __typename?: 'Video';
  hosted?: Maybe<Media>;
  social?: Maybe<Media>;
};

export type VideoInput = {
  hosted?: InputMaybe<MediaInput>;
  social?: InputMaybe<MediaInput>;
};

export type Website = {
  __typename?: 'Website';
  created_at: Scalars['Timestamp']['output'];
  editor_data?: Maybe<Scalars['JSONObject']['output']>;
  favicon?: Maybe<Scalars['String']['output']>;
  fonts: Array<WebsiteFont>;
  id: Scalars['ID']['output'];
  is_deployed: Scalars['Boolean']['output'];
  outfitter_id: Scalars['ID']['output'];
  pages: Array<WebsitePage>;
  scripts: Array<WebsiteScript>;
  updated_at: Scalars['Timestamp']['output'];
  url: Scalars['String']['output'];
};

export type WebsiteFont = {
  __typename?: 'WebsiteFont';
  font_family: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type WebsiteFontInput = {
  font_family: Scalars['String']['input'];
  name: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type WebsiteMetaTag = {
  __typename?: 'WebsiteMetaTag';
  content: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  property?: Maybe<Scalars['String']['output']>;
};

export type WebsiteMetaTagInput = {
  content: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  property?: InputMaybe<Scalars['String']['input']>;
};

export type WebsitePage = {
  __typename?: 'WebsitePage';
  css: Scalars['String']['output'];
  html: Scalars['String']['output'];
  js: Scalars['String']['output'];
  meta_tags?: Maybe<Array<WebsiteMetaTag>>;
  slug?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type WebsitePageInput = {
  css: Scalars['String']['input'];
  html: Scalars['String']['input'];
  js: Scalars['String']['input'];
  meta_tags?: InputMaybe<Array<WebsiteMetaTagInput>>;
  slug?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type WebsiteScript = {
  __typename?: 'WebsiteScript';
  placement: WebsiteScriptPlacement;
  script: Scalars['String']['output'];
};

export type WebsiteScriptInput = {
  placement: WebsiteScriptPlacement;
  script: Scalars['String']['input'];
};

export enum WebsiteScriptPlacement {
  Head = 'HEAD'
}

/** A type that describes a widget */
export type Widget = {
  __typename?: 'Widget';
  button_color?: Maybe<Scalars['String']['output']>;
  button_text?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['Timestamp']['output'];
  google_analytics_id?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  is_active: Scalars['Boolean']['output'];
  is_external: Scalars['Boolean']['output'];
  listing_ids?: Maybe<Array<Scalars['ID']['output']>>;
  outfitter: Outfitter;
  pixel_id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  text_color?: Maybe<Scalars['String']['output']>;
  trigger_type: WidgetTriggerType;
  updated_at: Scalars['Timestamp']['output'];
  widget_name: Scalars['String']['output'];
};

export enum WidgetTriggerType {
  Button = 'BUTTON',
  Inline = 'INLINE',
  Modal = 'MODAL',
  Tab = 'TAB'
}

/** A type that describes a wishlist */
export type Wishlist = {
  __typename?: 'Wishlist';
  created_at: Scalars['Timestamp']['output'];
  id: Scalars['ID']['output'];
  isPrivate: Scalars['Boolean']['output'];
  listings: Array<Listing>;
  name: Scalars['String']['output'];
  updated_at: Scalars['Timestamp']['output'];
  user: User;
};
